<template>
  <div v-if="isMobile !== null">
    <!-- v-if="isMobile!=null"> -->
    <!-- :style="{ 'background-image': 'url(' + backgroundImage + ')' }" -->
    <section class="relative isolate w-full overflow-hidden py-1 md:py-4 border-b border-slate-700/60 bg-[#061a33] text-white">
      <div class="absolute inset-0 bg-[radial-gradient(circle_at_6%_-12%,rgba(14,116,144,.34),transparent_32%),radial-gradient(circle_at_87%_22%,rgba(251,191,36,.13),transparent_28%),linear-gradient(112deg,#061a33_0%,#0a2c56_57%,#07192e_100%)]"></div>
      <div class="absolute inset-y-0 right-0 hidden w-[48%] bg-[linear-gradient(120deg,transparent_0%,rgba(255,255,255,.035)_48%,transparent_49%)] md:block"></div>
      <div class="absolute -bottom-20 left-[29%] h-48 w-[39rem] -rotate-6 rounded-full border border-white/[.08]"></div>
      <NuxtImg
        src="/assets/img/hero/umrah-haramayn-hero-v2-1200.png"
        alt=""
        aria-hidden="true"
        width="1200"
        height="600"
        format="webp"
        quality="78"
        loading="lazy"
        decoding="async"
        class="umrah-hero-art pointer-events-none absolute bottom-0 right-0 hidden h-[14rem] w-auto max-w-[54vw] object-contain object-right opacity-95 drop-shadow-[0_18px_24px_rgba(0,0,0,.25)] md:block"
      />
      <div class="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-300/90 to-transparent"></div>

      <div v-if="pageData" class="relative mx-auto max-w-screen-xl px-4 py-2 sm:px-6 md:py-3 lg:px-10">
        <div class="flex items-center justify-between gap-3">
          <ol class="flex min-w-0 flex-wrap items-center gap-y-1 text-[11px] font-medium text-slate-300/90" aria-label="Breadcrumb">
            <li class="inline-flex items-center">
              <a class="rounded-md py-1 transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-300/60" @click.prevent.stop="goPath('/')" :href="getPath('/')">{{$t('Anasayfa')}}</a>
              <span class="mx-2 text-amber-300/50" aria-hidden="true">/</span>
            </li>
            <li class="inline-flex items-center">
              <a :href="getPath('/tour/umre-turlari')" @click.stop.prevent="goPath('/tour/umre-turlari')" class="rounded-md py-1 transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-300/60">{{$t('Turlar')}}</a>
              <span class="mx-2 text-amber-300/50" aria-hidden="true">/</span>
            </li>
            <li class="max-w-[11rem] truncate text-slate-100 sm:max-w-md" aria-current="page" v-html="seoLandingContent?.breadcrumb || pageData?.SA_Baslik"></li>
          </ol>

          <div v-if="(!isMobile || !(user && user?.U_Admin === 'on'))" class="flex shrink-0 items-center gap-1.5 rounded-xl border border-white/15 bg-slate-950/20 p-1.5 shadow-lg shadow-slate-950/20 backdrop-blur-md">
            <a key="whatsappbutton" :aria-label="$t('WhatsApp')" :title="$t('WhatsApp')" :href="buildWhatsAppUrl('Merhaba turlarınız hakkında bilgi almak istiyorum.')" target="_blank" rel="nofollow noopener noreferrer" class="whatsappTrigger inline-flex h-8 items-center justify-center gap-1.5 rounded-lg bg-emerald-500 px-2.5 text-white transition hover:bg-emerald-400 hover:shadow-lg hover:shadow-emerald-500/25 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80">
              <font-awesome-icon icon="fa-brands fa-whatsapp" class="h-4 w-4" />
              <span class="hidden text-[11px] font-bold sm:inline">WhatsApp</span>
            </a>
            <a key="phonebutton" :aria-label="$t('Telefon')" :title="$t('Telefon')" href="tel:908502414141" class="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-white/15 bg-white/10 text-white transition hover:bg-white/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80">
              <font-awesome-icon icon="fa-solid fa-phone" class="h-3.5 w-3.5" />
            </a>
          </div>
        </div>

        <div class="mt-1 md:mt-3 max-w-[41rem] border-l-2 border-amber-300/75 pl-4 sm:pl-5">
          <div class="min-w-0">
            <div class="mb-2 inline-flex items-center gap-2 rounded-full border border-amber-200/25 bg-amber-300/10 px-2.5 py-1 text-[9px] font-extrabold uppercase tracking-[.16em] text-amber-200">
              <span class="relative flex h-1.5 w-1.5"><span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-300 opacity-75"></span><span class="relative inline-flex h-1.5 w-1.5 rounded-full bg-amber-300"></span></span>
              {{$t('Umre Turları')}}
            </div>
            <h1 v-if="seoLandingContent?.h1 || pageData?.SA_Baslik" class="m-0 text-2xl font-black leading-[1.08] tracking-[-.035em] text-white sm:text-3xl lg:text-[2.3rem]" v-html="seoLandingContent?.h1 || pageData.SA_Baslik"></h1>
            <p v-if="heroSupportingCopy" class="relative mb-0 mt-2 max-w-xl pr-2 text-[13px] leading-5 text-slate-200/90 line-clamp-2">
              <span>{{ heroSupportingCopy }}</span>
              <span aria-hidden="true" class="absolute -bottom-1 left-0 h-px w-12 bg-gradient-to-r from-amber-300/80 to-transparent motion-safe:animate-pulse"></span>
            </p>
          </div>

          <div class="mt-2.5 flex flex-wrap gap-1.5 text-[10px] font-semibold text-slate-100">
            <span class="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/[.07] px-2.5 py-1"><font-awesome-icon icon="fa-solid fa-hotel" class="h-3 w-3 text-amber-300" />{{$t('5 yıldızlı oteller')}}</span>
            <span class="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/[.07] px-2.5 py-1"><font-awesome-icon icon="fa-solid fa-train" class="h-3 w-3 text-amber-300" />{{$t('Hızlı Tren')}}</span>
            <span class="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/[.07] px-2.5 py-1"><font-awesome-icon icon="fa-solid fa-circle-check" class="h-3 w-3 text-amber-300" />{{$t('İrşad & rehberlik')}}</span>
          </div>
        </div>
      </div>
    </section>

    <section v-if="umrahDurationDays !== 3" class="max-w-screen-xl bg-white sm:mx-auto px-0 sm:px-6 lg:px-10 py-0 sm:py-0 overflow-visible">
      <div class="w-full h-full flex flex-wrap-reverse md:grid md:grid-cols-[300px_minmax(0,1fr)] md:gap-6 md:mt-2 overflow-visible">
        <div
          v-if="sidebarStickyActive"
          class="hidden md:block md:col-start-1 md:row-start-1 w-[300px]"
          aria-hidden="true"
        ></div>
        <aside
          ref="desktopSidebarRef"
          class="w-full md:w-[300px] md:max-w-[340px] md:col-start-1 md:row-start-1 shrink-0 mt-0 md:self-start md:h-fit pr-0 rounded-xl"
          :class="sidebarStickyActive ? 'fixed z-40 max-h-[calc(100vh-120px)] overflow-y-auto rounded-b-2xl bg-white/95 shadow-2xl ring-1 ring-slate-200 backdrop-blur' : 'overflow-visible'"
          :style="sidebarStickyStyle"
        >
         
        <ClientOnly>
        <div v-if="banners.length" class="hidden md:block">
          <Carousel class="carousel-pagination-top h-[188px] m-0 py-0 lg:px-0 px-2" :itemsToShow="1" :wrapAround="false" :transition="500">
              <Slide v-for="item in banners" :key="item.heading?.tr || item.temp" class="swiper-slide w-full group">
                <article
                  :class="`relative h-full w-full overflow-hidden rounded-2xl border border-white/20 bg-gradient-to-br from-brand-900 via-brand-800 to-brand-900 p-4 shadow-xl ${item.color || ''}`"
                  role="group"
                  aria-label="umre kampanya banner"
                >
                  <div class="absolute -right-10 -top-10 h-36 w-36 rounded-full bg-accent-500/20 blur-2xl"></div>
                  <div class="absolute -bottom-12 left-8 h-36 w-36 rounded-full bg-support-600/20 blur-2xl"></div>

                  <template v-if="item.image">
                    <NuxtImg
                      :src="item.image"
                      :alt="item.heading?.[locale] || `${currentSeoYear} umre turları`"
                      class="absolute inset-0 h-full w-full object-cover opacity-20"
                      :loading="'lazy'"
                    />
                  </template>

                  <div class="relative z-10 flex h-full flex-col justify-center">
                    <div>
                      <div class="mb-2 inline-flex items-center rounded-full border border-white/25 bg-white/10 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-neutral-100">
                        Umre Turları {{ currentSeoYear }}
                      </div>

                      <template v-if="item.heading">
                        <h3 class="text-lg md:text-xl font-bold leading-tight text-white my-0" v-html="item.heading?.[locale]"></h3>
                        <p v-if="item.text?.[locale]" class="my-1 text-xs md:text-sm text-neutral-100/90 line-clamp-2" v-html="item.text?.[locale]"></p>
                      </template>

                      <template v-else-if="item.temp == '1'">
                        <h3 class="text-lg md:text-xl font-bold leading-tight text-white my-0">
                          {{ $t('Umre Tur ve Fiyatları') }}
                        </h3>
                        <p class="my-1 text-xs md:text-xs text-neutral-100/90">
                          {{ $t('En iyi ve yakın otellerde konaklama, THY ile konforlu uçuş ve güçlü rehberlik hizmetleriyle premium umre deneyimi.') }}
                        </p>
                      </template>
                    </div>

                  </div>
                </article>
              </Slide>
            <template #addons>
              <Navigation>
                <template #prev>
                  <span class="inline-flex h-8 w-8 items-center justify-center rounded-full border border-white/30 bg-white/85 text-brand-900 shadow-sm transition-colors hover:bg-white">
                    <font-awesome-icon icon="fa-solid fa-chevron-left" class="h-3 w-3" />
                  </span>
                </template>
                <template #next>
                  <span class="inline-flex h-8 w-8 items-center justify-center rounded-full border border-white/30 bg-white/85 text-brand-900 shadow-sm transition-colors hover:bg-white">
                    <font-awesome-icon icon="fa-solid fa-chevron-right" class="h-3 w-3" />
                  </span>
                </template>
              </Navigation>
            </template>
          </Carousel>
        </div>
        </ClientOnly>

        <div  
          class="px-4 mb-3 rounded-lg p-4 mt-3 text-sm border rounded-md border-l-sky-600 border-l-4"  
          :class="shouldHideSidebarInfoCards ? 'hidden':''"
          v-if="pageData && pageData.SA_Subtitle && !isPrimaryUmrahLanding"
        >
          <span v-html="decodeHTMLEntities(pageData.SA_Subtitle)"></span>
        </div>

        <div v-if="!isMobile"
        class="hidden md:block mb-3 mt-1 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition-[box-shadow,transform] duration-200"
        :class="shouldHideSidebarInfoCards ? 'mt-3' : ''">
          <div class="flex items-center justify-between mb-2">
            <div class="flex items-center gap-2">
              <span class="flex h-7 w-7 items-center justify-center rounded-full bg-amber-100 text-amber-700">
                <font-awesome-icon icon="fa-solid fa-bed" class="h-3.5 w-3.5" />
              </span>
              <div>
                <p class="mb-0 leading-3 text-sm font-semibold text-slate-800">{{$t('Oda Seçimi')}}</p>
                <p v-if="sidebarRoomEditorOpen" class="mb-0 text-[11px] leading-3  text-slate-400">{{$t('Kişi ve çocuk bilgilerini girin')}}</p>
              </div>
            </div>
            <div class="flex items-center gap-2">
              <button
                v-if="sidebarStickyActive"
                type="button"
                @click="toggleStickyRoomCard"
                class="flex items-center gap-1 rounded-md bg-slate-100 px-2 py-1 text-[11px] font-semibold text-slate-600 hover:bg-slate-200"
                :aria-expanded="!sidebarStickyMinimized"
              >
                <font-awesome-icon :icon="sidebarStickyMinimized ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up'" class="h-2.5 w-2.5" />
                {{ sidebarStickyMinimized ? $t('Genişlet') : $t('Küçült') }}
              </button>
              <button
                v-if="roomCardContentVisible && sidebarRoomEditorOpen"
                type="button"
                @click="resetSearchFilters"
                class="text-[11px] font-semibold text-slate-500 hover:text-slate-700"
              >
                {{$t('Sıfırla')}}
              </button>
              <button
                v-else-if="roomCardContentVisible"
                type="button"
                @click="sidebarRoomEditorOpen = true"
                class="flex items-center gap-1 text-[11px] font-semibold text-brand-600 hover:text-brand-800"
              >
                <font-awesome-icon icon="fa-solid fa-pen" class="h-2.5 w-2.5" />
                {{$t('Düzenle')}}
              </button>
            </div>
          </div>

          <div v-show="roomCardContentVisible">
          <!-- Özet görünüm (kapalıyken) -->
          <div v-if="!sidebarRoomEditorOpen" class="rounded-xl border border-slate-100 bg-slate-50/60 p-3">
            <div class="flex items-center gap-2 text-xs font-semibold text-slate-700 mb-2">
              <font-awesome-icon icon="fa-solid fa-users" class="h-3 w-3 text-slate-500" />
              {{ previewPeopleLabel }}
            </div>
            <div class="flex flex-wrap gap-1.5">
              <span
                v-for="(room, key) in reservation.rooms"
                :key="`summary_room_${key}`"
                class="inline-flex items-center gap-1 rounded-md bg-white border border-slate-200 px-2 py-1 text-[11px] text-slate-600"
              >
                <font-awesome-icon icon="fa-solid fa-door-open" class="h-2.5 w-2.5 text-slate-400" />
                {{ key + 1 }}. {{$t('Oda')}}:
                {{ room.adult }} {{$t('Yetişkin')}}
                <template v-if="room.child > 0">, {{ room.child }} {{$t('Çocuk')}}</template>
                <template v-if="room.baby > 0">, {{ room.baby }} {{$t('Bebek')}}</template>
              </span>
            </div>
            <div v-if="reservation.childrenAges && reservation.childrenAges.length > 0" class="mt-2 text-[11px] text-slate-500">
              <span class="font-semibold">{{$t('Çocuk yaşları')}}:</span>
              <div class="mt-1 flex flex-wrap gap-1.5">
                <span
                  v-for="(a, i) in reservation.childrenAges"
                  :key="`summary_child_${i}`"
                  class="inline-flex items-center gap-1 rounded-md border border-slate-200 bg-white px-2 py-1 text-[10px] text-slate-600"
                >
                  {{ i + 1 }}. {{ a === '' ? '—' : a }} {{ $t('yaş') }}
                  <span class="text-slate-400">•</span>
                  <span class="font-semibold text-slate-500">{{ getSidebarChildBedLabel(i) }}</span>
                </span>
              </div>
            </div>
          </div>

          <!-- Form (açıkken) -->
          <template v-if="sidebarRoomEditorOpen">
          <div class="flex flex-col gap-2">
            <div
              v-for="(room, key) in reservation.rooms"
              :key="`sidebar_room_${key}`"
              class="rounded-xl border border-slate-200 bg-slate-50/60 p-3"
            >
              <div class="flex items-center justify-between mb-2 relative">
                <span class="text-[12px] font-semibold text-slate-700">{{ key + 1 }}. {{$t('Oda')}}</span>
                <button
                  v-if="key !== 0"
                  type="button"
                  class="text-slate-400 hover:text-rose-500 absolute top-2 right-2"
                  @click="removeRoom(key)"
                  aria-label="Odayi kaldir"
                >  <font-awesome-icon icon="fa-solid fa-trash" class="h-3 w-3" />
                </button>
              </div>

              <div class="grid grid-cols-3 gap-2">
                <div>
                  <label class="text-[10px] font-semibold text-slate-500">{{$t('Kişi')}} (12+)</label>
                  <select v-model.number="room.adult" @change="normalizeChildrenAges(reservation)"
                    class="w-full rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-semibold">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </div>
                <div>
                  <label class="text-[10px] font-semibold text-slate-500">{{$t('Çocuk')}} (2-11)</label>
                  <select v-model.number="room.child" @change="normalizeChildrenAges(reservation)"
                    class="w-full rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-semibold">
                    <option value="0">-</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </div>
                <div>
                  <label class="text-[10px] font-semibold text-slate-500">{{$t('Bebek')}} (0-2)</label>
                  <select v-model.number="room.baby" @change="normalizeChildrenAges(reservation)"
                    class="w-full rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-semibold">
                    <option value="0">-</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </div>
              </div>
            </div>

            <button
              type="button"
              class="h-9 rounded-xl border border-dashed border-slate-300 bg-white text-xs font-semibold text-slate-600 hover:bg-slate-50"
              @click="addRoom"
            >
              + {{$t('Oda Ekle')}}
            </button>
          </div>

          <div v-if="totalKidsCount > 0" class="mt-3 rounded-xl border border-slate-200 bg-white p-3">
            <div class="mb-2 flex flex-col items-center justify-between">
              <p class="mb-0 text-[11px] font-semibold text-slate-600">{{$t('Çocukların yaşlarını belirtin')}} (0-17)</p>
              <!-- <span class="text-[10px] text-slate-400">{{ locale === 'tr' ? 'Fiyat yaşa göre hesaplanır' : 'Price is calculated by age' }}</span> -->
            </div>

            <div class="space-y-2">
              <div
                v-for="(age, idx) in reservation.childrenAges"
                :key="`sidebar_age_${idx}`"
                class="rounded-lg border border-slate-200 bg-slate-50/60 p-2"
              >
                <div class="flex items-start gap-2 relative">
                  <span class="mt-1 absolute left-2 top-0 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-slate-200 px-1 text-[10px] font-bold text-slate-600">{{ idx + 1 }}</span>

                  <div class="flex-1 min-w-0">
                    <div class="flex flex-col items-center gap-2">
                      <select
                        v-model="reservation.childrenAges[idx]"
                        @change="onSidebarChildAgeChange(idx)"
                        class="rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-semibold min-w-[110px]"
                      >
                        <option value="">{{$t('Yaş seç')}}</option>
                        <option v-for="n in 18" :key="n - 1" :value="n - 1">
                          {{ n - 1 === 0 ? '0 (bebek)' : n - 1 + ' yaş' }}
                        </option>
                      </select>

                       <div
                    class="shrink-0 w-full" 
                  >
                    <div class="rounded-lg border border-slate-200 bg-white p-2">
                      <div class="space-y-1.5">
                        <button
                          v-for="opt in getSidebarChildBedOptionsByIndex(idx)"
                          :key="`sidebar_bed_${idx}_${opt.key}`"
                          type="button"
                          @click="selectSidebarChildBedOption(idx, opt.key)"
                          class="w-full rounded-md border px-2 py-1.5 text-left transition-colors"
                          :class="sidebarChildBedChoices[idx] === opt.key ? 'border-sky-300 bg-sky-50' : 'border-slate-200 bg-white hover:bg-slate-50'"
                        >
                          <div class="flex items-center gap-2">
                            <div class="flex h-8 w-12 items-center justify-center rounded bg-slate-100">
                              <svg v-if="opt.kind === 'turBaby'" viewBox="0 0 56 28" class="h-6 w-10">
                                <rect x="3" y="3" width="50" height="22" rx="6" fill="#dbeafe" stroke="#60a5fa" stroke-width="1.6"/>
                                <rect x="7" y="7" width="42" height="8" rx="3" fill="#eff6ff"/>
                                <line x1="9" y1="3" x2="9" y2="25" stroke="#93c5fd" stroke-width="1"/>
                                <line x1="16" y1="3" x2="16" y2="25" stroke="#93c5fd" stroke-width="1"/>
                                <line x1="23" y1="3" x2="23" y2="25" stroke="#93c5fd" stroke-width="1"/>
                                <line x1="30" y1="3" x2="30" y2="25" stroke="#93c5fd" stroke-width="1"/>
                                <line x1="37" y1="3" x2="37" y2="25" stroke="#93c5fd" stroke-width="1"/>
                                <line x1="44" y1="3" x2="44" y2="25" stroke="#93c5fd" stroke-width="1"/>
                                <rect x="8" y="18" width="40" height="4" rx="2" fill="#bfdbfe"/>
                              </svg>
                              <template v-else-if="opt.kind === 'turChild'"  >
                                  <img src="/assets/svg/bed-single.svg" class="h-8" alt="Ek yatak" />
                              </template>
                              <template v-else  >
                                  <img src="/assets/svg/bed-double.svg" class="h-8" alt="Çift kişilik yatak" />
                              </template>
                               
                            </div>
                            <div class="min-w-0">
                              <p class="mb-0 leading-3 text-[10px] font-bold text-slate-700">{{ locale === 'tr' ? opt.labelTr : opt.labelEn }}</p>
                              <p class="mb-0 leading-3 text-[9px] text-slate-400">{{ locale === 'tr' ? opt.descTr : opt.descEn }}</p>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>

                      <div class="absolute top-2 right-2">
                        <button type="button" class="text-slate-400 hover:text-rose-500" @click="removeChildAge(idx)">
                          <font-awesome-icon icon="fa-solid fa-xmark" class="h-3 w-3"></font-awesome-icon>
                        </button>
                      </div>
                    </div>
                  </div>

                  
                </div>
              </div>
            </div>
          </div>

          <button
            type="button"
            @click="sidebarRoomEditorOpen = false"
            class="mt-3 w-full h-9 rounded-xl bg-brand-700 text-white text-xs font-semibold hover:bg-brand-800 transition-colors"
          >
            <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3 mr-1" />
            {{$t('Kaydet')}}
          </button>
          </template>
          </div>
        </div>

            <div class="bg-white sticky top-0">
       
        <!-- <div class="my-3 px-4 py-3 group rounded-xl bg-sky-100 border border-sky-200 flex items-center hover:border-sky-300 border-r-3 shadow-md cursor-pointer text-slate-500">  -->
        
        <div
          class="overflow-hidden transition-all duration-200 ease-out"
          :class="shouldHideSidebarInfoCards ? 'max-h-0 opacity-0 -translate-y-2 pointer-events-none' : 'max-h-[320px] opacity-100 translate-y-0'"
        >
        <div class="my-2 overflow-hidden rounded-2xl border border-slate-200/90 bg-white p-2 shadow-[0_14px_35px_-30px_rgba(15,23,42,.6)]">
          <div class="mb-2 flex items-center justify-between border-b border-slate-100 px-1 pb-2">
            <span class="inline-flex items-center gap-1.5 text-[10px] font-extrabold uppercase tracking-[.16em] text-slate-500">
              <font-awesome-icon icon="fa-solid fa-compass" class="h-3 w-3 text-[#0b5557]" />
              {{$t('Hızlı Erişim')}}
            </span>
            <a :href="getPath('/page/yolculuk-merkezi')" class="text-[10px] font-bold text-[#0b5557] transition hover:text-slate-900" @click.stop.prevent="goPath('/page/yolculuk-merkezi')">
              {{$t('Tümü')}} →
            </a>
          </div>

          <div class="grid grid-cols-1 gap-1">
            <a :href="getPath('/tour/ongoing-tours')" :title="$t('Devam Eden Turlarımız')" class="group relative flex items-center gap-2 rounded-xl border border-slate-100 bg-[#fafbf9] px-2.5 py-1 transition hover:-translate-y-0.5 hover:border-slate-300 hover:bg-white hover:shadow-sm" @click.stop.prevent="goPath('/tour/ongoing-tours')">
              <span class="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-[#0b5557] shadow-sm">
                <img src="/assets/img/ongoing.svg" class="h-4 w-4" alt="" style="height:16px;width:16px;" />
              </span>
              <span class="text-[11px] font-bold leading-[1.25] text-slate-700 group-hover:text-[#0b5557]">{{$t('Devam Eden Turlarımız')}}</span>
              <span class="absolute right-2 top-2 h-1.5 w-1.5 rounded-full bg-emerald-500 ring-2 ring-emerald-500/15"></span>
            </a>

            <a :href="getPath('/page/faq')" :title="$t('Sıkça Sorulan Sorular')" class="group flex items-center gap-2 rounded-xl border border-slate-100 bg-[#fafbf9] px-2.5 py-1 transition hover:-translate-y-0.5 hover:border-slate-300 hover:bg-white hover:shadow-sm" @click.stop.prevent="goPath('/page/faq')">
              <span class="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-[#0b5557] shadow-sm"><font-awesome-icon icon="fa-solid fa-question-circle" class="h-3.5 w-3.5" /></span>
              <span class="text-[11px] font-bold leading-[1.25] text-slate-700 group-hover:text-[#0b5557]">{{$t('Sıkça Sorulan Sorular')}}</span>
            </a>

            <a :href="getPath('/page/umre-ve-hac-rehberi')" :title="$t('Umre Manevi Rehberi')" class="group flex items-center gap-2 rounded-xl border border-slate-100 bg-[#fafbf9] px-2.5 py-1 transition hover:-translate-y-0.5 hover:border-slate-300 hover:bg-white hover:shadow-sm" @click.stop.prevent="goPath('/page/umre-ve-hac-rehberi')">
              <span class="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-[#0b5557] shadow-sm"><font-awesome-icon icon="fa-solid fa-kaaba" class="h-3.5 w-3.5" /></span>
              <span class="text-[11px] font-bold leading-[1.25] text-slate-700 group-hover:text-[#0b5557]">{{$t('Umre Manevi Rehberi')}}</span>
            </a>

            <a :href="getPath('/page/umre-rehberi')" :title="$t('Umre Rehberi')" class="group flex items-center gap-2 rounded-xl border border-slate-100 bg-[#fafbf9] px-2.5 py-1 transition hover:-translate-y-0.5 hover:border-slate-300 hover:bg-white hover:shadow-sm" @click.stop.prevent="goPath('/page/umre-rehberi')">
              <span class="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-[#0b5557] shadow-sm"><font-awesome-icon icon="fa-solid fa-book-open" class="h-3.5 w-3.5" /></span>
              <span class="text-[11px] font-bold leading-[1.25] text-slate-700 group-hover:text-[#0b5557]">{{$t('Umre Rehberi')}}</span>
            </a>

            <a :href="getPath('/page/yorumlar')" :title="$t('Yolcu Yorumları')" class="group flex items-center gap-2 rounded-xl border border-slate-100 bg-[#fafbf9] px-2.5 py-1 transition hover:-translate-y-0.5 hover:border-slate-300 hover:bg-white hover:shadow-sm" @click.stop.prevent="goPath('/page/yorumlar')">
              <span class="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-[#0b5557] shadow-sm"><font-awesome-icon icon="fa-solid fa-comments" class="h-3.5 w-3.5" /></span>
              <span class="text-[11px] font-bold leading-[1.25] text-slate-700 group-hover:text-[#0b5557]">{{$t('Yolcu Yorumları')}}</span>
            </a>

            <a :href="getPath('/user/quiz/quiz-all')" :title="$t('Umre Testi')" class="group flex items-center gap-2 rounded-xl border border-slate-100 bg-[#fafbf9] px-2.5 py-1 transition hover:-translate-y-0.5 hover:border-slate-300 hover:bg-white hover:shadow-sm" @click.stop.prevent="goPath('/user/quiz/quiz-all')">
              <span class="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-[#0b5557] shadow-sm"><font-awesome-icon icon="fa-solid fa-graduation-cap" class="h-3.5 w-3.5" /></span>
              <span class="text-[11px] font-bold leading-[1.25] text-slate-700 group-hover:text-[#0b5557]">{{$t('Umre Testi')}}</span>
            </a>
          </div>
        </div>
        </div> 
          <div class="hidden md:block left-0 z-20 space-y-4">
            <div class="relative w-full rounded-2xl border border-neutral-200 bg-white/95 backdrop-blur p-4 shadow-sm">
              <div class="mb-3 flex items-center justify-between border-b border-neutral-100 pb-2">
                <div class="inline-flex items-center gap-2 rounded-full bg-accent-50 px-2.5 py-1 text-xs font-semibold text-accent-700">
                  <font-awesome-icon icon="fa-solid fa-calendar-days" class="h-3 w-3" />
                  {{$t('Müsait Tarihler')}}
                </div>
                <span class="text-[11px] font-semibold text-neutral-500">{{ toursDateListMonth?.length || 0 }} {{$t('ay')}}</span>
              </div>

            <div class="flex flex-wrap flex-col gap-1">
              <div v-for="(item, key) in toursDateListMonth" :key="'k_' + key" 
                class="cursor-pointer flex flex-col rounded-xl border border-neutral-200 bg-neutral-50/70 overflow-hidden">
                <div 
                   class="border-b border-neutral-200 py-2 text-sm w-full flex group justify-between cursor-pointer px-2.5 text-xs font-semibold"
                      @click="toggleMonth(item)"
                    ><span class="text-slate-700 group-hover:text-brand-700 ">
                      <font-awesome-icon icon="fa-solid fa-circle" class="h-2.5 w-2.5 text-brand-300 group-hover:text-brand-500 mr-1"></font-awesome-icon>
                      {{ item }} UMRE</span> <span>
                      <font-awesome-icon icon="fa-solid fa-chevron-down" class="h-3 w-3 text-neutral-500"></font-awesome-icon>
                    </span>
                </div>
                <div class="flex flex-wrap gap-1.5 p-2 bg-white" v-show="toursDateList[item].show">
                    <template  v-for="(item2, key2) in toursDateList[item]" >
                        <div @click="scrollTo(item2.id)" v-if="item2.date"
                        class="rounded-md border px-2 py-1 text-xs transition-colors"
                        :class="activeDateId === item2.id ? 'border-brand-500 bg-brand-100 text-brand-800 font-semibold ring-1 ring-brand-400' : 'border-neutral-200 hover:border-brand-300 hover:bg-brand-50 bg-white text-neutral-700'"
                      >{{item2.date}}({{ item2?.total }})</div>
                    </template>
                </div>
              </div>
            </div>
            </div>

            <div v-show="!sidebarStickyActive" class="relative w-full rounded-2xl border border-neutral-200 bg-white/95 backdrop-blur p-4 shadow-sm">
              <div  class="absolute -top-3 text-sm mb-2 flex items-center truncate bg-orange-400  text-white px-2 py-0.5 w-fit rounded-full">{{$t('Filtrele')}}</div>
              <div   class="flex md:grow rounded-md mb-2 py-2">
                <div class="w-full text-dark-900 font-semibold text-lg">
                  <label class="hidden md:block text-xs text-slate-700">{{$t('Ne zaman')}}</label>
                  <div class=" border-slate-100 w-full relative mt-1">
                    <!-- <div class="flex-none absolute bg-white shadow-md p-2 rounded-md left-0 border border-slate-100"> -->
                    <div class="flex-none ">
                      <template v-if="1==3">
                        <globalMenu 
                            :menu-items="searchQuestions['when']"
                            :label="labelSearch['when']"
                            @change="item=>addSearch('when', item.id)"
                        ></globalMenu> 
                      </template>
                      <template v-else> 
                        <div class="flex flex-wrap w-full truncate" v-if="searchQuestions">
                        <template v-for="item in searchQuestions['when']">
                          <div
                           @click="addSearch('when', item.id)"
                            :class="item.selected ? 'bg-green-100  border-green-300' : 'border-slate-200 truncate'"
                            class="rounded-md mr-1 cursor-pointer flex flex-nowrap items-center py-1 pl-1 pr-2 text-xs border block mb-1 hover:bg-green-100 hover:border-green-400">
                            <span v-if="!item.selected" class="h-3 w-3 mr-1 text-slate-300 bg-slate-300 rounded-md"  ></span>
                            <font-awesome-icon v-else class="h-3 w-3 mr-1" icon="fa-solid fa-check-circle"></font-awesome-icon>
                            {{ $t(item.short) }}
                          </div>
                        </template>
                      </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <div  class="text-dark-900 font-semibold text-lg rounded-md">
                <label class="hidden md:block pl-0 text-xs text-slate-700" >{{ $t('Süre') }} </label>
                 
                        <div v-if="searchQuestions" class=" border-slate-100 w-full relative mt-1  text-xs md:text-md">
                          <div class="flex-none ">
                            <div class="flex flex-nowrap w-full ">
                              <template v-for="item in searchQuestions['duration']">
                                <div @click="addSearch('duration', item.id)"
                                  :class="item.selected ? 'border-green-200 bg-green-100' : 'border-slate-200 '"
                                  class="rounded-md truncate mr-1 cursor-pointer py-1 px-2 text-xs border block mb-1 hover:bg-green-100 hover:border-green-400">
                                  {{ $t(item.label) }}</div>
                              </template>
                            </div>
                          </div>
                        </div>   
              </div>
              <div  class="text-dark-900 font-semibold text-lg  rounded-md">
                <label class="hidden md:block pl-0 mt-3 text-xs text-slate-500" >{{ $t('Oteller') }} </label>
                 
                        <div   class="hidden md:block md:px-3 mb-1 text-dark-900 font-semibold text-lg border-slate-100 pl-7 md:pl-0 rounded-md">
                  <!-- <label class="hidden md:block pl-0 md:pl-1 text-xs text-slate-100" >{{ $t('Otel') }} </label> -->
                  <div class="w-full mt-1">
                    <!-- Eski select kaldırıldı, modal tetikleyen buton eklendi -->
                    <button
                      type="button"
                      class="w-full flex items-center justify-between rounded-md border border-slate-200 bg-white text-slate-700 px-3 py-2 text-sm"
                      @click="openHotelModal"
                    >
                      <span class="flex items-center gap-2">
                        <font-awesome-icon
                          :icon="search.activeHotelId && search.activeHotelId!=='all' ? 'fa-solid fa-circle-check' : 'fa-solid fa-circle'"
                          :class="search.activeHotelId && search.activeHotelId!=='all' ? 'text-green-600' : 'text-slate-400'"
                          class="h-4 w-4"
                        />
                        {{ activeHotelFilterLabel || $t('Tüm Oteller') }}
                      </span>
                      <font-awesome-icon icon="fa-solid fa-chevron-down" class="h-3 w-3 text-slate-400" />
                    </button>
                  </div>
                </div>
              </div>
              </div>
          </div> 
        </div>
        </aside>
        <div class="w-full h-full block wrap whitespace-normal min-h-96 overflow-visible md:col-start-2 md:row-start-1" style="min-height: 500px;">

           <div
  v-show="isMobile && ((!detailSearchView && !detailReservationView && !detailMenuView) || windowTop)"
  class="sticky top-0 z-20 bg-white/95 backdrop-blur-md border-b border-neutral-100"
>
  <div class="flex gap-2 px-3 py-2 overflow-x-auto scrollbar-hide scroll-smooth -mx-px" style="-webkit-overflow-scrolling: touch;">
    <button
      type="button"
      @click="detailSearchView=!detailSearchView;detailMenuView=false"
      class="shrink-0 inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 text-[12px] font-semibold border transition-all shadow-sm"
      :class="detailSearchView
        ? 'bg-brand-800 border-brand-700 text-white shadow-brand-200'
        : hasActiveTourFilters
          ? 'bg-amber-50 border-amber-400 text-amber-900 ring-1 ring-amber-300'
          : 'bg-white border-neutral-200 text-neutral-700 hover:bg-neutral-50'"
    >
      <font-awesome-icon icon="fa-solid fa-sliders" class="h-3 w-3"></font-awesome-icon>
      {{$t('Filtrele')}}
      <span
        v-if="hasActiveTourFilters"
        class="inline-flex min-w-5 h-5 items-center justify-center rounded-full bg-amber-500 px-1.5 text-[10px] font-extrabold leading-none text-white"
        :aria-label="`${activeTourFilterCount} ${$t('aktif filtre')}`"
      >
        {{ activeTourFilterCount }}
      </span>
    </button>

    <button
      type="button"
      @click="openComments()"
      class="shrink-0 inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 text-[12px] font-semibold border bg-white border-neutral-200 text-neutral-700 hover:bg-neutral-50 transition-all shadow-sm"
    >
      <font-awesome-icon icon="fa-solid fa-star" class="h-3 w-3 text-accent-500"></font-awesome-icon>
      {{$t('Yorumlar')}}
    </button>

    <button
      type="button"
      @click="openVideoModal()"
      class="shrink-0 inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 text-[12px] font-semibold border bg-white border-neutral-200 text-neutral-700 hover:bg-neutral-50 transition-all shadow-sm"
    >
      <font-awesome-icon icon="fa-solid fa-play" class="h-3 w-3 text-support-600"></font-awesome-icon>
      {{$t('Video')}}
    </button>

    <button
      type="button"
      @click="showDates()"
      class="shrink-0 inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 text-[12px] font-semibold border transition-all shadow-sm"
      :class="detailMenuView ? 'bg-accent-600 border-accent-500 text-white shadow-accent-200' : 'bg-white border-neutral-200 text-neutral-700 hover:bg-neutral-50'"
    >
      <font-awesome-icon icon="fa-solid fa-calendar-days" class="h-3 w-3" :class="detailMenuView ? 'text-white' : 'text-brand-500'"></font-awesome-icon>
      {{$t('Tarihler')}}
    </button>

    <button
      type="button"
      @click="openNedenInancTur()"
      class="shrink-0 inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 text-[12px] font-semibold border bg-white border-neutral-200 text-neutral-700 hover:bg-neutral-50 transition-all shadow-sm"
    >
      <font-awesome-icon icon="fa-solid fa-circle-question" class="h-3 w-3 text-brand-500"></font-awesome-icon>
      {{$t('Neden Biz?')}}
    </button>

    <a
      :href="buildWhatsAppUrl()"
      target="_blank"
      rel="nofollow noopener noreferrer"
      class="whatsappTrigger shrink-0 inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 text-[12px] font-semibold border bg-support-50 border-support-200 text-support-700 hover:bg-support-100 transition-all shadow-sm"
    >
      <font-awesome-icon icon="fa-brands fa-whatsapp" class="h-3.5 w-3.5"></font-awesome-icon>
      {{$t('WhatsApp')}}
    </a>
  </div>
</div>

          <!-- Mobile: Sticky Tarih Navigasyonu -->
          <div
            v-if="isMobile && activeDateEntry && flatDateEntries.length > 1 && !detailSearchView && !detailMenuView"
            class="md:hidden sticky top-[52px] z-[19] px-2 pb-1.5 bg-white/95 backdrop-blur-md border-b border-neutral-100"
          >
            <div class="flex items-center justify-between gap-1">
              <!-- Önceki -->
              <button
                v-if="prevDateEntry"
                type="button"
                class="group flex items-center gap-1.5 rounded-lg px-2 py-1.5 text-left transition-colors active:bg-brand-50"
                @click.stop.prevent="scrollTo(prevDateEntry.id)"
              >
                <span class="flex h-6 w-6 items-center justify-center rounded-full border border-brand-200 bg-brand-50 text-brand-600">
                  <font-awesome-icon icon="fa-solid fa-chevron-left" class="h-2 w-2" />
                </span>
                <span class="flex flex-col">
                  <span class="text-[8px] font-medium text-neutral-400 uppercase tracking-wider leading-none">{{ $t('Önceki') }}</span>
                  <span class="text-[11px] font-bold text-neutral-700 leading-tight">{{ prevDateEntry.date }}</span>
                </span>
              </button>
              <div v-else class="w-16"></div>

              <!-- Aktif tarih -->
              <div class="flex flex-col items-center shrink-0">
                <span class="text-[8px] font-semibold text-brand-500 uppercase tracking-widest leading-none">{{ $t('Gidiş') }}</span>
                <span class="text-sm font-extrabold text-brand-800 leading-tight tracking-tight">{{ activeDateLabel }}</span>
                <span class="text-[9px] text-neutral-400 font-medium leading-none">
                  {{ activeDateIndex + 1 }} / {{ flatDateEntries.length }}
                </span>
              </div>

              <!-- Sonraki -->
              <button
                v-if="nextDateEntry"
                type="button"
                class="group flex items-center gap-1.5 rounded-lg px-2 py-1.5 text-right transition-colors active:bg-brand-50"
                @click.stop.prevent="scrollTo(nextDateEntry.id)"
              >
                <span class="flex flex-col items-end">
                  <span class="text-[8px] font-medium text-neutral-400 uppercase tracking-wider leading-none">{{ $t('Sonraki') }}</span>
                  <span class="text-[11px] font-bold text-neutral-700 leading-tight">{{ nextDateEntry.date }}</span>
                </span>
                <span class="flex h-6 w-6 items-center justify-center rounded-full border border-brand-200 bg-brand-50 text-brand-600">
                  <font-awesome-icon icon="fa-solid fa-chevron-right" class="h-2 w-2" />
                </span>
              </button>
              <div v-else class="w-16"></div>
            </div>
          </div>

          <div class="sticky top-0 md:top-1 left-0 z-20 w-full overflow-visible transition-all relative"
            :class="[stickyClass, 'rounded-xl border border-slate-200 bg-white/95 backdrop-blur-md shadow-sm']"
            v-show="!isMobile || detailSearchView || detailMenuView"
          >
              
              <div v-show="isMobile && (detailSearchView || detailReservationView || detailMenuView)" 
                 class="flex w-full items-center justify-between gap-2 border-b border-neutral-200 bg-neutral-100 px-2 py-1.5"
              > 
                  <div class="flex items-center md:hidden">
                    <span class="inline-flex items-center rounded-md bg-brand-900 px-2 py-1 text-[10px] font-semibold uppercase tracking-wide text-white">{{$t('Filtre')}}</span>
                  </div>
                <div class="flex justify-end">
                  <a href="javascript:void(0)" class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium text-brand-800 transition-colors hover:text-brand-900" @click.stop.prevent="resetSearchFilters()"> 
                    <span>{{ $t('Filtreyi Sıfırla') }}</span>
                  </a> 
                  <a href="javascript:void(0)" class="mr-1 inline-flex items-center gap-1.5 rounded-md border border-neutral-300 bg-white px-2 py-1 text-xs font-semibold text-neutral-700 transition-colors hover:bg-neutral-200" @click.stop.prevent="closeMenu()">
                    <font-awesome-icon icon="fa-solid fa-times" class="h-3 w-3 text-neutral-500"  ></font-awesome-icon> 
                    <span>{{ $t('Filtreyi Gizle') }}</span>
                  </a> 
                  </div>
              </div>
              <div v-show="!isMobile || detailSearchView" class="flex w-full flex-col gap-2 px-3 py-2.5 md:flex-row md:items-start md:justify-between md:gap-3">

              <div class="flex md:grow"> 
                <div class="w-full text-neutral-900 font-semibold">
                 
                  <label class="hidden md:block pl-1 text-[11px] font-semibold uppercase tracking-wide text-slate-600">{{$t('Ne zaman')}}</label>
                  <div class="w-full relative mt-1">
                    <!-- <div class="flex-none absolute bg-white shadow-md p-2 rounded-md left-0 border border-slate-100"> -->
                    <div class="flex-none ">
                      
                        <div class="flex flex-wrap w-full" v-if="searchQuestions">
                        <template v-for="item in searchQuestions['when']">
                          <div
                           @click="addSearch('when', item.id)"
                            :class="item.selected ? 'bg-accent-500 border-accent-500 text-white' : 'border-neutral-300 bg-white text-neutral-700 truncate'"
                            class="rounded-md mr-1 cursor-pointer flex flex-nowrap items-center py-1 pl-1 pr-2 text-xs border block mb-1 transition-colors hover:bg-accent-500 hover:border-accent-500">
                             <span v-if="!item.selected" class="h-3 w-3 mr-1 rounded-md bg-neutral-300"  ></span>
                            <font-awesome-icon v-else class="h-3 w-3 mr-1" icon="fa-solid fa-check-circle"></font-awesome-icon>
                            {{ $t(item.short) }}
                          </div>
                        </template>
                        <div
                           @click="addSearch('when', null)"
                            :class="search['when']?.length == 0 ? 'bg-accent-500 border-accent-500 text-white' : 'border-neutral-300 bg-white text-neutral-700 truncate'"
                            class="rounded-md mr-1 cursor-pointer flex flex-nowrap items-center py-1 pl-1 pr-2 text-xs border block mb-1 transition-colors hover:bg-accent-500 hover:border-accent-500">
                             <span  v-if="search['when']?.length > 0" class="h-3 w-3 mr-1 rounded-md bg-neutral-300"  ></span>
                            <font-awesome-icon v-else class="h-3 w-3 mr-1" icon="fa-solid fa-check-circle"></font-awesome-icon>
                            {{ $t('Tümü') }}
                          </div>
                      </div> 
                      <div v-else class="flex min-h-[32px] items-center gap-2 pr-2">
                        <span v-for="n in 3" :key="`when_skeleton_${n}`" class="h-7 rounded-md border border-neutral-200 bg-neutral-100 animate-pulse" :class="n === 1 ? 'w-16' : n === 2 ? 'w-20' : 'w-14'"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div  class="md:px-2 text-neutral-900 font-semibold rounded-md">
                <label class="hidden md:block pl-0 md:pl-1 text-[11px] font-semibold uppercase tracking-wide text-slate-600" >{{ $t('Süre') }} </label>
                       
                        <div v-if="searchQuestions" class="w-full relative mt-1 text-xs md:text-md">
                          <div class="flex-none ">
                            <div class="flex flex-wrap w-full">
                              <template v-for="item in searchQuestions['duration']">
                                <div @click="addSearch('duration', item.id)"
                                  :class="item.selected ? 'bg-accent-500 border-accent-500 text-white' : 'border-neutral-300 bg-white text-neutral-700'"
                                  class="rounded-md truncate mr-1 cursor-pointer py-1 px-2 text-xs border block mb-1 transition-colors hover:bg-accent-500 hover:border-accent-500">
                                  {{ $t(item.label) }}</div>
                              </template>
                              <div
                           @click="addSearch('duration', null)"
                            :class="search['duration']?.length == 0 ? 'bg-accent-500 border-accent-500 text-white' : 'border-neutral-300 bg-white text-neutral-700 truncate'"
                            class="rounded-md mr-1 cursor-pointer flex flex-nowrap items-center py-1 pl-1 pr-2 text-xs border block mb-1 transition-colors hover:bg-accent-500 hover:border-accent-500">
                            <font-awesome-icon v-if="search['duration']?.length > 0" class="h-3 w-3 mr-1 text-neutral-400" icon="fa-solid fa-circle"></font-awesome-icon>
                            <font-awesome-icon v-else class="h-3 w-3 mr-1" icon="fa-solid fa-check-circle"></font-awesome-icon>
                            {{ $t('Tümü') }}
                          </div>
                            </div>
                          </div>
                        </div>
                        <div v-else class="mt-1 flex min-h-[32px] items-center gap-2">
                          <span v-for="n in 3" :key="`duration_skeleton_${n}`" class="h-7 rounded-md border border-neutral-200 bg-neutral-100 animate-pulse" :class="n === 1 ? 'w-12' : n === 2 ? 'w-16' : 'w-14'"></span>
                        </div>
                      
              </div>
              
           <div v-if="isMobile"  class="block md:hidden md:px-3 mb-1 text-neutral-900 font-semibold rounded-md">
                  <label class="hidden md:block pl-0 md:pl-1 text-[11px] font-semibold uppercase tracking-wide text-neutral-500" >{{ $t('Otel') }} </label>
                  <div class="w-full mt-1">
                    <!-- Eski select kaldırıldı, modal tetikleyen buton eklendi -->
                    <button
                      type="button"
                      class="w-full flex items-center justify-between rounded-md border border-neutral-300 bg-white text-neutral-700 px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-500/40"
                      @click="openHotelModal"
                    >
                      <span class="flex items-center gap-2">
                        <font-awesome-icon
                          :icon="search.activeHotelId && search.activeHotelId!=='all' ? 'fa-solid fa-circle-check' : 'fa-solid fa-circle'"
                          :class="search.activeHotelId && search.activeHotelId!=='all' ? 'text-support-600' : 'text-neutral-400'"
                          class="h-4 w-4"
                        />
                        {{ activeHotelFilterLabel || $t('Tüm Oteller') }}
                      </span>
                      <font-awesome-icon icon="fa-solid fa-chevron-down" class="h-3 w-3 text-neutral-500" />
                    </button>
                  </div>
                </div>
              
              </div>

            
             

          </div>
         
 
          <div class="mx-2 md:mx-0 hidden md:block" v-if="!isMobile && category=='5YILDIZUMRE'">
           
          <!-- <div class="w-full flex justify-between mt-3 border-t border-l border-r border-slate-100  rounded-lg bg-white mx-0">
            <div class="w-full flex items-center"> 
              <template v-for="(item,index) in informations">
                <span @click="headertab=index+1" :class="headertab==index+1 ?  'bg-slate-200 text-slate-500 rounded-t-lg' :'text-sky-700' " 
                  class="py-2 cursor-pointer flex items-center text-sm space-x-2 font-semibold px-3 hover:bg-slate-100 truncate ">
                  <font-awesome-icon class="mr-2" :class="headertab==index+1 ? 'text-sky-600':'text-sky-200'"  style="width: 16px;height: 16px;" icon="fa-solid fa-info-circle"></font-awesome-icon> {{item.title[locale]}}
                </span>
              </template>  
            </div>
            <span v-show="headertab!=3" @click="headertab=3" :class="'bg-white text-stone-500' " class="py-2 flex-none font-semibold w-fit   text-xs px-3 rounded-tr-lg">Gizle</span>
          </div> -->
          
          <!-- <div v-show="headertab==1" class="bg-gradient-to-r w-full  from-slate-100 to-slate-200 flex px-2 py-2 border-slate-600 rounded-b-lg mb-2 leading-6 text-sm mx-0"> 
             
             <div class="grid grid-cols-1 md:grid-cols-4 gap-2  w-full">
                <div @click="setHotelFilter('aG90ZWxEZXRhaWwxNjcxNjI4ODYz','Makkah Hotel')" 
                    class="cursor-pointer relative h-24 overflow-hidden bg-slate-800 rounded-lg block"
                    :class="search.activeHotelId==='aG90ZWxEZXRhaWwxNjcxNjI4ODYz' ? 'ring-2 ring-offset-2 ring-green-400' : ''"
                > 
                      <img src="https://image.inanctur.com.tr/yonetim/images/oteller/umre_oteller/makkah-hotel-hilton/towers_w_200px_h_120px.jpg" alt="Makkah Hotel" 
                      class="w-full h-full object-cover rounded-lg absolute top-0 left-0 w-full h-full z-0 opacity-40 hover:opacity-40"/>

                    <div class="z-10 absolute bottom-3 left-0"> 
                        <span class="text-white font-bold px-2">Makkah Hotel</span>
                      
                        <span class="h-4">
                          <span class="flex items-center ml-2 text-white text-xs h-4"> 
                            <font-awesome-icon icon="fa-solid fa-circle" class="text-white h-2 w-2 mr-1 mb-0.5" />
                            Hareme sıfır mesafede
                          </span>
                        </span> 
                          <span class="h-7 mt-3">
                            <span class="flex items-center ml-2 ">
                              <font-awesome-icon v-for="n in 5" :key="n" icon="fa-solid fa-star" class="text-yellow-400 w-4 h-4 mr-0.5" />
                            </span>
                        </span>

                    </div>
                </div>  
                <div @click="setHotelFilter('aG90ZWxEZXRhaWwxNTQ3MTQ3MjMw','Anjum Hotel')" 
                    class="cursor-pointer relative h-24 overflow-hidden bg-slate-800 rounded-lg block"
                    :class="search.activeHotelId==='aG90ZWxEZXRhaWwxNTQ3MTQ3MjMw' ? 'ring-2 ring-offset-2 ring-green-400' : ''"
                > 
                      <img src="https://image.inanctur.com.tr/yonetim/images/oteller/umre_oteller/Anjum/anjum-hotel-makkah-mecca-pic-88_w_200px_h_120px.jpg" 
                      alt="Anjum Hotel" 
                      class="w-full h-full object-cover rounded-lg absolute top-0 left-0 w-full h-full z-0 opacity-50 hover:opacity-40"/>

                    <div class="z-10 absolute bottom-3 left-0"> 
                        <span class="text-white font-bold px-2">Anjum Hotel</span>
                      
                        <span class="h-5 ">
                          <span class="flex items-center ml-2 text-white text-xs h-5"> 
                            <font-awesome-icon icon="fa-solid fa-circle" class="text-white h-2 w-2 mr-1 mb-0.5" />
                            Hareme 400 mt. mesafede
                          </span>
                        </span> 
                          <span class="h-7 mt-2">
                            <span class="flex items-center ml-2 ">
                              <font-awesome-icon v-for="n in 5" :key="n" icon="fa-solid fa-star" class="text-yellow-400 w-4 h-4 mr-0.5" />
                            </span>
                        </span>

                    </div>
                </div>   
                <div @click="setHotelFilter('aG90ZWxEZXRhaWwxNzM4NzYxNDgy','Jumeirah Hotel')" 
                    class="cursor-pointer relative h-24 overflow-hidden bg-slate-800 rounded-lg block"
                    :class="search.activeHotelId==='aG90ZWxEZXRhaWwxNzM4NzYxNDgy' ? 'ring-2 ring-offset-2 ring-green-400' : ''"
                    > 
                      <img src="https://image.inanctur.com.tr/yonetim/images/oteller/umre_oteller/jabal-omar-jumeirah/511151638_w_200px_h_120px.jpg" 
                      alt="Jumeirah Hotel" 
                      class="w-full h-full object-cover rounded-lg absolute top-0 left-0 w-full h-full z-0 opacity-50 hover:opacity-40"/>

                    <div class="z-10 absolute bottom-3 left-0"> 
                        <span class="text-white font-bold px-2">Jumeirah Hotel</span>
                      
                        <span class="h-5 ">
                          <span class="flex items-center ml-2 text-white text-xs h-5"> 
                            <font-awesome-icon icon="fa-solid fa-circle" class="text-white h-2 w-2 mr-1 mb-0.5" />
                            Hareme 200 mt. mesafede
                          </span>
                        </span> 
                          <span class="h-7 mt-2">
                            <span class="flex items-center ml-2 ">
                              <font-awesome-icon v-for="n in 5" :key="n" icon="fa-solid fa-star" class="text-yellow-400 w-4 h-4 mr-0.5" />
                            </span>
                        </span>

                    </div>
                </div>   
                <div @click="setHotelFilter('aG90ZWxEZXRhaWwxNzYwNjAzODkz','Al Marwa Rayhaan by Rotana')" 
                    class="cursor-pointer relative h-24 overflow-hidden bg-slate-800 rounded-lg block"
                    :class="search.activeHotelId==='aG90ZWxEZXRhaWwxNzYwNjAzODkz' ? 'ring-2 ring-offset-2 ring-green-400' : ''"
                    > 
                      <img src="https://image.inanctur.com.tr/yonetim/images/oteller/umre_oteller/AlMarvaRayhanRotana/670091385_w_200px_h_120px.jpg" 
                      alt="Al Marwa Rayhaan by Rotana" 
                      class="w-full h-full object-cover rounded-lg absolute top-0 left-0 w-full h-full z-0 opacity-50 hover:opacity-40"/>

                    <div class="z-10 absolute bottom-3 left-0"> 
                        <span class="text-white font-bold px-2">Al Marwa Rayhaan</span>
                      
                        <span class="h-5 ">
                          <span class="flex items-center ml-2 text-white text-xs h-5"> 
                            <font-awesome-icon icon="fa-solid fa-circle" class="text-white h-2 w-2 mr-1 mb-0.5" />
                            Hareme sıfır mesafede
                          </span>
                        </span> 
                          <span class="h-7 mt-2">
                            <span class="flex items-center ml-2 ">
                              <font-awesome-icon v-for="n in 5" :key="n" icon="fa-solid fa-star" class="text-yellow-400 w-4 h-4 mr-0.5" />
                            </span>
                        </span>

                    </div>
                </div>   
              
            </div>
          </div> -->

          <!-- <div v-show="headertab==2" class="bg-gradient-to-r    from-slate-100 to-slate-200 border-slate-600   border-l-4 border-l-sky-500 p-2 rounded-b-lg mb-2 leading-6 text-sm mx-0"> 
            <span class="text-md mt-1 font-semibold leading-4 text-sky-500 font-sans mb-2">{{informations[1].title[locale]}}</span> 
            <div class="w-full flex flex-col md:flex-row jusitfy-between md:space-x-3">
              <div class="flex flex-wrap text-sm font-normal leading-5 text-wrap text-slate-600">
                <span v-html="informations[1].text[locale]"></span>
              </div> 
            </div> 
          </div>  -->
        </div>
        

        <div
          v-if="isMobile && hasActiveTourFilters"
          role="status"
          aria-live="polite"
          class="mx-2 mb-2 mt-2 flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 md:hidden"
        >
          <font-awesome-icon icon="fa-solid fa-filter" class="h-3 w-3 shrink-0 text-amber-600" />
          <p class="mb-0 min-w-0 flex-1 text-xs leading-4 text-slate-700">
            {{ $t('Filtre') }}: <strong>{{ activeTourFilterSummary }}</strong>
          </p>
          <button
            type="button"
            class="shrink-0 text-xs font-bold text-brand-800 underline underline-offset-2"
            @click.stop.prevent="resetSearchFilters()"
          >
            {{ $t('Tüm turları göster') }}
          </button>
        </div>

        <div class="flex justify-between md:mt-2">
        
          <div class="grow">
           <div v-if="!isMobile && search.activeHotelId && search.activeHotelId!=='all'" class="mx-2 md:mx-0 mb-2 mt-1 p-2 pl-4 bg-amber-100 border border-amber-300 rounded-md md:rounded-2xl text-sm text-amber-800 flex justify-between items-center">
            <span>{{$t('Aktif otel filtresi')}}: <strong><br />{{ activeHotelFilterLabel }}</strong></span>
                      <button
                        class="ml-2 px-2 py-1 rounded border border-amber-300 hover:bg-white rounded-full"
                        @click="setHotelFilter(search.activeHotelId, activeHotelFilterLabel)"
                      >
                        {{$t('Filtreyi temizle')}}
                      </button>
            </div>
            </div>
            <div v-if="!isMobile" class="hidden md:flex items-center gap-2 px-2 flex-none">
            <!-- Modern segmented control with sliding indicator -->
             <span class="text-xs underline">{{$t('Görünüm')}}:</span>
            <div role="tablist" aria-label="Görünüm seçenekleri" class="relative inline-flex items-center" style="min-width:210px" tabindex="0" @keydown="onViewListKeydown">
              <!-- sliding indicator -->
              <span
                aria-hidden="true"
                class="absolute top-0 left-0 h-full w-1/3 bg-amber-500 rounded-full shadow-md transform transition-transform duration-200"
                :style="viewIndicatorStyle"
              ></span>

              <button
                type="button"
                role="tab"
                :aria-selected="viewMode === 'cards'"
                :aria-pressed="viewMode === 'cards'"
                @click="setViewMode('cards')"
                class="relative z-10 px-2 w-1/3 text-sm font-medium rounded-full flex items-center gap-2 outline-none transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-amber-300"
                :class="viewMode === 'cards' ? 'text-white' : 'text-slate-700 hover:text-slate-900'"
                aria-label="Kart görünümü"
                :title="$t('Kart görünümü')"
              >
                <font-awesome-icon icon="fa-solid fa-th-large" class="h-3 w-3" />
                <span class="hidden sm:inline">{{$t('Liste ')}}</span>
              </button>

              <button
                type="button"
                role="tab"
                :aria-selected="viewMode === 'table'"
                :aria-pressed="viewMode === 'table'"
                @click="setViewMode('table')"
                class="relative z-10 px-2 w-1/3 text-sm font-medium rounded-full flex items-center gap-2 outline-none transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-amber-300"
                :class="viewMode === 'table' ? 'text-white' : 'text-slate-700 hover:text-slate-900'"
                aria-label="Tablo görünümü"
                :title="$t('Tablo görünümü')"
              >
                <font-awesome-icon icon="fa-solid fa-table" class="h-3 w-3" />
                <span class="hidden sm:inline">{{$t('Tablo')}}</span>
              </button>

              <button
                type="button"
                role="tab"
                :aria-selected="viewMode === 'calendar'"
                :aria-pressed="viewMode === 'calendar'"
                @click="setViewMode('calendar')"
                class="relative z-10 px-2 w-1/3 text-sm font-medium rounded-full flex items-center gap-2 outline-none transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-amber-300"
                :class="viewMode === 'calendar' ? 'text-white' : 'text-slate-700 hover:text-slate-900'"
                aria-label="Takvim görünümü"
                :title="$t('Takvim görünümü')"
              >
                <font-awesome-icon icon="fa-solid fa-calendar-days" class="h-3 w-3" />
                <span class="hidden sm:inline">{{$t('Takvim')}}</span>
              </button>
            </div>
          </div>
        </div>

        
          <div id="tour-list-top" class="h-1"></div>
          <div v-if="tours || (!tours && loading)" class="md:mx-0 mx-2 mt-2 flex flex-col" style="min-height: 840px;">

            <!-- <div class="w-full block  mx-1 px-5 py-5 mb-5 trasition-all duration-400  bg-amber-100 rounded-md"
          v-show="loadingScrolledData">
              {{ $t('Turlar yükleniyor') }}
          </div> -->
            

              <section
                class="relative mb-4 overflow-hidden rounded-2xl border border-slate-200 bg-gradient-to-br from-white via-slate-50 to-sky-50/70 p-3.5 shadow-[0_14px_32px_-24px_rgba(15,23,42,.4)] md:p-4"
                aria-label="Güncel Umre Duyuruları"
              >
                <div aria-hidden="true" class="pointer-events-none absolute -right-10 -top-12 h-32 w-32 rounded-full bg-sky-200/35 blur-3xl"></div>
                <div aria-hidden="true" class="pointer-events-none absolute -bottom-16 left-10 h-24 w-32 rounded-full bg-emerald-200/25 blur-3xl"></div>

                <div class="relative z-10 mb-3 flex items-center justify-between gap-3">
                  <div class="flex min-w-0 items-center gap-2.5">
                    <span class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-sky-200 bg-sky-50 text-sky-700 shadow-sm">
                      <font-awesome-icon icon="fa-solid fa-bell" class="h-4 w-4" />
                    </span>
                    <div class="min-w-0">
                      <h2 class="mb-0 text-sm leading-4 font-bold tracking-tight text-slate-800">Güncel Umre Duyuruları</h2>
                      <p class="mb-0 hidden text-[11px] leading-4  text-slate-500 md:block">Kontenjan ve program güncellemelerini buradan takip edin.</p>
                    </div>
                  </div>
                  <span class="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50 px-2 py-1 text-[10px] font-bold text-emerald-700">
                    <span class="h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
                    Güncel
                  </span>
                </div>

                <div class="relative z-10 grid grid-cols-1 gap-2.5 md:grid-cols-2 md:gap-3">
                  <button
                    v-if="novemberCampaignTour"
                    type="button"
                    class="group relative order-first overflow-hidden rounded-xl border border-amber-300/80 bg-gradient-to-r from-amber-50 via-orange-50 to-rose-50 p-3 text-left shadow-sm transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-0.5 hover:border-amber-400 hover:shadow-md md:col-span-2 md:p-3.5"
                    @click="openNovemberCampaign"
                  >
                    <span aria-hidden="true" class="absolute -right-6 -top-10 h-28 w-28 rounded-full bg-amber-300/30"></span>
                    <span aria-hidden="true" class="absolute bottom-0 left-[38%] h-px w-2/3 bg-gradient-to-r from-amber-300/0 via-amber-400/60 to-amber-300/0"></span>
                    <div class="relative flex items-center gap-3">
                      <span class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-amber-500 to-orange-600 text-white shadow-sm">
                        <font-awesome-icon icon="fa-solid fa-tags" class="h-4 w-4" />
                      </span>
                      <div class="min-w-0 flex-1">
                        <p class="mb-0 text-[10px] font-extrabold uppercase tracking-[.14em] text-orange-700">{{ locale === 'en' ? 'Special campaign' : 'Özel kampanya' }}</p>
                        <p class="mb-0 mt-0.5 text-sm font-extrabold tracking-tight text-slate-900 md:text-[15px]">
                          {{ novemberCampaignTour.start }} {{ locale === 'en' ? 'Umrah programme' : 'Umre Programı' }}
                          <span class="font-semibold text-orange-700">· {{ locale === 'en' ? 'campaign offer' : 'kampanya fırsatı' }}</span>
                        </p>
                        <p class="mb-0 mt-0.5 text-[11px] leading-4 text-slate-600 md:text-xs">{{ locale === 'en' ? 'Discover the programme and its special campaign price.' : 'Programı ve kampanyaya özel fiyat avantajını hemen inceleyin.' }}</p>
                      </div>
                      <span class="inline-flex shrink-0 items-center gap-1 rounded-full border border-amber-300 bg-white/80 px-2.5 py-1.5 text-[11px] font-bold text-amber-800 shadow-sm transition-colors group-hover:bg-amber-500 group-hover:text-white">
                        {{ locale === 'en' ? 'View tour' : 'Programı incele' }}
                        <font-awesome-icon icon="fa-solid fa-arrow-right" class="h-2.5 w-2.5 transition-transform group-hover:translate-x-0.5" />
                      </span>
                    </div>
                  </button>

                  <article class="group relative overflow-hidden rounded-xl border border-sky-200/90 bg-white/90 p-3 transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-0.5 hover:border-sky-300 hover:shadow-md">
                    <span class="absolute right-3 top-3 rounded-full bg-sky-50 px-2 py-0.5 text-[9px] font-extrabold uppercase tracking-[.1em] text-sky-700">Kontenjan</span>
                    <div class="flex items-start gap-3 pr-16">
                      <span class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                        <font-awesome-icon icon="fa-solid fa-circle-exclamation" class="h-4 w-4" />
                      </span>
                      <div class="min-w-0">
                        <p class="mb-1 text-[10px] font-extrabold uppercase tracking-[.12em] text-sky-700">Umre Doluluk Durumu</p>
                        <p class="mb-0 text-xs leading-5 text-slate-600 md:text-sm md:leading-5">
                          <strong class="font-bold text-slate-800">7,8,10,12,14,15 ve 21 Kasım </strong> umre programlarımız dolmuştur. İlginiz için teşekkürler.
                        </p>
                      </div>
                    </div>
                  </article>

                  <article class="group relative hidden overflow-hidden rounded-xl border border-emerald-200/90 bg-white/90 p-3 transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-0.5 hover:border-emerald-300 hover:shadow-md md:block">
                    <span class="absolute right-3 top-3 rounded-full bg-emerald-50 px-2 py-0.5 text-[9px] font-extrabold uppercase tracking-[.1em] text-emerald-700">Yeni dönem</span>
                    <div class="flex items-start gap-3 pr-20">
                      <span class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-emerald-100 text-emerald-600">
                        <font-awesome-icon icon="fa-solid fa-calendar-check" class="h-4 w-4" />
                      </span>
                      <div class="min-w-0">
                        <p class="mb-1 text-[10px] font-extrabold uppercase tracking-[.12em] text-emerald-700">Program duyurusu</p>
                        <p class="mb-0 text-sm leading-5 text-slate-600">Ramazan ayı ve sonrası Şevval ayı umre programlarımız açıklanmıştır.</p>
                      </div>
                    </div>
                  </article>
                </div>
              </section>
               <!-- View mode conditional -->
            <div class="w-full mb-6 md:mb-8">
              <div v-if="showToursLoadingSkeleton" class="space-y-3 md:space-y-4">
                <div
                  v-for="n in loadingGhostCount"
                  :key="`tour_loading_${n}`"
                  class="w-full overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-sm"
                >
                  <div class="h-12 md:h-14 w-full border-b border-neutral-200 bg-gradient-to-r from-neutral-100 via-neutral-50 to-neutral-100 animate-pulse"></div>
                  <div class="grid grid-cols-1 md:grid-cols-[1fr_176px]">
                    <div class="p-3 md:p-4 space-y-3">
                      <div class="grid grid-cols-2 gap-3">
                        <div class="h-16 md:h-20 rounded-xl border border-neutral-200 bg-neutral-100 animate-pulse"></div>
                        <div class="h-16 md:h-20 rounded-xl border border-neutral-200 bg-neutral-100 animate-pulse"></div>
                      </div>
                      <div class="h-8 rounded-xl border border-neutral-200 bg-neutral-100 animate-pulse"></div>
                    </div>
                    <div class="hidden md:flex flex-col items-end justify-center gap-2 p-4 border-l border-neutral-200 bg-neutral-50/70">
                      <div class="h-3 w-16 rounded bg-neutral-200 animate-pulse"></div>
                      <div class="h-7 w-24 rounded bg-neutral-200 animate-pulse"></div>
                      <div class="h-3 w-14 rounded bg-neutral-200 animate-pulse"></div>
                    </div>
                  </div>
                  <div class="h-11 md:h-12 w-full border-t border-neutral-200 bg-neutral-50 animate-pulse"></div>
                </div>
              </div>

              
              <div v-else-if="viewMode === 'calendar'" class="rounded-2xl border border-neutral-200 bg-white shadow-sm overflow-hidden mt-5">
                <div class="flex items-center justify-between px-4 py-3 border-b border-neutral-200 bg-neutral-50">
                  <div class="flex items-center gap-2">
                    <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-brand-50 text-brand-700">
                      <font-awesome-icon icon="fa-solid fa-calendar-days" class="h-4 w-4" />
                    </span>
                    <div class="flex flex-col">
                      <span class="text-xs text-neutral-500">{{$t('Takvim görünümü')}}</span>
                      <span class="text-base font-semibold text-neutral-900">{{ calendarMonthLabel }}</span>
                    </div>
                  </div>
                  <div class="flex items-center gap-2">
                    <button
                      type="button"
                      class="h-8 w-8 inline-flex items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-600 hover:bg-neutral-50"
                      @click="goPrevCalendarMonth"
                      :title="$t('Önceki ay')"
                    >
                      <font-awesome-icon icon="fa-solid fa-chevron-left" class="h-3 w-3" />
                    </button>
                    <button
                      type="button"
                      class="h-8 w-8 inline-flex items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-600 hover:bg-neutral-50"
                      @click="goNextCalendarMonth"
                      :title="$t('Sonraki ay')"
                    >
                      <font-awesome-icon icon="fa-solid fa-chevron-right" class="h-3 w-3" />
                    </button>
                  </div>
                </div>

                <div class="grid grid-cols-7 gap-px bg-neutral-200 text-[11px] text-neutral-500">
                  <div v-for="day in calendarWeekdays" :key="day" class="bg-white px-2 py-2 text-center font-semibold">
                    {{ day }}
                  </div>
                </div>

                <div class="grid grid-cols-7 gap-px bg-neutral-200">
                  <button
                    v-for="day in calendarDays"
                    :key="day.dateKey"
                    type="button"
                    @click="selectCalendarDate(day)"
                    class="bg-white min-h-[84px] px-2 py-2 text-left hover:bg-neutral-50 transition-colors"
                    :class="[day.inMonth ? 'text-neutral-900' : 'text-neutral-400', day.isSelected ? 'ring-2 ring-accent-500 ring-inset' : '']"
                  >
                    <div class="flex items-start justify-between">
                      <span class="text-xs font-semibold">{{ day.day }}</span>
                      <span v-if="day.toursCount > 0" class="inline-flex items-center rounded-full bg-accent-50 text-accent-700 border border-accent-200 px-2 py-0.5 text-[10px] font-semibold">
                        {{ day.toursCount }}
                      </span>
                    </div>
                    <div v-if="day.hasTours" class="mt-2 flex flex-col gap-1">
                      <span class="text-[10px] text-neutral-500">{{$t('Turlar')}}</span>
                      <span class="text-[11px] font-medium text-neutral-700 line-clamp-2">{{ day.previewText }}</span>
                    </div>
                  </button>
                </div>

                <div class="border-t border-neutral-200 bg-white px-4 py-3">
                  <div class="flex items-center justify-between">
                    <div class="text-sm font-semibold text-neutral-900">
                      {{$t('Seçili Gün')}}: <span class="text-neutral-600">{{ calendarSelectedLabel }}</span>
                    </div>
                    <button
                      v-if="calendarSelectedDate"
                      type="button"
                      class="text-xs font-semibold text-brand-700 hover:text-brand-900"
                      @click="clearCalendarSelection"
                    >
                      {{$t('Seçimi temizle')}}
                    </button>
                  </div>
                  <div v-if="calendarSelectedTours.length" class="mt-3 grid gap-2">
                    <div v-for="tour in calendarSelectedTours" :key="tour.pdb_Id" class="flex items-center justify-between rounded-xl border border-neutral-200 bg-neutral-50/60 px-3 py-2">
                      <div class="min-w-0">
                        <div class="text-sm font-semibold text-neutral-900 truncate">
                          {{ tour.otel1_adi?.[locale] || tour.otel1_adi?.tr }} / {{ tour.otel2_adi?.[locale] || tour.otel2_adi?.tr }}
                        </div>
                        <div class="text-[11px] text-neutral-500">{{ tour.tur_Sure }} {{$t('gün')}} • {{ tour.start }}</div>
                      </div>
                      <div class="flex items-center gap-1.5 shrink-0">
                        <button
                          type="button"
                          class="h-8 px-3 rounded-full border border-brand-200 bg-brand-50 text-brand-700 text-[11px] font-semibold hover:bg-brand-100"
                          @click.stop.prevent="openQuickTourDetail(tour)"
                        >
                          <font-awesome-icon icon="fa-solid fa-eye" class="h-3 w-3 mr-1" />{{$t('Hızlı İncele')}}
                        </button>
                        <button
                          type="button"
                          class="h-8 px-3 rounded-full bg-accent-600 text-white text-[11px] font-semibold hover:bg-accent-500"
                          @click.stop.prevent="goPath('/tourDetail/' + tour.pdb_Id)"
                        >
                          {{$t('Detaylar')}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-else class="mt-3 text-xs text-neutral-500">
                    {{$t('Bu gün için tur bulunamadı.')}}
                  </div>
                </div>
              </div>

              <div v-else-if="viewMode === 'table'" class="overflow-x-auto bg-white rounded-lg border border-slate-200 shadow-sm">
                <table class="min-w-full text-sm text-left">
                  <thead class="bg-slate-50">
                    <tr>
                      <th class="px-4 py-3 text-xs text-slate-500 uppercase"> {{$t('Tarih')}} </th>
                      <th class="px-4 py-3 text-xs text-slate-500 uppercase"> {{$t('Süre')}} </th>
                      <th class="px-4 py-3 text-xs text-slate-500 uppercase"> {{$t('Oteller')}} </th>
                      <th class="px-4 py-3 text-xs text-slate-500 uppercase text-right"> {{$t('İkili Oda')}} </th>
                      <th class="px-4 py-3 text-xs text-slate-500 uppercase text-right"> </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in flattenedTours" :key="item.pdb_Id" class="border-b last:border-b-0 hover:bg-slate-50">
                      <td class="px-4 py-3 align-top">
                        <div class="font-medium text-slate-800">{{ item.start }}</div>
                        <div class="text-xs text-slate-500">Dön:{{ item.end || formatDate(item.turs_StartDate, 'dd MM') }}</div>
                      </td>
                      <td class="px-4 py-3 align-top">
                        <div class="text-slate-700 font-semibold">{{ item.tur_Sure }} {{$t('gün')}}</div>
                      </td>
                      <td class="px-4 py-3 align-top max-w-xs relative">

                        <div v-for="hotel in item.hotels" :key="hotel.id" class="text-xs text-slate-500">
                          {{ hotel.city? hotel.city?.[locale] + ': ' : '' }} {{ hotel.sOtelAdi?.[locale] || hotel.sOtelAdi?.tr }} - {{  hotel.turo_Sure }} {{$t('gece')}} 
                        </div> 
                        <template v-if="item.colorful_title[locale]">
                           <span  v-html="item.colorful_title[locale]"
                            class="py-0.5 md:py-0.5  font-normal text-xs tracking-tight "
                            :class="item.turd_Color ? `text-${item.turd_Color || 'slate'}-700` : 'text-gray-900'">
                            </span> 
                        </template>
                       
                      </td>
                      <td class="px-2 py-3 align-top text-right">
                        <div class="text-lg font-bold text-slate-900">{{ formatMoney(item.turs_double) }} <span class="text-xs text-slate-500">{{ item.tour_Currency }}</span></div>
                        <div v-if="getTourTotal(item, reservation) > 0" class="mt-1 text-[11px] text-slate-500">
                          Toplam: {{ formatMoney(getTourTotal(item, reservation)) }} {{ item.tour_Currency }}
                        </div>
                      </td>
                      <td class="px-2 py-3 align-top text-right">
                        <a
                          @click.stop.prevent="openQuickTourDetail(item)"
                          href="javascript:void(0)"
                          class="cursor-pointer border w-fit group-hover:border-slate-200 
                          bg-white text-green-700 border border-green-200 shadow-md hover:bg-green-500 hover:text-white font-medium rounded-lg px-2 md:px-2 py-1 text-xs flex items-center"
                        >  {{$t('İncele')}} </a>
                      </td>
                    </tr>
                    <tr v-if="flattenedTours.length === 0">
                      <td colspan="4" class="px-4 py-6 text-center text-slate-500">{{$t('Bu kategori için uygun tur bulunamadı.')}}</td>
                    </tr>
                  </tbody>
                </table>
              </div> 

               <div v-else class="[content-visibility:auto] [contain-intrinsic-size:1200px]">
 <!-- <template v-if="!tours"> 
                  <div class="md:mt-0 block w-full md:mx-0 mb-5 trasition-all duration-400  z-0">
 
                        <div class="w-full block min-h-96">
                              <template v-for="i in 3" :key="'loading_' + i">
                                <div class="w-full flex flex-col rounded-lg justify-between items-start mb-4 md:items-center bg-slate-100 border-b-2 border-slate-300 ">
                                  <div class="flex items-center justify-between z-30 bg-slate-100 w-full border-b border-slate-300 ">
                                    <div class="flex items-center animate-pulse ">
                                    <span class=" px-4 py-2   text-md  md:text-lg font-semibold bg-sky-400 rounded-tl-md text-slate-200"> Gidiş </span>
                                            <span class=" px-2 md:px-4  py-2 text-slate-200 text-md    md:text-lg font-semibold px-3   "> .. .. ....</span>
                                            <span class=" px-2 md:px-4 pr-7 py-2 text-slate-200 text-md  border-l border-slate-300 md:text-lg   font-semibold">... {{$t('gün')}}</span>
                                          </div>
                                          <span class="hidden md:block px-4 py-2 text-slate-200 text-md  border-l border-slate-300   md:text-lg font-semibold  ">{{$t('Dönüş')}}: .... .. ..</span>
                                  </div> 
                                    <div class="w-full grid md:gap-2 mt-2 px-3 justify-between items-start md:items-center"
                                        :class="'grid-cols-1 md:grid-cols-3'">
                                  <div class="w-full relative rounded-md border-b-slate-200 group  h-[296px] hover:bg-slate-50  cursor-pointer ring-1 ring-offset-1 ring-slate-300  mt-2 mb-3 md:my-2 border-b-0" > 
                                      <div class="animate-pulse flex space-x-4"> 
                                        <div class="flex-1 space-y-6 px-2 py-4">
                                          <div class="h-12 bg-slate-200 rounded w-3/4 "></div>
                                          <div class="h-12 bg-slate-200 rounded w-1/2 "></div>
                                          <div class="h-12 bg-slate-200 rounded w-2/3  "></div>
                                          <div class="h-12 bg-slate-200 rounded w-1/1  "></div>
                                        </div>    
                                    </div>
                                  </div>
                                  <div class="w-full relative rounded-md border-b-slate-200 group  h-[296px] hover:bg-slate-50  cursor-pointer ring-1 ring-offset-1 ring-slate-300  mt-2 mb-3 md:my-4 border-b-0" >
                                    <div class="flex-1 space-y-6 px-2 py-4">
                                          <div class="h-12 bg-slate-200 rounded w-3/4 "></div>
                                          <div class="h-12 bg-slate-200 rounded w-1/2 "></div>
                                          <div class="h-12 bg-slate-200 rounded w-2/3  "></div>
                                          <div class="h-12 bg-slate-200 rounded w-1/1  "></div>
                                        </div>    
                                  </div>
                                  <div class="w-full relative rounded-md border-b-slate-200 group  h-[296px] hover:bg-slate-50  cursor-pointer ring-1 ring-offset-1 ring-slate-300  mt-2 mb-3 md:my-4 border-b-0" >
                                    <div class="flex-1 space-y-6 px-2 py-4">
                                          <div class="h-12 bg-slate-200 rounded w-3/4 "></div>
                                          <div class="h-12 bg-slate-200 rounded w-1/2 "></div>
                                          <div class="h-12 bg-slate-200 rounded w-2/3  "></div>
                                          <div class="h-12 bg-slate-200 rounded w-1/1  "></div>
                                        </div>    
                                  </div>
                                  </div> 
                              </div> 
                            </template>
                      </div>
                    </div>
             </template> -->
            <template v-for="(dayOf, dayKey) in tours" > 
              <div v-if="hasVisibleTours(dayOf)"
                class="w-full flex flex-col justify-between items-start md:items-center group"
                :class="hasAvailableTours(dayOf) ? 'pb-2 md:py-2' : 'mb-1 mt-2'">
                <div v-if="hasAvailableTours(dayOf)" class="w-full relative flex items-center justify-between rounded-xl bg-gradient-to-r from-brand-50 via-white to-brand-50 px-3 md:px-5 py-1.5 md:py-2.5 border border-brand-200 shadow-sm">
                  <div class="flex items-center gap-3">
                    <span class="inline-flex items-center gap-2 rounded-full bg-brand-800 text-white text-xs md:text-sm font-semibold px-3 py-1.5 shadow-md">
                      <font-awesome-icon icon="fa-solid fa-plane-departure" class="h-3 w-3" />
                      {{ $t('Gidiş') }}
                    </span>
                    <span class="text-brand-900 text-sm md:text-lg font-bold tracking-tight">{{ dayOf[0].start }}</span>
                    <span class="hidden sm:inline-flex items-center gap-2 text-neutral-500 text-xs md:text-sm font-medium">
                      <span class="h-1.5 w-1.5 rounded-full bg-neutral-300"></span>
                      {{ dayOf[0].tur_Sure }} {{ $t('gün') }}
                    </span>
                    <div
                  v-if="getMatchingHolidays(dayOf[0]?.turs_StartDate, dayOf[dayOf.length - 1]?.turs_EndDate || dayOf[0]?.turs_EndDate)?.length"
                  class="w-auto "
                > 
                  <div v-if="!isMobile" class="hidden md:flex flex-wrap gap-1.5">
                    <span
                      v-for="item in getMatchingHolidays(dayOf[0]?.turs_StartDate, dayOf[dayOf.length - 1]?.turs_EndDate || dayOf[0]?.turs_EndDate)"
                      :key="`${item.baslangic}-${item.ad_tr}`"
                      class="inline-flex items-center rounded-full border border-amber-200 bg-amber-500 px-2 py-1 text-[14px] font-bold text-white shadow-sm"
                    >
                      {{ formatDate(item.baslangic, 'dd MMM') }}: {{ item.ad_tr }}
                    </span>
                  </div>
                </div>
                  </div>
                  <div class="flex items-center gap-2">
                    <span class="hidden md:inline-flex items-center gap-2 text-brand-700 text-sm font-semibold">
                      <font-awesome-icon icon="fa-solid fa-plane-arrival" class="h-3 w-3 text-brand-500" />
                      {{ $t('Dönüş') }}: {{ dayOf[0].end }}
                    </span>
                    <button
                      v-if="getComparableTours(dayOf).length > 1"
                      type="button"
                      class="hidden md:inline-flex items-center gap-1 rounded-full border border-brand-200 bg-brand-50 px-2.5 py-1 text-xs font-semibold text-brand-800 hover:bg-brand-100"
                      @click.stop.prevent="openComparisonModal(dayOf)"
                    >
                      <font-awesome-icon icon="fa-solid fa-code-compare" class="h-3 w-3" />
                      {{ getComparableTours(dayOf).length }} {{ $t('turu karşılaştır.') }}
                    </button>
                    <button
                      class="ml-1 inline-flex items-center justify-center rounded-md border border-brand-200 bg-brand-50 px-2.5 py-1.5 text-brand-800 shadow-sm hover:bg-brand-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
                      @click.stop.prevent="toggleCollapse(dayOf[0].start)"
                      :aria-expanded="!isCollapsed(dayOf[0].start)"
                      :title="isCollapsed(dayOf[0].start) ? $t('Aç') : $t('Kapat')">
                      <font-awesome-icon :icon="isCollapsed(dayOf[0].start) ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up'" class="text-sm" />
                    </button>
                  </div>
                </div>

                <div
                  v-if="hasAvailableTours(dayOf) && getComparableTours(dayOf).length > 1"
                  class="w-full md:hidden px-3 py-2 border-b border-neutral-100 bg-white/95"
                >
                  <p class="text-[12px] text-neutral-500 mb-0">
                    {{ $t('Bu tarihte') }} {{ dayOf[0]?.tur_Sure }} {{ $t('günlük') }} {{ getComparableTours(dayOf).length }} {{ $t('tur var.') }}
                    <a
                      href="javascript:void(0)"
                      class="text-brand-600 font-semibold underline underline-offset-2 hover:text-brand-800"
                      @click.stop.prevent="openComparisonModal(dayOf)"
                    >{{ $t('Turları karşılaştır') }}</a>
                  </p>
                </div>

                

                <div
                  v-show="!hasAvailableTours(dayOf) || !isCollapsed(dayOf[0].start)"
                  class="w-full grid grid-cols-1 gap-4 md:gap-6 justify-between items-start md:border-l border-neutral-200"
                  :class="hasAvailableTours(dayOf) ? 'px-1 md:pl-3 my-3' : 'mt-1'">
              <template v-for="(item, index) in dayOf">

          <div v-if="!hide[item.start] && (item.turs_status_data?.available)">
  <div v-if="isMobile" class="flex flex-wrap gap-1.5">
                    <span
                      v-for="item in getMatchingHolidays(dayOf[0]?.turs_StartDate, dayOf[dayOf.length - 1]?.turs_EndDate || dayOf[0]?.turs_EndDate)"
                      :key="`${item.baslangic}-${item.ad_tr}`"
                      class="inline-flex items-center rounded-full border border-amber-200 bg-amber-500 px-2 py-1 text-[14px] font-bold text-white shadow-sm"
                    >
                      {{ formatDate(item.baslangic, 'dd MMM') }}: {{ item.ad_tr }}
                    </span>
                  </div>
            <!-- ===== Müsait Tur Kartı ===== -->
            <div
              :id="`tour${item.pdb_Id}`"
              class="w-full relative bg-white border border-neutral-200 rounded-2xl shadow-sm group hover:shadow-lg transition-all duration-200 cursor-pointer"
              :class="[index + 1 === dayOf.length ? 'mb-3' : 'mb-0', selectedTour?.pdb_Id === item.pdb_Id ? 'ring-2 ring-emerald-500/80 border-emerald-200 bg-gradient-to-br from-emerald-50/80 via-white to-white shadow-[0_18px_38px_-24px_rgba(16,185,129,0.55)]' : '']">

              <!-- Kart kapalıyken de görünen kampanya bandı -->
              <div
                v-if="getTourCampaignTitle(item)"
                class="tour-campaign-card relative z-[2] flex min-h-[46px] items-center gap-2.5 overflow-hidden rounded-t-[15px] border-b border-amber-300/70 bg-gradient-to-r from-amber-50 via-orange-50 to-rose-50 px-3 py-2 pr-20 md:min-h-[52px] md:gap-3 md:px-4 md:py-2.5 md:pr-28"
                :aria-label="locale === 'en' ? 'Special campaign' : 'Özel kampanya'"
              >
                <span aria-hidden="true" class="absolute -right-5 -top-8 h-20 w-20 rounded-full bg-amber-300/20"></span>
                <span class="relative flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-amber-500 to-orange-600 text-white shadow-sm md:h-9 md:w-9">
                  <font-awesome-icon icon="fa-solid fa-tags" class="h-3.5 w-3.5 md:h-4 md:w-4" />
                </span>
                <span class="relative min-w-0 flex-1">
                  <span class="block text-[9px] font-extrabold uppercase tracking-[0.14em] text-orange-700 md:text-[10px]">
                    {{ locale === 'en' ? 'Special campaign' : 'Özel kampanya' }}
                  </span>
                  <span
                    class="tour-campaign-card-copy block text-xs font-bold leading-4 text-slate-900 md:text-sm md:leading-5"
                    v-html="getTourCampaignTitle(item)"
                  ></span>
                </span>
              </div>

              <!-- Durum etiketi -->
              <div class="hidden md:block rounded-full h-2.5 w-2.5 bg-neutral-300 group-hover:bg-support-500 absolute top-20 -left-[1.1em] transition-colors duration-200"></div>
              <div
                v-if="item.turs_status_data.value !== 'OPEN'"
                class="absolute right-3 z-10 px-2 py-0.5 text-[10px] font-bold rounded-full tracking-wide"
                :class="[getStatusBadgeClass(item.turs_status_data), getTourCampaignTitle(item) ? 'top-2.5 md:top-3' : '-top-3']">
                {{ item.turs_status_data.title }}
              </div>
              

              <!-- === ANA İÇERİK === -->
              <!-- ── Satır 1: Otel 1 | Otel 2 | Havayolu | Fiyat ── -->
              <div class="grid grid-cols-[1fr_1fr_120px] md:grid-cols-[1fr_176px] md:divide-x divide-neutral-100">

                <!-- Mobile: Rota + Fiyat -->
                <div class="col-span-3 row-span-2 rounded-t-2xl overflow-hidden md:hidden">
                  <!-- Üst bant: Rota bilgileri + Havayolu -->
                  <div class="flex items-stretch bg-brand-800">
                    <div class="flex-1 flex flex-col">
                      <div class="flex items-center gap-2 px-3 py-2.5">
                        <font-awesome-icon :icon="`fa-solid ${item.routes[0]?.turs_Transporter}`" class="h-3.5 w-3.5 text-white/60" />
                        <span class="text-[11px] font-semibold text-white/60 uppercase tracking-wide">{{ $t('Gidiş') }}</span>
                        <span class="text-sm font-bold text-white">
                          {{ formatDate(item.turs_StartDate, 'dd MMM, EEE') }}
                        </span>
                      </div>
                      <div class="flex items-center gap-2 px-3 py-1 bg-brand-700/40">
                        <font-awesome-icon :icon="`fa-solid ${item.routes[1]?.turs_Transporter}`" class="h-3 w-3 text-brand-200" />
                        <span class="text-[12px] font-semibold text-brand-200">
                          {{ formatDate(item.routes[1]?.turs_Date, 'dd MMM, EEE') }}
                        </span>
                        <span class="text-[11px] text-yellow-100 truncate flex justify-center items-center font-semibold"
                          :class="item.routes[1]?.turs_Transporter == 'fa-train' ? '!text-accent-100' : item.routes[1]?.turs_Transporter == 'fa-bus' ? '!text-accent-300' : ''">
                          <template v-if="item.routes[1]?.turs_Transporter == 'fa-train'">
                            <img src="/assets/img/svg/train-speed.svg" alt="train" class="h-5 w-5 mr-1 fill-white text-white brightness-0 invert opacity-70"/>
                          </template> 
                          <template v-if="item.routes[1]?.turs_Transporter == 'fa-bus'">  </template>
                          <!-- {{ item.routes[1]?.turs_CityStart?.tr }} → {{ item.routes[1]?.turs_CityEnd?.tr }} -->
                            Hızlı Trenle
                        </span>
                      </div>
                      <div class="flex items-center gap-2 px-3 py-2 bg-brand-900/30">
                        <font-awesome-icon :icon="`fa-solid ${item.routes[item.routes.length-1]?.turs_Transporter}`" class="h-3 w-3 text-brand-300" />
                        <span class="text-[11px] font-semibold text-brand-300 uppercase tracking-wide">{{ $t('Dönüş') }}</span>
                        <span class="text-[13px] font-bold text-white/90">
                          {{ formatDate(item.turs_EndDate, 'dd MMM, EEE') }}
                        </span>
                      </div>
                    </div>
                    <div class="flex flex-col items-center justify-center px-2 border-l border-white/10 bg-brand-900/20 min-w-[68px]">
                     <span v-if="item && item.airwayName && item.airwayName.en == 'Turkish Airlines'" class="flex flex-col border-b border-b-red-700 items-center gap-0.5">
                        <img src="/assets/img/logo/thy.webp" style="height:26px;" alt="Turkish Airlines" class="" />
                        <span class="text-white font-bold text-[8px]">TURKISH AIRLINES</span>
                      </span>
                      <template v-else>
                          <img :src="showImage(item.airwayLogo, '', 24, '', '', '')" style="height:22px;" alt="airway" class="brightness-0 invert opacity-70" />
                      
                      </template>
                      
                      <span class="text-xl font-extrabold text-white mt-1.5 leading-none">{{ item.tur_Sure }}</span>
                      <span class="text-[9px] text-brand-300 font-medium">{{ $t('gün') }}</span>
                    </div>
                  </div>
                  <!-- Alt bant: Fiyat -->
                  <div class="flex items-center justify-between px-3 py-2.5 bg-white border-b border-neutral-200">
                    <!-- Sol: Toplam + kişi özeti (tıklanabilir) -->
                     <div class="text-black text-xs">
                        ✓ Yüksek hızlı tren ile<br />
                        <span class="text-teal-800">✓ Seçkin rehberlik hizmeti </span><br />
                        ✓ Ailelere özel paketler<br />
                      </div>  
                    <!-- <button
                      type="button"
                      @click.stop.prevent="toggleListPeopleEditor(item.pdb_Id)"
                      class="flex flex-col min-w-0 text-left group/edit"
                    >
                      <div v-if="getTourTotal(item, reservation) > 0" class="flex items-baseline gap-1">
                        <span class="text-lg font-extrabold text-brand-800 leading-none">{{ formatMoney(getTourTotal(item, reservation)) }}</span>
                        <span class="text-[10px] font-bold text-brand-500">{{ item.tour_Currency }}</span>
                      </div>
                      <div class="flex items-center gap-1 mt-0.5">
                        <font-awesome-icon icon="fa-solid fa-pen" class="h-2 w-2 text-brand-400 group-hover/edit:text-brand-600 transition-colors" />
                        <span v-if="getTourTotal(item, reservation) > 0" class="text-[10px] text-neutral-400 truncate group-hover/edit:text-brand-600 transition-colors">
                          {{ previewPeopleLabel }}
                        </span>
                        <span v-else class="text-[11px] text-neutral-400 group-hover/edit:text-brand-600 transition-colors">{{ $t('Kişi seçin') }}</span>
                      </div>
                    </button> -->
                    <!-- Sağ: Kişi başı fiyat -->
                    <div class="flex flex-col items-end shrink-0 pl-3">
                      <span class="text-[11px] text-neutral-400 line-through leading-none"
                        v-if="item.turs_double_high && item.turs_double != item.turs_double_high">
                        {{ formatMoney(item.turs_double_high) }}
                      </span>
                      <div class="flex items-baseline gap-0.5">
                        <span class="text-2xl font-extrabold leading-none tracking-tight"
                          :class="item.turs_double_high && item.turs_double != item.turs_double_high ? 'text-support-600' : 'text-neutral-900'">
                          {{ formatMoney(item.turs_double) }}
                        </span>
                        <span class="text-[10px] font-bold text-neutral-400">{{ item.tour_Currency }}</span>
                      </div>
                      <span class="text-[9px] text-neutral-400 mt-0.5">{{ $t('kişi başı') }}</span>
                    </div>
                  </div>
                  <!-- Kişi düzenleyici -->
                  <div v-if="listPeopleEditorTourId === item.pdb_Id" class="col-span-2 border-b border-neutral-200 bg-white p-2.5">
                        <div class="flex items-center gap-1.5 mb-1.5 px-1 text-[9px] font-semibold text-neutral-400 uppercase tracking-wide">
                          <span class="w-12"></span>
                          <span class="min-w-[42px] text-center">{{ $t('Yetişkin') }}</span>
                          <span class="min-w-[42px] text-center">{{ $t('Çocuk') }}</span>
                          <span class="min-w-[42px] text-center">{{ $t('Bebek') }}</span>
                        </div>
                        <div class="space-y-1.5 max-h-[130px] overflow-auto pr-1">
                          <div
                            v-for="(room, roomIdx) in reservation.rooms"
                            :key="`mobile_room_edit_${roomIdx}`"
                            class="flex items-center gap-1.5 rounded-lg border border-neutral-200 bg-neutral-50 px-2 py-1"
                          >
                            <span class="w-12 text-[10px] font-semibold text-neutral-600">{{ roomIdx + 1 }}. {{ $t('Oda') }}</span>
                            <select v-model.number="room.adult" class="h-7 min-w-[42px] rounded-md border border-neutral-300 bg-white px-1 text-[11px]">
                              <option v-for="n in 3" :key="`mr_adult_${roomIdx}_${n}`" :value="n">{{ n }}</option>
                            </select>
                            <select v-model.number="room.child" class="h-7 min-w-[42px] rounded-md border border-neutral-300 bg-white px-1 text-[11px]">
                              <option v-for="n in 4" :key="`mr_child_${roomIdx}_${n}`" :value="n - 1">{{ n - 1 }}</option>
                            </select>
                            <select v-model.number="room.baby" class="h-7 min-w-[42px] rounded-md border border-neutral-300 bg-white px-1 text-[11px]">
                              <option v-for="n in 4" :key="`mr_baby_${roomIdx}_${n}`" :value="n - 1">{{ n - 1 }}</option>
                            </select>
                            <button
                              v-if="roomIdx !== 0"
                              type="button"
                              @click.stop.prevent="removeRoom(roomIdx)"
                              class="ml-auto text-rose-500 hover:text-rose-600"
                            >
                              <font-awesome-icon icon="fa-solid fa-trash" class="h-3 w-3" />
                            </button>
                          </div>
                        </div>

                        <div v-if="totalKidsCount > 0" class="mt-2 border-t border-neutral-200 pt-2">
                          <p class="mb-1.5 text-[9px] font-semibold uppercase tracking-wide text-neutral-400">{{ $t('Çocuk Yaşları ve Yatak') }}</p>
                          <div class="space-y-1.5 max-h-[145px] overflow-auto pr-1">
                            <div
                              v-for="(age, ageIdx) in reservation.childrenAges"
                              :key="`mobile_age_edit_${ageIdx}`"
                              class="rounded-md border border-neutral-200 bg-neutral-50 px-1.5 py-1"
                            >
                              <div class="flex items-center gap-1.5">
                                <span class="text-[10px] text-neutral-500">{{ ageIdx + 1 }}.</span>
                                <select v-model="reservation.childrenAges[ageIdx]" @change="onSidebarChildAgeChange(ageIdx)" class="h-6 min-w-[64px] rounded border border-neutral-300 bg-white px-1 text-[10px]">
                                  <option value="">{{ $t('Yaş seç') }}</option>
                                  <option v-for="n in 18" :key="`mobile_age_${ageIdx}_${n}`" :value="n - 1">{{ n - 1 === 0 ? '0 (' + $t('bebek') + ')' : (n - 1) + ' ' + $t('yaş') }}</option>
                                </select>
                                <button
                                  type="button"
                                  class="inline-flex items-center gap-1 rounded border border-neutral-300 bg-white px-1.5 py-1 text-[9px] font-semibold text-neutral-600"
                                  @click="toggleSidebarChildBedPanel(ageIdx)"
                                >
                                  <font-awesome-icon icon="fa-solid fa-bed" class="h-2.5 w-2.5" />
                                  {{ getSidebarChildBedLabel(ageIdx) }}
                                </button>
                                <button type="button" @click.stop.prevent="removeChildAge(ageIdx)" class="ml-auto text-rose-500 hover:text-rose-600">
                                  <font-awesome-icon icon="fa-solid fa-xmark" class="h-3 w-3" />
                                </button>
                              </div>

                              <div v-if="sidebarChildBedPanelOpen[ageIdx]" class="mt-1.5 grid grid-cols-2 gap-1">
                                <button
                                  v-for="opt in getSidebarChildBedOptionsByIndex(ageIdx)"
                                  :key="`mobile_bed_${ageIdx}_${opt.key}`"
                                  type="button"
                                  @click="selectSidebarChildBedOption(ageIdx, opt.key)"
                                  class="rounded border px-1.5 py-1 text-left"
                                  :class="sidebarChildBedChoices[ageIdx] === opt.key ? 'border-sky-300 bg-sky-50' : 'border-neutral-200 bg-white'"
                                >
                                  <div class="flex items-center gap-1.5">
                                    <div class="flex h-6 w-8 items-center justify-center rounded bg-slate-100">
                                      <svg v-if="opt.kind === 'turBaby'" viewBox="0 0 40 20" class="h-4 w-7">
                                        <rect x="2" y="2" width="36" height="16" rx="4" fill="#dbeafe" stroke="#60a5fa" stroke-width="1.2"/>
                                        <line x1="8" y1="2" x2="8" y2="18" stroke="#93c5fd" stroke-width="1"/>
                                        <line x1="16" y1="2" x2="16" y2="18" stroke="#93c5fd" stroke-width="1"/>
                                        <line x1="24" y1="2" x2="24" y2="18" stroke="#93c5fd" stroke-width="1"/>
                                        <line x1="32" y1="2" x2="32" y2="18" stroke="#93c5fd" stroke-width="1"/>
                                      </svg>
                                      <svg v-else-if="opt.kind === 'turChild'" viewBox="0 0 40 20" class="h-4 w-7">
                                        <rect x="3" y="3" width="34" height="14" rx="4" fill="#d1fae5" stroke="#34d399" stroke-width="1.2"/>
                                        <rect x="6" y="5" width="10" height="5" rx="2" fill="#ecfdf5"/>
                                        <path d="M6 13 Q20 9 34 13" fill="none" stroke="#6ee7b7" stroke-width="1.6"/>
                                      </svg>
                                      <svg v-else viewBox="0 0 40 20" class="h-4 w-7">
                                        <rect x="2" y="3" width="36" height="14" rx="4" fill="#fde68a" stroke="#f59e0b" stroke-width="1.2"/>
                                        <rect x="5" y="5" width="10" height="5" rx="2" fill="#fffbeb"/>
                                        <rect x="25" y="5" width="10" height="5" rx="2" fill="#fffbeb"/>
                                      </svg>
                                    </div>
                                    <div>
                                      <p class="mb-0 leading-2 text-[9px] font-semibold text-neutral-700 mb-0">{{ locale === 'tr' ? opt.labelTr : opt.labelEn }}</p>
                                      <p class="mb-0 leading-2 text-[8px] text-neutral-500 mb-0">{{ locale === 'tr' ? opt.descTr : opt.descEn }}</p>
                                    </div>
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="mt-2 flex items-center justify-between gap-2">
                          <button type="button" @click.stop.prevent="addRoom" class="h-7 px-2 rounded-md border border-dashed border-neutral-300 text-[11px] font-semibold text-neutral-700 hover:bg-neutral-100">+ {{ $t('Oda') }}</button>
                          
                              <div class="flex items-center gap-2">
                                      <button type="button" @click.stop.prevent="resetPeopleSelection"
                                        class="h-7 px-2 rounded-md border border-neutral-300 text-[11px] font-semibold text-neutral-700 hover:bg-neutral-100">{{
                                        $t('Sıfırla') }}</button>
                                      <button type="button" @click.stop.prevent="toggleListPeopleEditor(item.pdb_Id)"
                                        class="h-7 px-2 rounded-md border border-red-300 text-[11px] font-semibold text-red-700 hover:bg-red-100">{{
                                        $t('Kapat') }}</button>
                                    </div>
         
                        </div>
                  </div>
                </div>
                <div class="hidden col-span-3 rounded-t-2xl border-b border-neutral-200 bg-gradient-to-r from-neutral-200 via-white to-neutral-50 px-4 pt-2 pb-2 md:col-span-2 md:block">
                  <div class="grid grid-cols-5 gap-2 items-center">
                    <div class="min-w-0">
                      <p class="mb-0 text-[10px] font-semibold uppercase tracking-wide text-neutral-500">{{ $t('Gidiş') }}</p>
                      <p class="mb-0 text-sm font-bold text-neutral-800 truncate">{{ formatDate(item.turs_StartDate, 'dd MMM, EEE') }}</p>
                         <span   class="text-[11px] text-slate-700 flex items-center" >
                                   {{ item.routes[0]?.turs_CityStart?.tr }} → {{ item.routes[0]?.turs_CityEnd?.tr }}            
                          </span> 
                    </div>
                    <div class="min-w-0">
                      <p class="mb-0 text-[10px] font-semibold uppercase tracking-wide text-neutral-500">  {{ item.routes[1]?.turs_CityStart?.tr }} → {{ item.routes[1]?.turs_CityEnd?.tr }}
                       
                      </p>
                      <p class="mb-0 text-sm font-bold text-neutral-800 truncate mt-0 leading-4">{{ formatDate(item.routes[1]?.turs_Date, 'dd MMM, EEE') }} 
                        </p> 
                          <span v-if="item.routes[1]?.turs_Transporter == 'fa-train'" class="text-[11px] font-semibold text-teal-700 pl-0.5 flex items-center" >
                            <img src="/assets/img/svg/train-speed.svg" alt="train" class="h-4 w-4 mr-1"/>
                            Hızlı Trenle
                          </span>
                     
                    </div>
                    <div class="min-w-0">
                      <p class="mb-0 text-[10px] font-semibold uppercase tracking-wide text-neutral-500">{{ $t('Dönüş') }}</p>
                      <p class="mb-0 text-sm font-bold text-neutral-800 truncate ">{{ formatDate(item.turs_EndDate, 'dd MMM, EEE') }}</p>
                      <span   class="text-[11px] text-slate-700 flex items-center" >
                                   {{ item.routes[2]?.turs_CityStart?.tr }} → {{ item.routes[2]?.turs_CityEnd?.tr }}            
                          </span> 
                    </div>
                    <div class="min-w-0">
                      <p class="mb-0 text-[10px] font-semibold uppercase tracking-wide text-neutral-500">{{ $t('Süre') }}</p>
                      <p class="mb-0 text-sm font-bold text-accent-700 truncate">{{ item.tur_Sure }} {{ $t('gün') }}</p>
                    </div>
                    <div class="min-w-0 flex justify-end items-center gap-2">
                      <button
                        type="button"
                        @click.stop.prevent="toggleCardCompact(item.pdb_Id)"
                        class="inline-flex h-7 w-7 items-center justify-center rounded-full border border-brand-200 bg-brand-50 text-brand-800 shadow-sm hover:bg-brand-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
                        :title="isCardCompact(item.pdb_Id) ? $t('Detaylı Gör') : $t('Kompakt Gör')"
                        :aria-expanded="!isCardCompact(item.pdb_Id)"
                      >
                        <font-awesome-icon :icon="isCardCompact(item.pdb_Id) ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up'" class="text-xs" />
                      </button>
                      <img :src="showImage(item.airwayLogo, '', 24, '', '', '')" style="height:18px;" alt="airway" class="opacity-90" />
                    </div>
                  </div>
                </div>

                <!-- Oteller -->
                <div v-if="!isCardCompact(item.pdb_Id)" class="grid grid-cols-2 col-span-3 md:col-span-1">
                  <!-- Otel başlık -->
                  <div class="hidden md:flex col-span-2  justify-between items-center font-semibold px-4 text-sm pt-3 pb-2 border-b border-neutral-100">
                    <span class="text-brand-700 tracking-wide text-xs font-bold uppercase">{{ $t('Oteller') }}</span>
                    <span class="flex items-center gap-0.5">
                      <font-awesome-icon v-for="n in 5" :key="n" icon="fa-solid fa-star" class="h-2.5 w-2.5 text-accent-400" />
                    </span>
                  </div>

                  <!-- Otel 1 -->
                  <div class="flex flex-col border-r border-slate-200 bg-white md:border-r-0 border-b">
                    <div class="flex flex-col items-start py-2 px-4 md:flex-wrap md:border-r border-slate-200 overflow-hidden">
                      <span v-if="item.otel1?.city?.[locale] || item.otel1?.city?.tr" class="text-[11px] md:text-xs font-semibold text-slate-600">
                        {{ item.otel1?.city?.[locale] || item.otel1?.city?.tr }} / {{ item.turs_otel1_sure }} {{ $t('gece') }}
                      </span>
                      <span v-html="item.otel1_adi?.[locale] || item.otel1_adi?.tr" class="text-[13px] md:text-base font-semibold truncate max-w-full text-slate-800"></span>
                    </div>
                    <div class="flex items-start gap-3 px-4 pb-3 pt-1">
                      <div class="relative group/h1 shrink-0">
                        <NuxtImg
                          class="rounded-xl object-cover ring-2 ring-offset-1 ring-accent-300 shadow-sm"
                          :loading="index <= 4 ? 'eager' : 'lazy'"
                          :decoding="index <= 4 ? 'sync' : 'async'"
                          :src="showImage(item.otel1_photo, isMobile ? 54 : 68, isMobile ? 54 : 68, true, '', '')"
                          :alt="item.otel1_adi?.tr"
                          :style="{ width: isMobile ? '54px' : '64px', height: isMobile ? '54px' : '64px' }"
                        />
                      </div>
                      <div class="flex-1 min-w-0 pt-0.5">
                        <div class="flex flex-col items-start gap-1 flex-wrap text-xs md:text-sm">
                          <span v-if="item.hotels?.[0]?.star?.[locale] || item.hotels?.[0]?.star?.tr"
                            class="font-bold text-accent-500 leading-none">
                            {{ item.hotels?.[0]?.star?.[locale] || item.hotels?.[0]?.star?.tr }}
                          </span>
                          <span v-if="item.hotels?.[0]?.sOtelShort?.[locale] || item.hotels?.[0]?.sOtelShort?.tr" class="text-neutral-500 leading-none">
                            {{ item.hotels?.[0]?.sOtelShort?.[locale] || item.hotels?.[0]?.sOtelShort?.tr }}
                          </span>
                          <a @click.stop.prevent="openSidebar(item.hotels?.[0])" class="flex font-semibold text-brand-600 items-center hover:text-brand-800 hover:underline transition-colors cursor-pointer">
                            <font-awesome-icon icon="fa-solid fa-magnifying-glass" class="h-2.5 w-2.5 mr-1" />
                            {{ $t('Oteli İncele') }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Otel 2 -->
                  <div class="flex flex-col border-slate-200 border-b">
                    <div class="flex flex-col items-start py-2 px-4 bg-white md:flex-wrap overflow-hidden">
                      <span v-if="item.otel2?.city?.[locale] || item.otel2?.city?.tr" class="text-[11px] md:text-xs font-semibold text-slate-600">
                        {{ item.otel2?.city?.[locale] || item.otel2?.city?.tr }} / {{ item.turs_otel2_sure }} {{ $t('gece') }}
                      </span>
                      <span v-html="item.otel2_adi?.[locale] || item.otel2_adi?.tr" class="text-[13px] md:text-base font-semibold truncate max-w-full text-slate-800"></span>
                    </div>
                    <div class="flex items-start gap-3 px-4 pb-3 pt-1">
                      <div class="relative group/h2 shrink-0">
                        <NuxtImg
                          class="rounded-xl object-cover ring-2 ring-offset-1 ring-accent-300 shadow-sm"
                          :loading="index <= 4 ? 'eager' : 'lazy'"
                          :decoding="index <= 4 ? 'sync' : 'async'"
                          :src="showImage(item.otel2_photo, isMobile ? 54 : 64, isMobile ? 54 : 64, true, '', '')"
                          :alt="item.otel2_adi?.tr"
                          :style="{ width: isMobile ? '54px' : '64px', height: isMobile ? '54px' : '64px' }"
                        />
                        <a @click.stop.prevent="openSidebar(item.hotels?.[1])"
                          class="absolute inset-0 flex items-end justify-center rounded-xl pb-0.5 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover/h2:opacity-100 transition-opacity">
                          <span class="text-[8px] font-bold text-white">{{ $t('Oteli İncele') }}</span>
                        </a>
                      </div>
                      <div class="flex-1 min-w-0 pt-0.5">
                        <div class="flex flex-col items-start gap-1 flex-wrap text-xs md:text-sm">
                          <span v-if="item.hotels?.[1]?.star?.[locale] || item.hotels?.[1]?.star?.tr"
                            class="font-bold text-accent-500 leading-none">
                            {{ item.hotels?.[1]?.star?.[locale] || item.hotels?.[1]?.star?.tr }}
                          </span>
                          <span v-if="item.hotels?.[1]?.sOtelShort?.[locale] || item.hotels?.[1]?.sOtelShort?.tr" class="text-neutral-500 leading-none">
                            {{ item.hotels?.[1]?.sOtelShort?.[locale] || item.hotels?.[1]?.sOtelShort?.tr }}
                          </span>
                          <a @click.stop.prevent="openSidebar(item.hotels?.[1])" class="flex font-semibold text-brand-600 items-center hover:text-brand-800 hover:underline transition-colors cursor-pointer">
                            <font-awesome-icon icon="fa-solid fa-magnifying-glass" class="h-2.5 w-2.5 mr-1" />
                            {{ $t('Oteli İncele') }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="grid grid-cols-1 col-span-3 md:col-span-1 bg-white border-b border-neutral-200">
                  <div class="flex items-center justify-between gap-2 px-3 py-2 border-b border-neutral-100">
                    <span class="text-[10px] font-semibold uppercase tracking-wide text-neutral-500">1. 
                      {{ item.otel1?.city?.[locale] || item.otel1?.city?.tr }} / {{ item.turs_otel1_sure }} {{ $t('gece') }}
                    </span>
                    <a
                      @click.stop.prevent="openSidebar(item.hotels?.[0])"
                      class="inline-flex max-w-[78%] items-center gap-1 text-xs font-semibold text-brand-700 hover:text-brand-900 hover:underline transition-colors truncate"
                    >
                      <span class="truncate" v-html="item.otel1_adi?.[locale] || item.otel1_adi?.tr"></span>
                      <font-awesome-icon icon="fa-solid fa-up-right-from-square" class="h-2.5 w-2.5 shrink-0" />
                    </a>
                  </div>
                  <div class="flex items-center justify-between gap-2 px-3 py-2">
                    <span class="text-[10px] font-semibold uppercase tracking-wide text-neutral-500">2. 
                      {{ item.otel2?.city?.[locale] || item.otel2?.city?.tr }} / {{ item.turs_otel2_sure }} {{ $t('gece') }}
                    </span>
                    <a
                      @click.stop.prevent="openSidebar(item.hotels?.[1])"
                      class="inline-flex max-w-[78%] items-center gap-1 text-xs font-semibold text-brand-700 hover:text-brand-900 hover:underline transition-colors truncate"
                    >
                      <span class="truncate" v-html="item.otel2_adi?.[locale] || item.otel2_adi?.tr"></span>
                      <font-awesome-icon icon="fa-solid fa-up-right-from-square" class="h-2.5 w-2.5 shrink-0" />
                    </a>
                  </div>
                </div>

                <!-- Desktop: Fiyat -->
                <div class="relative hidden w-full flex-col items-end justify-center border-l border-neutral-100 bg-gradient-to-br from-neutral-50 to-white px-5 py-4 md:flex md:w-[160px]">
                  <div class="flex flex-col items-end">
                    <span class="text-[13px] text-neutral-500 line-through leading-none"
                      v-if="item.turs_double_high && item.turs_double != item.turs_double_high">
                      {{ formatMoney(item.turs_double_high) }}
                    </span>
                    <div class="flex items-baseline gap-0.5">
                      <span class="text-2xl font-extrabold leading-none tracking-tight"
                        :class="item.turs_double_high && item.turs_double != item.turs_double_high ? 'text-support-600' : 'text-neutral-900'">
                        {{ formatMoney(item.turs_double) }}
                      </span>
                      <span class="text-[11px] font-bold text-neutral-400">{{ item.tour_Currency }}</span>
                    </div>
                    <span class="text-[10px] text-neutral-500 mt-1 text-right leading-tight">{{ $t('Kişi başı') }}</span>
                  </div>

                  <div
                    v-if="listPeopleEditorTourId === item.pdb_Id"
                    class="absolute right-2 top-3 z-20 w-[280px] rounded-xl border border-neutral-200 bg-white p-2.5 shadow-xl"
                  >
                    <div class="flex items-center gap-1.5 mb-1.5 px-2 text-[9px] font-semibold text-neutral-400 uppercase tracking-wide">
                      <span class="w-14"></span>
                      <span class="min-w-[46px] text-center">{{ $t('Yetişkin') }}</span>
                      <span class="min-w-[46px] text-center">{{ $t('Çocuk') }}</span>
                      <span class="min-w-[46px] text-center">{{ $t('Bebek') }}</span>
                    </div>
                    <div class="space-y-1.5 max-h-[150px] overflow-auto pr-1">
                      <div
                        v-for="(room, roomIdx) in reservation.rooms"
                        :key="`desktop_room_edit_${roomIdx}`"
                        class="flex items-center gap-1.5 rounded-lg border border-neutral-200 bg-neutral-50 px-2 py-1"
                      >
                        <span class="w-14 text-[10px] font-semibold text-neutral-600">{{ roomIdx + 1 }}. {{ $t('Oda') }}</span>
                        <select v-model.number="room.adult" class="h-7 min-w-[46px] rounded-md border border-neutral-300 bg-white px-1 text-[11px]">
                          <option v-for="n in 3" :key="`dr_adult_${roomIdx}_${n}`" :value="n">{{ n }}</option>
                        </select>
                        <select v-model.number="room.child" class="h-7 min-w-[46px] rounded-md border border-neutral-300 bg-white px-1 text-[11px]">
                          <option v-for="n in 4" :key="`dr_child_${roomIdx}_${n}`" :value="n - 1">{{ n - 1 }}</option>
                        </select>
                        <select v-model.number="room.baby" class="h-7 min-w-[46px] rounded-md border border-neutral-300 bg-white px-1 text-[11px]">
                          <option v-for="n in 4" :key="`dr_baby_${roomIdx}_${n}`" :value="n - 1">{{ n - 1 }}</option>
                        </select>
                        <button
                          v-if="roomIdx !== 0"
                          type="button"
                          @click.stop.prevent="removeRoom(roomIdx)"
                          class="ml-auto text-rose-500 hover:text-rose-600"
                        >
                          <font-awesome-icon icon="fa-solid fa-trash" class="h-3 w-3" />
                        </button>
                      </div>
                    </div>

                    <div v-if="totalKidsCount > 0" class="mt-2 border-t border-neutral-200 pt-2">
                      <p class="text-[9px] font-semibold text-neutral-400 uppercase tracking-wide mb-1.5">{{ $t('Çocuk Yaşları ve Yatak') }}</p>
                      <div class="space-y-1.5 max-h-[170px] overflow-auto pr-1">
                        <div
                          v-for="(age, ageIdx) in reservation.childrenAges"
                          :key="`desktop_age_edit_${ageIdx}`"
                          class="rounded-md border border-neutral-200 bg-neutral-50 px-1.5 py-1"
                        >
                          <div class="flex items-center gap-1">
                            <span class="text-[10px] text-neutral-500">{{ ageIdx + 1 }}.</span>
                            <select v-model="reservation.childrenAges[ageIdx]" @change="onSidebarChildAgeChange(ageIdx)" class="h-6 min-w-[60px] rounded border border-neutral-300 bg-white px-1 text-[10px]">
                              <option value="">{{ $t('Yaş seç') }}</option>
                              <option v-for="n in 18" :key="`desk_age_${ageIdx}_${n}`" :value="n - 1">{{ n - 1 === 0 ? '0 (' + $t('bebek') + ')' : (n - 1) + ' ' + $t('yaş') }}</option>
                            </select>
                            <button
                              type="button"
                              class="inline-flex items-center gap-1 rounded border border-neutral-300 bg-white px-1.5 py-1 text-[9px] font-semibold text-neutral-600"
                              @click="toggleSidebarChildBedPanel(ageIdx)"
                            >
                              <font-awesome-icon icon="fa-solid fa-bed" class="h-2.5 w-2.5" />
                              {{ getSidebarChildBedLabel(ageIdx) }}
                            </button>
                            <button type="button" @click.stop.prevent="removeChildAge(ageIdx)" class="ml-auto text-rose-500 hover:text-rose-600">
                              <font-awesome-icon icon="fa-solid fa-xmark" class="h-3 w-3" />
                            </button>
                          </div>
                          <div v-if="sidebarChildBedPanelOpen[ageIdx]" class="mt-1 grid grid-cols-2 gap-1">
                            <button
                              v-for="opt in getSidebarChildBedOptionsByIndex(ageIdx)"
                              :key="`desk_bed_${ageIdx}_${opt.key}`"
                              type="button"
                              @click="selectSidebarChildBedOption(ageIdx, opt.key)"
                              class="rounded border px-1.5 py-1 text-left"
                              :class="sidebarChildBedChoices[ageIdx] === opt.key ? 'border-sky-300 bg-sky-50' : 'border-neutral-200 bg-white'"
                            >
                              <div class="flex items-center gap-1.5">
                                <div class="flex h-6 w-8 items-center justify-center rounded bg-slate-100">
                                  <svg v-if="opt.kind === 'turBaby'" viewBox="0 0 40 20" class="h-4 w-7">
                                    <rect x="2" y="2" width="36" height="16" rx="4" fill="#dbeafe" stroke="#60a5fa" stroke-width="1.2"/>
                                    <line x1="8" y1="2" x2="8" y2="18" stroke="#93c5fd" stroke-width="1"/>
                                    <line x1="16" y1="2" x2="16" y2="18" stroke="#93c5fd" stroke-width="1"/>
                                    <line x1="24" y1="2" x2="24" y2="18" stroke="#93c5fd" stroke-width="1"/>
                                    <line x1="32" y1="2" x2="32" y2="18" stroke="#93c5fd" stroke-width="1"/>
                                  </svg>
                                  <svg v-else-if="opt.kind === 'turChild'" viewBox="0 0 40 20" class="h-4 w-7">
                                    <rect x="3" y="3" width="34" height="14" rx="4" fill="#d1fae5" stroke="#34d399" stroke-width="1.2"/>
                                    <rect x="6" y="5" width="10" height="5" rx="2" fill="#ecfdf5"/>
                                    <path d="M6 13 Q20 9 34 13" fill="none" stroke="#6ee7b7" stroke-width="1.6"/>
                                  </svg>
                                  <svg v-else viewBox="0 0 40 20" class="h-4 w-7">
                                    <rect x="2" y="3" width="36" height="14" rx="4" fill="#fde68a" stroke="#f59e0b" stroke-width="1.2"/>
                                    <rect x="5" y="5" width="10" height="5" rx="2" fill="#fffbeb"/>
                                    <rect x="25" y="5" width="10" height="5" rx="2" fill="#fffbeb"/>
                                  </svg>
                                </div>
                                <div>
                                  <p class="mb-0 text-[9px] font-semibold text-neutral-700">{{ locale === 'tr' ? opt.labelTr : opt.labelEn }}</p>
                                  <p class="mb-0 text-[8px] text-neutral-500">{{ locale === 'tr' ? opt.descTr : opt.descEn }}</p>
                                </div>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="mt-2 flex items-center justify-between gap-2">
                      <button type="button" @click.stop.prevent="addRoom" class="h-7 px-2 rounded-md border border-dashed border-neutral-300 text-[11px] font-semibold text-neutral-700 hover:bg-neutral-100">+ {{ $t('Oda') }}</button>
                      <div class="flex gap-2">
                          <button type="button" @click.stop.prevent="resetPeopleSelection" class="h-7 px-2 rounded-md border border-neutral-300 text-[11px] font-semibold text-neutral-700 hover:bg-neutral-100">{{ $t('Sıfırla') }}</button>
                          <button type="button" @click.stop.prevent="toggleListPeopleEditor(item.pdb_Id)" class="h-7 px-2 rounded-md border border-red-300 text-[11px] font-semibold text-red-700 hover:bg-red-100">{{ $t('Kapat') }}</button>
                      </div> 
                      </div> 
                  </div>
                </div>

                <!-- Bilgi etiketleri -->
                <div v-if="!isCardCompact(item.pdb_Id) && (item.colorful_title?.[locale] || item.turd_Short?.[locale])"
                  class="flex flex-wrap col-span-3 md:col-span-2 items-center gap-1.5 px-2 md:px-4 py-2 border-t border-neutral-100 bg-neutral-50/40">
                  <span v-if="item.colorful_title?.[locale]" v-html="item.colorful_title?.[locale]"
                    class="text-[10px] md:text-xs font-medium rounded-md px-2 py-1 border"
                    :class="getInfoBadgeClass(item.turd_Color)">
                  </span>
                  <span v-if="item.turd_Short?.[locale]" v-html="item.turd_Short?.[locale]"
                    class="text-[10px] md:text-xs text-support-700 font-bold py-1"></span>
                </div>
              </div>

              <TourGuideRoster :guides="item.guides" :locale="locale" compact />

              <!-- Butonlar -->
              <div class="flex flex-wrap items-center justify-between gap-1.5 border-t border-neutral-200/60 px-3 py-2 bg-gradient-to-r from-neutral-50/80 to-white" :class="narrationOpenTourId === item.pdb_Id ? '' : 'rounded-b-2xl'">
                <div class="flex items-center gap-1.5">
                  <div class="flex items-center gap-1">
                    <GlobalShare
                      :show-title="false"
                      :title="`${item.otel1_adi?.tr || ''} / ${item.otel2_adi?.tr || ''}`"
                      :url="`/tourDetail/${item.pdb_Id}`"
                      size="sm"
                    />
                    <button type="button"
                     class="h-8 w-8 p-2 flex items-center justify-center rounded-full border transition-colors"
                     @click.stop.prevent="togglePrintSelect(item)"
                     :aria-label="isPrintSelected(item.pdb_Id) ? 'PDF seçiminden çıkar' : 'PDF için tur seç'"
                     :class="isPrintSelected(item.pdb_Id) ? 'border-accent-400 bg-accent-50 text-accent-700' : 'border-neutral-200 bg-white text-neutral-500'">
                      <font-awesome-icon :icon="isPrintSelected(item.pdb_Id) ? 'fa-solid fa-check' : 'fa-solid fa-print'" class="h-2.5 w-2.5" />
                    </button>
                  </div>
                  <a :href="buildWhatsAppUrl(`Merhaba ${item.start} tarihli ${item.tur_Sure} günlük, ${item.otel1_adi?.tr || ''}, ${item.otel2_adi?.tr || ''} turunuz hakkında bilgi almak istiyorum.`)"
                    target="_blank" rel="nofollow noopener noreferrer"
                    :aria-label="locale === 'en' ? 'Get tour information via WhatsApp' : 'WhatsApp ile tur hakkında bilgi alın'"
                    :title="locale === 'en' ? 'Get tour information via WhatsApp' : 'WhatsApp ile tur hakkında bilgi alın'"
                    class="whatsappTrigger w-8 h-8 p-1 flex items-center justify-center rounded-full bg-support-600 text-white text-xs font-semibold hover:bg-support-500 shadow-sm gap-1">
                    <font-awesome-icon icon="fa-brands fa-whatsapp" class="h-5 w-5" />
                   
                  </a>
                </div>
                <button
                  v-if="getTourNarrationMedia(item)"
                  type="button"
                  class="order-3 basis-full h-10 w-full px-3 inline-flex items-center justify-center rounded-xl border border-violet-200 bg-violet-50 text-violet-700 hover:bg-violet-100 text-xs font-semibold gap-2 md:order-2 md:h-8 md:w-auto md:basis-auto md:rounded-full md:px-2.5 md:text-[11px]"
                  @click.stop.prevent="toggleTourNarration(item)"
                >
                  <font-awesome-icon :icon="getTourNarrationMedia(item)?.type === 'video' ? 'fa-solid fa-circle-play' : 'fa-solid fa-volume-high'" class="h-3.5 w-3.5 md:h-3 md:w-3" />
                  {{ narrationOpenTourId === item.pdb_Id ? 'Kapat' : 'Turu Anlat' }}
                </button>
                <div class="order-2 flex items-center gap-1.5 md:order-3">
                  <a @click.stop.prevent="openQuickTourDetail(item)" href="javascript:void(0)"
                    class="h-8 px-2.5 flex items-center rounded-full border border-brand-200 bg-white text-brand-700 hover:bg-brand-50 text-[11px] font-semibold gap-1">
                    <font-awesome-icon icon="fa-solid fa-magnifying-glass" class="h-2.5 w-2.5" />
                    {{ $t('Hızlı İncele') }}
                  </a>
                  <a :href="getPath('/tourDetail/' + item.pdb_Id)" @click.stop.prevent="goPath('/tourDetail/' + item.pdb_Id)"
                    class="h-8 px-3 flex items-center rounded-full border border-sky-200 bg-teal-700 text-white hover:bg-slate-800 text-sm font-semibold shadow-sm gap-1">
                    <font-awesome-icon icon="fa-solid fa-chevron-right" class="h-2.5 w-2.5" />
                    {{ $t('Detaylar') }}
                  </a>
                </div>
              </div>
              <Teleport to="body">
                <div
                  v-if="narrationOpenTourId === item.pdb_Id && getTourNarrationMedia(item)"
                  class="fixed bottom-4 right-4 z-[70] w-[min(92vw,32rem)] max-h-[calc(100vh-2rem)] overflow-auto rounded-2xl border border-violet-200 bg-white p-4 shadow-2xl shadow-slate-900/25"
                  role="dialog"
                  aria-modal="true"
                  @click.stop
                >
                  <div class="mb-3 flex items-center justify-between gap-3">
                    <span class="text-sm font-bold text-violet-950">
                      {{ getTourNarrationMedia(item)?.type === 'video' ? 'Tur tanıtım videosu' : 'Tur sesli anlatımı' }}
                      <span class="mt-1 flex items-center gap-1 text-[10px] font-medium text-violet-500">
                        <font-awesome-icon icon="fa-solid fa-robot" class="h-3 w-3" />
                        Yapay zeka ile oluşturulmuştur.
                      </span>
                    </span>
                    <button
                      type="button"
                      class="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-violet-100 text-violet-800 shadow-sm transition-colors hover:bg-violet-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-500 focus-visible:ring-offset-2"
                      aria-label="Kapat"
                      title="Kapat"
                      @click.stop.prevent="narrationOpenTourId = ''"
                    >
                      <font-awesome-icon icon="fa-solid fa-xmark" class="h-6 w-6" />
                    </button>
                  </div>
                  <video
                    v-if="getTourNarrationMedia(item)?.type === 'video'"
                    :key="`narration-video-${getTourNarrationMedia(item)?.src}`"
                    :src="getTourNarrationMedia(item)?.src"
                    controls
                    autoplay
                    playsinline
                    preload="metadata"
                    class="max-h-[70vh] w-full rounded-xl bg-black object-contain"
                  ></video>
                  <audio
                    v-else
                    :key="`narration-audio-${getTourNarrationMedia(item)?.src}`"
                    :src="getTourNarrationMedia(item)?.src"
                    controls
                    autoplay
                    preload="metadata"
                    class="w-full"
                  ></audio>
                </div>
              </Teleport>
            </div>
          </div>
          <div
            v-else-if="!hide[item.start] && item.turs_status_data?.value === 'FULL'"
            class="relative z-0 w-full border border-slate-200 bg-gradient-to-r from-slate-50 via-white to-slate-50 px-3 py-2.5 shadow-[0_8px_20px_-16px_rgba(15,23,42,.48)] transition-colors hover:border-slate-300"
            :class="[
              index > 0 && dayOf[index - 1]?.turs_status_data?.value === 'FULL' ? '-mt-[17px] rounded-t-none border-t-0 md:-mt-[25px]' : 'rounded-t-xl',
              index < dayOf.length - 1 && dayOf[index + 1]?.turs_status_data?.value === 'FULL' ? 'rounded-b-none' : 'rounded-b-xl'
            ]"
          >
            <div class="flex min-h-[42px] flex-wrap items-center gap-x-3 gap-y-1.5 md:flex-nowrap md:gap-x-4">
              <div class="flex shrink-0 items-center gap-2 md:border-r md:border-slate-200 md:pr-4">
                <span class="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-sky-200/90 bg-sky-50 text-sky-700 shadow-sm">
                  <font-awesome-icon icon="fa-solid fa-plane-departure" class="h-3.5 w-3.5" />
                </span>
                <div class="leading-tight">
                  <p class="mb-0 text-[9px] leading-1 font-bold uppercase tracking-[.1em] text-slate-400">{{ $t('Gidiş') }}</p>
                  <p class="mb-0 whitespace-nowrap text-sm font-extrabold tracking-tight text-slate-800 md:text-[15px]">
                    {{ item.start }} <span class="ml-1 text-[11px] font-semibold text-slate-400">•</span> <span class="text-[11px] font-semibold text-slate-500">{{ item.tur_Sure }} {{ $t('gün') }}</span>
                  </p>
                </div>
              </div>
              <span class="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-slate-300 bg-slate-100 px-2 py-1 text-[10px] font-extrabold uppercase tracking-[.1em] text-slate-600">
                <font-awesome-icon icon="fa-solid fa-lock" class="h-2.5 w-2.5 text-sky-600" />
                {{ locale === 'en' ? 'Sold out' : 'Dolu' }}
              </span>
              <p class="mb-0 min-w-[120px] text-xs font-medium text-slate-600 md:flex-1">
                {{ locale === 'en' ? 'This departure is no longer available.' : 'Bu program satışa kapanmıştır. Teşekkürler.' }}
              </p>
              <div class="ml-auto flex min-w-0 items-center gap-2 text-[11px] font-semibold text-slate-500">
                <span class="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-slate-100 px-2 py-1">
                  <font-awesome-icon icon="fa-solid fa-plane-arrival" class="h-3 w-3 text-slate-400" />
                  <span class="hidden sm:inline">{{ $t('Dönüş') }}:</span> {{ formatDate(item.turs_EndDate, 'dd MMM') }}
                </span>
              </div>
            </div>
          </div>

          </template>
          </div>
        </div>
            </template>

            <div
              v-if="isMobile && hasActiveTourFilters && !showToursLoadingSkeleton"
              class="mt-3 flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 md:hidden"
            >
              <font-awesome-icon icon="fa-solid fa-filter" class="h-3 w-3 shrink-0 text-amber-600" />
              <p class="mb-0 min-w-0 flex-1 text-xs leading-4 text-slate-700">
                {{ $t('Filtre') }}: <strong>{{ activeTourFilterSummary }}</strong>
              </p>
              <button
                type="button"
                class="shrink-0 text-xs font-bold text-brand-800 underline underline-offset-2"
                @click.stop.prevent="resetSearchFilters()"
              >
                {{ $t('Tüm turları göster') }}
              </button>
            </div>

            <div v-if="locale == 'tr'" class="p-3 text-xs text-content text-page">
              <p class="text-sm md:text-md leading-5 md:leading-6 mb-0">Bu yaz Medine'de iki(2), Mekke'de tek(1) otel seçeneği sunuyoruz. <strong>Otellerle yaptığımız güçlü anlaşmalar ile</strong> fiyat avantajını siz yolcularımıza yansıtıyoruz. Mekke'nin en iyi otellerinde biri olan Harem-i Şerife sıfır konumda bulunan Fairmont Clock Tower konaklama fırsatı sunuyoruz. Üstelik fark katan İnanç Tur rehberliği ve Türk Havayolları konforu da pakete dahil.  </p>

              <div class="mt-4 rounded-2xl border border-amber-300/40 bg-gradient-to-br from-slate-900 via-brand-900 to-amber-900 p-3 md:p-4 shadow-[0_20px_45px_-26px_rgba(0,0,0,0.65)]">
                <div class="flex items-center gap-2 mb-3">
                  <span class="inline-flex h-8 w-8 items-center justify-center rounded-full bg-amber-400/20 text-amber-200 ring-1 ring-amber-300/40">
                    <font-awesome-icon icon="fa-solid fa-gem" class="h-3.5 w-3.5" />
                  </span>
                  <p class="mb-0 text-sm md:text-base font-bold tracking-wide text-amber-100">Premium Ayrıcalıklar</p>
                </div>

                <div class="grid grid-cols-1 lg:grid-cols-3 gap-2.5 md:gap-3 mb-3">
                  <div class="rounded-xl border border-amber-300/35 bg-white/10 backdrop-blur-sm px-3 py-2.5">
                    <p class="mb-1 text-[11px] font-semibold uppercase tracking-wide text-amber-200">Otel Konforu</p>
                    <p class="mb-0 text-xs md:text-sm text-slate-100">Fairmont Clock Tower ve seçkin 5 yıldızlı alternatiflerle üst segment konaklama deneyimi.</p>
                  </div>
                  <div class="rounded-xl border border-sky-300/35 bg-white/10 backdrop-blur-sm px-3 py-2.5">
                    <p class="mb-1 text-[11px] font-semibold uppercase tracking-wide text-sky-200">Hızlı Tren</p>
                    <p class="mb-0 text-xs md:text-sm text-slate-100">Medine → Mekke hattında hızlı tren transferi ile daha akıcı, konforlu ve zaman kazandıran rota.</p>
                  </div>
                  <div class="rounded-xl border border-emerald-300/35 bg-white/10 backdrop-blur-sm px-3 py-2.5">
                    <p class="mb-1 text-[11px] font-semibold uppercase tracking-wide text-emerald-200">Aileye Özel Paket</p>
                    <p class="mb-0 text-xs md:text-sm text-slate-100">Çocuk yaş aralığına göre iki alternatif oda yerleşimi ile net, karşılaştırılabilir paket seçimi.</p>
                  </div>
                </div>

                <div class="rounded-xl border border-white/20 bg-white/10 backdrop-blur-sm p-2.5 md:p-3">
                  <div class="flex items-center gap-2 mb-2.5">
                    <span class="inline-flex h-6 w-6 items-center justify-center rounded-full bg-emerald-400/20 text-emerald-200 ring-1 ring-emerald-300/30">
                      <font-awesome-icon icon="fa-solid fa-users" class="h-3 w-3" />
                    </span>
                    <p class="mb-0 text-xs md:text-sm font-semibold text-white">Aile Paket Seçimi</p>
                  </div>

                  <div class="grid grid-cols-1 xl:grid-cols-2 gap-2.5">
                    <div class="rounded-lg border border-teal-400/25 bg-slate-900/40 overflow-hidden">
                      <div class="flex items-center gap-2 px-3 py-1.5 bg-teal-500/15 border-b border-teal-400/20">
                        <font-awesome-icon icon="fa-solid fa-child" class="h-3 w-3 text-teal-300 shrink-0" />
                        <span class="text-[11px] font-bold text-teal-100 tracking-wide">2 Yetişkin + 1 Çocuk</span>
                        <span class="ml-auto inline-flex items-center rounded-full bg-teal-400/20 border border-teal-300/30 px-2 py-0.5 text-[9px] font-semibold text-teal-200">2–6 Yaş</span>
                      </div>
                      <div class="p-2.5">
                      <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                        <div class="rounded-md border border-white/15 bg-white/5 p-2">
                          <p class="mb-1 text-[10px] font-semibold text-white">Alternatif A: Ek yatak yok</p>
                          <div class="rounded-md bg-slate-800/60 p-2">
                           <img src="/assets/svg/bed-double.svg" alt="Çift kişilik yatak" class="w-16 flex-none" />
                            <p class="mb-0 mt-1 text-[9px] text-slate-200">1x Çift Kişilik Yatak</p>
                          </div>
                        </div>
                        <div class="rounded-md border border-amber-300/30 bg-amber-100/10 p-2">
                          <p class="mb-1 text-[10px] font-semibold text-amber-100">Alternatif B: Ek yataklı</p>
                          <div class="rounded-md bg-slate-800/60 p-2">
                             <div class=" flex gap-3">
                           <img src="/assets/svg/bed-double.svg" alt="Çift kişilik yatak" class="w-16 flex-none" />
                            <img src="/assets/svg/bed-single.svg" alt="Tek kişilik yatak" class="w-12 flex-none" />
                            </div><p class="mb-0 mt-1 text-[9px] text-slate-200">1x Çift + 1x Tek Kişilik</p>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>

                    <div class="rounded-lg border border-violet-400/25 bg-slate-900/40 overflow-hidden">
                      <div class="flex items-center gap-2 px-3 py-1.5 bg-violet-500/15 border-b border-violet-400/20">
                        <font-awesome-icon icon="fa-solid fa-child" class="h-3 w-3 text-violet-300 shrink-0" />
                        <span class="text-[11px] font-bold text-violet-100 tracking-wide">2 Yetişkin + 1 Çocuk</span>
                        <span class="ml-auto inline-flex items-center rounded-full bg-violet-400/20 border border-violet-300/30 px-2 py-0.5 text-[9px] font-semibold text-violet-200">7–12 Yaş</span>
                      </div>
                      <div class="p-2.5">
                      <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                        <div class="rounded-md border border-white/15 bg-white/5 p-2">
                          <p class="mb-1 text-[10px] font-semibold text-white">Alternatif A: Ek yatak yok</p>
                          <div class="rounded-md bg-slate-800/60 p-2"> <div class=" flex gap-3">
                            <img src="/assets/svg/bed-double.svg" alt="Çift kişilik yatak" class="w-16 flex-none" />
 
</div>

                            <p class="mb-0 mt-1 text-[9px] text-slate-200">1x Çift Kişilik Yatak</p>
                          </div>
                        </div>
                        <div class="rounded-md border border-amber-300/30 bg-amber-100/10 p-2">
                          <p class="mb-1 text-[10px] font-semibold text-amber-100">Alternatif B: Ek yataklı</p>
                          <div class="rounded-md bg-slate-800/60 p-2"> <div class=" flex gap-3">
                            <img src="/assets/svg/bed-double.svg" alt="Çift kişilik yatak" class="w-16 flex-none" />
                            <img src="/assets/svg/bed-single.svg" alt="Tek kişilik yatak" class="w-12 flex-none" />

</div> <p class="mb-0 mt-1 text-[9px] text-slate-200">1x Çift + 1x Tek Kişilik</p>
                         
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            
              <div class="flex flex-col justify-center w-full items-center md:items-center mt-3">
                
                
                     <img  
                      :loading="'lazy'"  
                      :decoding="'async'"
                      :src="isMobile ? '/assets/img/hotels/mekke-otelleri-2025-2026-mobile.webp' : '/assets/img/hotels/mekke-otelleri-2025-2026.webp'"
                      class="w-full h-auto mb-2 rounded-lg" 
                      :title="pageData.SA_Baslik"  :alt="pageData.SA_Baslik"  
                    />
              
                    <img  
                      :loading="'lazy'"  
                      :decoding="'async'"
                        :src="isMobile ? '/assets/img/hotels/medine-otelleri-2025-2026-mobile.webp' : '/assets/img/hotels/medine-otelleri-2025-2026.webp'" 
                      class="w-full  h-auto mb-2 rounded-lg" 
                      :title="pageData.SA_Baslik"  :alt="pageData.SA_Baslik"  
                      />
                
              </div>
            </div>
  
            <div v-if="locale == 'en'">
              <p class="text-sm md:text-md leading-5 md:leading-6"><strong>{{ umrahSeasonLabel }} Umrah packages</strong> offer you a peaceful and spiritual journey to the Holy Lands. Reserve your spot in our specially designed programs that ensure you perform your pilgrimage in the most comfortable and serene way with our advantageous <strong>Umrah prices</strong>. With Umrah tours exclusively arranged with 5-star accommodations, you can fulfill your worship in the Holy Lands with complete peace of mind.</p>
                <p class="text-sm md:text-md leading-5 md:leading-6 mb-0">This summer, we offer two (2) hotel options in Medina and one (1) in Makka.<strong> Thanks to our strong agreements with the hotels</strong>, we pass the price advantage directly on to you, our valued travelers. At the same price as programs using hotels in more distant locations and lower categories, we provide the opportunity to stay at the 5 star hotels. What’s more, guidance by İnanç Tur and the comfort of Turkish Airlines are also included in the package.</p>

                <div class="mt-4 rounded-2xl border border-amber-300/40 bg-gradient-to-br from-slate-900 via-brand-900 to-amber-900 p-3 md:p-4 shadow-[0_20px_45px_-26px_rgba(0,0,0,0.65)]">
                  <div class="flex items-center gap-2 mb-3">
                    <span class="inline-flex h-8 w-8 items-center justify-center rounded-full bg-amber-400/20 text-amber-200 ring-1 ring-amber-300/40">
                      <font-awesome-icon icon="fa-solid fa-gem" class="h-3.5 w-3.5" />
                    </span>
                    <p class="mb-0 text-sm md:text-base font-bold tracking-wide text-amber-100">Premium Highlights</p>
                  </div>

                  <div class="grid grid-cols-1 lg:grid-cols-3 gap-2.5 md:gap-3 mb-3">
                    <div class="rounded-xl border border-amber-300/35 bg-white/10 backdrop-blur-sm px-3 py-2.5">
                      <p class="mb-1 text-[11px] font-semibold uppercase tracking-wide text-amber-200">Hotel Comfort</p>
                      <p class="mb-0 text-xs md:text-sm text-slate-100">Fairmont Clock Tower in Makka with selected 5-star alternatives in Medina.</p>
                    </div>
                    <div class="rounded-xl border border-sky-300/35 bg-white/10 backdrop-blur-sm px-3 py-2.5">
                      <p class="mb-1 text-[11px] font-semibold uppercase tracking-wide text-sky-200">High-Speed Rail</p>
                      <p class="mb-0 text-xs md:text-sm text-slate-100">Fast transfer between Medina and Makka for a smoother, premium route flow.</p>
                    </div>
                    <div class="rounded-xl border border-emerald-300/35 bg-white/10 backdrop-blur-sm px-3 py-2.5">
                      <p class="mb-1 text-[11px] font-semibold uppercase tracking-wide text-emerald-200">Family Package</p>
                      <p class="mb-0 text-xs md:text-sm text-slate-100">Two alternatives by child age range, with clear room layout visualization.</p>
                    </div>
                  </div>

                  <div class="rounded-xl border border-white/20 bg-white/10 backdrop-blur-sm p-2.5 md:p-3">
                    <div class="flex items-center gap-2 mb-2.5">
                      <span class="inline-flex h-6 w-6 items-center justify-center rounded-full bg-emerald-400/20 text-emerald-200 ring-1 ring-emerald-300/30">
                        <font-awesome-icon icon="fa-solid fa-users" class="h-3 w-3" />
                      </span>
                      <p class="mb-0 text-xs md:text-sm font-semibold text-white">Family Package Selection</p>
                    </div>

                    <div class="grid grid-cols-1 xl:grid-cols-2 gap-2.5">
                      <div class="rounded-lg border border-teal-400/25 bg-slate-900/40 overflow-hidden">
                        <div class="flex items-center gap-2 px-3 py-1.5 bg-teal-500/15 border-b border-teal-400/20">
                          <font-awesome-icon icon="fa-solid fa-child" class="h-3 w-3 text-teal-300 shrink-0" />
                          <span class="text-[11px] font-bold text-teal-100 tracking-wide">2 Adults + 1 Child</span>
                          <span class="ml-auto inline-flex items-center rounded-full bg-teal-400/20 border border-teal-300/30 px-2 py-0.5 text-[9px] font-semibold text-teal-200">Age 2–6</span>
                        </div>
                        <div class="p-2.5">
                        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                          <div class="rounded-md border border-white/15 bg-white/5 p-2">
                            <p class="mb-1 text-[10px] font-semibold text-white">Option A: No extra bed</p>
                            <div class="rounded-md bg-slate-800/60 p-2">
                              <svg viewBox="0 0 160 96" class="h-11 w-full" role="img" aria-label="Top view double bed">
                                <rect x="10" y="18" width="140" height="62" rx="10" fill="#f8fafc" stroke="#cbd5e1" stroke-width="2" />
                                <rect x="16" y="24" width="58" height="14" rx="5" fill="#e2e8f0" />
                                <rect x="86" y="24" width="58" height="14" rx="5" fill="#e2e8f0" />
                                <rect x="16" y="68" width="128" height="4" rx="2" fill="#94a3b8" opacity="0.45" />
                              </svg>
                              <p class="mb-0 mt-1 text-[9px] text-slate-200">1x Double Bed</p>
                            </div>
                          </div>
                          <div class="rounded-md border border-amber-300/30 bg-amber-100/10 p-2">
                            <p class="mb-1 text-[10px] font-semibold text-amber-100">Option B: With extra bed</p>
                            <div class="rounded-md bg-slate-800/60 p-2">
                              <svg viewBox="0 0 160 120" class="h-16 w-full" role="img" aria-label="Top view double and single beds">
                                <defs>
                                  <linearGradient id="duvetDouble5" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stop-color="#cfd8dc"/>
                                    <stop offset="100%" stop-color="#b0bec5"/>
                                  </linearGradient>
                                  <linearGradient id="duvetSingle2" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stop-color="#d7ccc8"/>
                                    <stop offset="100%" stop-color="#bcaaa4"/>
                                  </linearGradient>
                                  <filter id="shadow5" x="-20%" y="-20%" width="140%" height="140%">
                                    <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="#000" flood-opacity="0.15"/>
                                  </filter>
                                </defs>
                                <rect x="8" y="8" width="70" height="104" rx="8" fill="#eceff1" stroke="#90a4ae" stroke-width="1"/>
                                <rect x="14" y="16" width="58" height="88" rx="6" fill="url(#duvetDouble5)" filter="url(#shadow5)"/>
                                <line x1="14" y1="54" x2="72" y2="54" stroke="#ffffff" stroke-width="0.6" stroke-opacity="0.35"/>
                                <rect x="18" y="14" width="24" height="8" rx="2" fill="#ffffff" stroke="#cfd8dc" stroke-width="0.4"/>
                                <rect x="46" y="14" width="24" height="8" rx="2" fill="#ffffff" stroke="#cfd8dc" stroke-width="0.4"/>
                                <rect x="84" y="16" width="64" height="88" rx="8" fill="#eceff1" stroke="#90a4ae" stroke-width="1"/>
                                <rect x="90" y="24" width="52" height="72" rx="6" fill="url(#duvetSingle2)" filter="url(#shadow5)"/>
                                <line x1="90" y1="54" x2="142" y2="54" stroke="#ffffff" stroke-width="0.6" stroke-opacity="0.35"/>
                                <rect x="98" y="22" width="36" height="8" rx="2" fill="#ffffff" stroke="#cfd8dc" stroke-width="0.4"/>
                              </svg>
                              <p class="mb-0 mt-1 text-[9px] text-slate-200">1x Double + 1x Single</p>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>

                      <div class="rounded-lg border border-violet-400/25 bg-slate-900/40 overflow-hidden">
                        <div class="flex items-center gap-2 px-3 py-1.5 bg-violet-500/15 border-b border-violet-400/20">
                          <font-awesome-icon icon="fa-solid fa-child" class="h-3 w-3 text-violet-300 shrink-0" />
                          <span class="text-[11px] font-bold text-violet-100 tracking-wide">2 Adults + 1 Child</span>
                          <span class="ml-auto inline-flex items-center rounded-full bg-violet-400/20 border border-violet-300/30 px-2 py-0.5 text-[9px] font-semibold text-violet-200">Age 7–12</span>
                        </div>
                        <div class="p-2.5">
                        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                          <div class="rounded-md border border-white/15 bg-white/5 p-2">
                            <p class="mb-1 text-[10px] font-semibold text-white">Option A: No extra bed</p>
                            <div class="rounded-md bg-slate-800/60 p-2">
                              <svg viewBox="0 0 160 96" class="h-11 w-full" role="img" aria-label="Top view double bed">
                                <rect x="10" y="18" width="140" height="62" rx="10" fill="#f8fafc" stroke="#cbd5e1" stroke-width="2" />
                                <rect x="16" y="24" width="58" height="14" rx="5" fill="#e2e8f0" />
                                <rect x="86" y="24" width="58" height="14" rx="5" fill="#e2e8f0" />
                                <rect x="16" y="68" width="128" height="4" rx="2" fill="#94a3b8" opacity="0.45" />
                              </svg>
                              <p class="mb-0 mt-1 text-[9px] text-slate-200">1x Double Bed</p>
                            </div>
                          </div>
                          <div class="rounded-md border border-amber-300/30 bg-amber-100/10 p-2">
                            <p class="mb-1 text-[10px] font-semibold text-amber-100">Option B: With extra bed</p>
                            <div class="rounded-md bg-slate-800/60 p-2">
                              <svg viewBox="0 0 160 120" class="h-16 w-full" role="img" aria-label="Top view double and single beds">
                                <defs>
                                  <linearGradient id="duvetDouble5" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stop-color="#cfd8dc"/>
                                    <stop offset="100%" stop-color="#b0bec5"/>
                                  </linearGradient>
                                  <linearGradient id="duvetSingle2" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stop-color="#d7ccc8"/>
                                    <stop offset="100%" stop-color="#bcaaa4"/>
                                  </linearGradient>
                                  <filter id="shadow5" x="-20%" y="-20%" width="140%" height="140%">
                                    <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="#000" flood-opacity="0.15"/>
                                  </filter>
                                </defs>
                                <rect x="8" y="8" width="70" height="104" rx="8" fill="#eceff1" stroke="#90a4ae" stroke-width="1"/>
                                <rect x="14" y="16" width="58" height="88" rx="6" fill="url(#duvetDouble5)" filter="url(#shadow5)"/>
                                <line x1="14" y1="54" x2="72" y2="54" stroke="#ffffff" stroke-width="0.6" stroke-opacity="0.35"/>
                                <rect x="18" y="14" width="24" height="8" rx="2" fill="#ffffff" stroke="#cfd8dc" stroke-width="0.4"/>
                                <rect x="46" y="14" width="24" height="8" rx="2" fill="#ffffff" stroke="#cfd8dc" stroke-width="0.4"/>
                                <rect x="84" y="16" width="64" height="88" rx="8" fill="#eceff1" stroke="#90a4ae" stroke-width="1"/>
                                <rect x="90" y="24" width="52" height="72" rx="6" fill="url(#duvetSingle2)" filter="url(#shadow5)"/>
                                <line x1="90" y1="54" x2="142" y2="54" stroke="#ffffff" stroke-width="0.6" stroke-opacity="0.35"/>
                                <rect x="98" y="22" width="36" height="8" rx="2" fill="#ffffff" stroke="#cfd8dc" stroke-width="0.4"/>
                              </svg>
                              <p class="mb-0 mt-1 text-[9px] text-slate-200">1x Double + 1x Single</p>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          <div class="p-1" v-show="pageData && pageData.SA_Yazilar">
            <div v-if="tours?.length > 0" class="border-t mt-3 pt-3">
              <div class="mt-5 text-base font-medium">{{$t('Genel Bilgiler')}}</div>
            </div>
            <div class="max-w-full flex justify-center" v-if="pageData && pageData.SA_Fotograf">
 

 
                      <NuxtImg  
                         :loading="'lazy'"  
                        :decoding="'async'"
                        :src="showImage(pageData.SA_Fotograf, '', isMobile ? 404 : 576, true, '', 'webp')" 
                        class="w-full max-w-xl h-auto mb-2  " 
                        :title="pageData.SA_Baslik"  :alt="pageData.SA_Baslik" 
                        v-slot="{ src, isLoaded, imgAttrs }"
                      ></NuxtImg>
 
            </div>
            <span class="text-content text-page" v-if="pageData && pageData.SA_Yazilar"
              v-html="decodeHTMLEntities(pageData.SA_Yazilar, pageData)"></span>
          </div>
        </div>
      </div>
      </div>
      </div>
      </div>
      </div>
    </section> 
    <LazyTourPdfStudio
      v-if="showPdfStudio"
      v-model:open="showPdfStudio"
      :tours="selectedForPrint"
      :locale="locale"
      :page-title="pageData?.SA_Baslik || keyworUmreTuru2"
      :cover-url="pdfCoverUrl"
      @remove="removePrintSelection"
      @clear="clearPrintSelection"
    />
    <div
      v-if="selectedForPrint.length > 0"
      class="fixed bottom-3 left-1/2 z-[125] flex w-[calc(100%-1.5rem)] max-w-[720px] -translate-x-1/2 items-center gap-2 rounded-2xl border border-amber-300 bg-white/95 px-3 py-2 shadow-2xl backdrop-blur md:w-auto md:rounded-full"
    >
      <span class="inline-flex shrink-0 items-center gap-1 rounded-full bg-amber-50 px-2 py-1 text-xs font-bold text-amber-800">
        <font-awesome-icon icon="fa-solid fa-file-pdf" class="h-3 w-3" />
        {{ selectedForPrint.length }} {{ $t('tur seçildi') }}
      </span>
      <button
        type="button"
        @click.stop.prevent="clearPrintSelection"
        class="hidden items-center gap-1 rounded-full border border-neutral-200 bg-white px-3 py-1.5 text-xs font-semibold text-neutral-700 hover:bg-neutral-50 sm:inline-flex"
      >
        <font-awesome-icon icon="fa-solid fa-xmark" class="h-3 w-3" />
        {{ $t('Temizle') }}
      </button>
      <button
        type="button"
        @click.stop.prevent="showPdfStudio = true"
        class="ml-auto inline-flex items-center gap-2 rounded-xl bg-slate-900 px-4 py-2 text-xs font-black text-white shadow-lg transition hover:bg-slate-800 md:rounded-full"
      >
        <font-awesome-icon icon="fa-solid fa-wand-magic-sparkles" class="h-3 w-3 text-amber-300" />
        PDF Hazırla
      </button>
    </div>

    <!-- ===== Comparison Modal ===== -->
    <Teleport v-if="comparisonMode && comparisonTours.length > 1" to="body">
      <div class="fixed inset-0 z-50 flex items-center justify-center bg-neutral-900/50 backdrop-blur-sm">
        <div class="relative max-h-[90vh] w-[95%] max-w-5xl overflow-auto rounded-2xl border border-neutral-200 bg-white shadow-2xl">
          <button
            type="button"
            @click.stop.prevent="closeComparison"
            class="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full border border-neutral-200 bg-white hover:bg-neutral-50 z-10">
            <font-awesome-icon icon="fa-solid fa-xmark" class="h-4 w-4 text-neutral-500" />
          </button>

          <div class="sticky top-0 border-b border-neutral-200 bg-gradient-to-r from-brand-50 to-brand-100/50 px-6 py-4">
            <div class="flex items-center gap-3">
              <div class="flex h-10 w-10 items-center justify-center rounded-lg bg-brand-600 text-white">
                <font-awesome-icon icon="fa-solid fa-code-compare" class="h-5 w-5" />
              </div>
              <div>
                <h3 class="text-lg font-bold text-neutral-900 mb-0">{{ $t('Tur Karşılaştırması') }}</h3>
                <p class="text-sm text-neutral-600 mb-0">{{ comparisonTours[0]?.start }} · {{ comparisonTours[0]?.tur_Sure }} {{ $t('gün') }} · {{ comparisonTours.length }} {{ $t('tur') }}</p>
              </div>
            </div>
          </div>

          <div class="p-6">
            <div class="grid grid-cols-3 md:grid-cols-3 gap-3 mb-5">
              <div class="rounded-xl border border-support-200 bg-support-50 px-4 py-3">
                <div class="text-[11px] font-semibold text-support-700 mb-1">{{ $t('En Uygun') }}</div>
                <div class="text-sm font-bold text-support-800">{{ getComparisonPriceStats(comparisonTours).minLabel }}</div>
              </div>
              <div class="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
                <div class="text-[11px] font-semibold text-amber-700 mb-1">{{ $t('En Yüksek') }}</div>
                <div class="text-sm font-bold text-amber-800">{{ getComparisonPriceStats(comparisonTours).maxLabel }}</div>
              </div>
              <div class="rounded-xl border border-brand-200 bg-brand-50 px-4 py-3">
                <div class="text-[11px] font-semibold text-brand-700 mb-1">{{ $t('Fiyat Farkı') }}</div>
                <div class="text-sm font-bold text-brand-800">{{ getComparisonPriceStats(comparisonTours).diffLabel }}</div>
              </div>
            </div>

            <div class="overflow-x-auto rounded-xl border border-neutral-200">
              <table class="w-full min-w-[720px] text-sm">
                <thead class="bg-neutral-100">
                  <tr>
                    <th class="text-left px-3 py-2 font-semibold text-neutral-700">{{ $t('Karşılaştırma Alanı') }}</th>
                    <th
                      v-for="(tour, idx) in comparisonTours"
                      :key="`cmp_head_${tour?.pdb_Id || idx}`"
                      class="text-left px-3 py-2 font-semibold text-neutral-700"
                    >
                      {{ $t('Tur') }} {{ idx + 1 }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in getComparisonRows(comparisonTours)"
                    :key="row.key"
                    :class="row.hasDifference ? 'bg-amber-100/35' : 'bg-white'"
                    class="border-t border-neutral-200"
                  >
                    <td class="px-3 py-2 text-xs font-semibold text-neutral-700">{{ row.label }}</td>
                    <td v-for="(cell, cIdx) in row.values" :key="`cmp_cell_${row.key}_${cIdx}`" class="px-3 py-2 text-sm text-neutral-900">
                      <div class="flex items-center justify-between gap-2">
                        <span v-html="cell"></span>
                        <button
                          v-if="row.key === 'medinaHotel' || row.key === 'mekkaHotel'"
                          type="button"
                          class="inline-flex h-6 w-6 items-center justify-center rounded-full border border-brand-200 bg-brand-50 text-brand-700 hover:bg-brand-100"
                          :title="$t('Oteli İncele')"
                          @click.stop.prevent="openComparisonHotel(comparisonTours[cIdx], row.key === 'medinaHotel' ? 0 : 1)"
                        >
                          <font-awesome-icon icon="fa-solid fa-up-right-from-square" class="h-2.5 w-2.5" />
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="mt-4 grid grid-cols-1 md:grid-cols-2 gap-2">
              <div
                v-for="(tour, idx) in comparisonTours"
                :key="`cmp_note_${tour?.pdb_Id || idx}`"
                class="rounded-lg border border-neutral-200 bg-neutral-50 px-3 py-2"
              >
                <div class="text-xs font-semibold text-neutral-500 mb-0.5">{{ $t('Tur') }} {{ idx + 1 }}</div>
                <div class="text-sm font-semibold text-neutral-900">
                  {{ tour?.otel1_adi?.[locale] || tour?.otel1_adi?.tr }} / {{ tour?.otel2_adi?.[locale] || tour?.otel2_adi?.tr }}
                </div>
                <div class="text-xs text-neutral-600 mt-0.5">{{ formatMoney(tour?.turs_double || 0) }} {{ tour?.tour_Currency || '' }}</div>
              </div>
            </div>
          </div>

          <div class="sticky bottom-0 border-t border-neutral-200 bg-neutral-50 px-6 py-4 flex items-center gap-3">
            <button
              type="button"
              @click.stop.prevent="closeComparison"
              class="inline-flex items-center gap-1 rounded-lg border border-neutral-300 bg-white px-4 py-2 text-sm font-semibold text-neutral-700 hover:bg-neutral-100 transition-colors">
              {{ $t('Kapat') }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <div   class="fixed bottom-2 right-2 w-8 h-8 rounded-full flex z-50 items-center justify-center bg-orange-600 cursor-pointerfont-semibold"
                     
                      @click="scrollToInside()">
                      <font-awesome-icon icon="fa-solid fa-chevron-up" class="h-4 w-4 text-white"></font-awesome-icon> 
                </div> 

    <div v-if="showPreview && selectedTour " class="fixed inset-0 z-40">
      <div class="absolute inset-0 bg-neutral-900/40" @click="closePreview"></div>
      <aside class="absolute right-0 top-0 h-full w-full max-w-[460px] bg-white shadow-2xl border-l border-neutral-200 transform transition-transform duration-300"
        :class="showPreview ? 'translate-x-0' : 'translate-x-full'"
      >
        <div class="flex items-center justify-between px-5 py-4 border-b border-neutral-200 bg-neutral-50">
          <div class="flex items-center gap-2">
            <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-brand-50 text-brand-700">
              <font-awesome-icon icon="fa-solid fa-magnifying-glass" class="h-4 w-4" />
            </span>
            <div>
              <div class="text-sm font-semibold text-neutral-900">{{ selectedTour.start }}</div>
              <div class="text-xs text-neutral-500">• {{ selectedTour.tur_Sure }} {{$t('gün')}} </div>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <button
              type="button"
              class="h-9 px-3 inline-flex items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-600 hover:bg-neutral-50 text-xs font-semibold disabled:opacity-50"
              @click="selectPrevTour"
              :disabled="!hasPrevTour"
              :title="$t('Önceki tur')"
            >
              <font-awesome-icon icon="fa-solid fa-chevron-left" class="h-3 w-3 mr-1" />
              {{ !isMobile ? $t('Önceki') : '' }}
            </button>
            <button
              type="button"
              class="h-9 px-3 inline-flex items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-600 hover:bg-neutral-50 text-xs font-semibold disabled:opacity-50"
              @click="selectNextTour"
              :disabled="!hasNextTour"
              :title="$t('Sonraki tur')"
            >
              {{ !isMobile ? $t('Sonraki') : ''}}
              <font-awesome-icon icon="fa-solid fa-chevron-right" class="h-3 w-3 ml-1" />
            </button>
            <button
              type="button"
              class="h-9 w-9 inline-flex items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-600 hover:bg-neutral-50"
              @click="closePreview"
              :title="$t('Kapat')"
            >
              <font-awesome-icon icon="fa-solid fa-xmark" class="h-4 w-4" />
            </button>
          </div>
        </div>

        <div class="h-full overflow-y-auto ">
          <div class="px-5 pb-[240px] md:pb-[290px]"> 
            <div class="md:mt-2 flex flex-wrap md:flex-row flex-col gap-1 mt-1 text-xs text-neutral-600">
              <span class="rounded-full md:bg-neutral-100 px-2 py-0.5 w-48 md:w-auto">{{$t('Gidiş')}}: {{ selectedTour.start }}</span>
              <span class="rounded-full md:bg-neutral-100 px-2 py-0.5 w-48 md:w-auto">{{$t('Dönüş')}}: {{ selectedTour.end }}</span>
              <span>
                <img :src="showImage(selectedTour.airwayLogo, '', 30, '', '', '')" title="Airway" alt="Airway" class="h-5 absolute right-5" style="width:67px;height:20px;" />
              </span>
            </div>

            <div class="mt-4 rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden">
              <div class="flex items-center justify-between gap-2 border-b border-neutral-100 bg-gradient-to-r from-brand-50 via-white to-accent-50 px-3 py-2.5 md:px-4">
                <div class="flex items-center gap-2">
                  <span class="inline-flex h-7 w-7 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <font-awesome-icon icon="fa-solid fa-tags" class="h-3.5 w-3.5"></font-awesome-icon>
                  </span>
                  <span class="text-sm md:text-base font-semibold text-neutral-800 truncate">{{$t('Ücretler')}}</span>
                </div>
                <span class="rounded-full border border-accent-200 bg-accent-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-accent-700">{{$t('kişi başı')}}</span>
              </div>

              <div class="pb-0 md:pb-4">
                <div class="px-2 pt-3 md:px-3">
                  <div class="">
                     
                      <p class="mb-0 text-xs font-semibold text-slate-500 tracking-wide text-slate-500 my-0">{{$t('Oda Fiyatları')}}</p>
                 
                    <div class="grid grid-cols-3 xl:grid-cols-3 gap-2">
                      <article class="rounded-lg border border-slate-200 bg-slate-50/70 p-3">
                        <p class="mb-1 text-xs font-semibold text-slate-500">{{$t('Tek Kişilik')}}</p>
                        <p v-if="selectedTour.turs_single_high && selectedTour.turs_single_high > selectedTour.turs_single" class="mb-0 text-xs font-semibold text-slate-300 line-through">
                          {{ formatMoney(selectedTour.turs_single_high) }} {{ selectedTour.tour_Currency }}
                        </p>
                        <p :class="selectedTour.turs_single_high && selectedTour.turs_single_high > selectedTour.turs_single ? 'text-teal-600' : 'text-slate-700'" class="mb-0 text-sm md:text-md font-bold">
                          {{ formatMoney(selectedTour.turs_single) }} {{ selectedTour.tour_Currency }}
                        </p>
                      </article>

                      <article class="rounded-lg border border-slate-200 bg-slate-50/70 p-3">
                        <p class="mb-1 text-xs font-semibold text-slate-500">{{$t('İkili Oda')}}</p>
                        <p v-if="selectedTour.turs_double_high && selectedTour.turs_double_high > selectedTour.turs_double" class="mb-0 text-xs font-semibold text-slate-300 line-through">
                          {{ formatMoney(selectedTour.turs_double_high) }} {{ selectedTour.tour_Currency }}
                        </p>
                        <p :class="selectedTour.turs_double_high && selectedTour.turs_double_high > selectedTour.turs_double ? 'text-teal-600' : 'text-slate-700'" class="mb-0 text-sm md:text-md  font-bold">
                          {{ formatMoney(selectedTour.turs_double) }} {{ selectedTour.tour_Currency }}
                        </p>
                      </article>

                      <article class="rounded-lg border border-slate-200 bg-slate-50/70 p-3">
                        <p class="mb-1 text-xs font-semibold text-slate-500">{{$t('Üçlü Oda')}}</p>
                        <p v-if="selectedTour.turs_triple_high && selectedTour.turs_triple_high > selectedTour.turs_triple" class="mb-0 text-xs font-semibold text-slate-300 line-through">
                          {{ formatMoney(selectedTour.turs_triple_high) }} {{ selectedTour.tour_Currency }}
                        </p>
                        <p :class="selectedTour.turs_triple_high && selectedTour.turs_triple_high > selectedTour.turs_triple ? 'text-teal-600' : 'text-slate-700'" class="mb-0 text-sm md:text-md font-bold">
                          {{ formatMoney(selectedTour.turs_triple) }} {{ selectedTour.tour_Currency }}
                        </p>
                      </article>
                    </div>
                    <div class="grid grid-cols-1 mt-2">
                      <article v-if="Object.keys(childPricesOrdered).length > 0" class="col-span-1">
                        <p class="mb-2 text-xs font-semibold text-slate-500">{{$t('Çocuk & Bebek Fiyatları')}}</p>
                        <div class="overflow-x-auto">
                          <table class="w-full text-left text-xs">
                            <thead class="border-b border-slate-200 bg-slate-100">
                              <tr>
                                <th class="px-2 py-2 font-semibold text-slate-600">{{$t('Yaş')}}</th>
                                <th class="px-2 py-2 font-semibold text-slate-600">{{$t('Tipi')}}</th>
                                <th class="px-2 py-2 font-semibold text-slate-600 text-right">{{$t('Fiyat')}}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <template v-for="(prices, ageKey) of childPricesOrdered" :key="ageKey">
                                <tr v-for="(price, index) in prices" :key="`child-price-${ageKey}-${index}`" :class="index === 0 ? 'border-t border-slate-200' : 'border-t border-slate-100'" class="hover:bg-slate-50">
                                  <td v-if="index === 0" :rowspan="prices.length" class="px-2 py-2 font-semibold text-slate-700">{{ ageKey }} {{$t('yaş')}}</td>
                                  <td class="px-2 py-2 text-slate-700">
                                    <span class="font-medium">{{ getChildPriceLabel(price) }}</span>
                                    <span class="text-[10px] text-slate-500 block">{{ getChildRoomLabel(price) }}</span>
                                  </td>
                                  <td class="px-2 py-2 text-right">
                                    <span v-if="price.turf_PriceHigh && price.turf_PriceHigh > price.turf_Price" class="text-slate-400 line-through text-[10px] block">{{ formatMoney(price.turf_PriceHigh) }} {{ selectedTour.tour_Currency }}</span>
                                    <span :class="price.turf_PriceHigh && price.turf_PriceHigh > price.turf_Price ? 'text-teal-600 font-bold' : 'text-slate-700 font-semibold'">{{ formatMoney(price.turf_Price) }} {{ selectedTour.tour_Currency }}</span>
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                      </article>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-2 grid grid-cols-1 gap-4">
              <div class="rounded-xl border border-neutral-200 bg-white p-4">
                <div class="text-xs font-semibold text-neutral-700 mb-2">{{$t('Rotalar')}}</div>
                <div class="flex flex-col gap-2">
                  <div v-for="(r, index) in selectedTour.routes" :key="`route_${index}`" class="text-xs flex gap-2 text-neutral-600">
                    <span class="font-semibold text-neutral-700">{{ r.rDay }} {{ r.rMonth }} {{ r.rYear }}</span>
                    <span class="ml-1 flex truncate items-center" v-if="r?.turs_Transporter == 'fa-train'">
                      <img src="/assets/img/svg/train-speed.svg" alt="train" class="h-4 w-4 mr-1"/> Hızlı Tren
                    </span>
                    <span class="ml-1 flex truncate items-center" v-else-if="r?.turs_Transporter == 'fa-plane-departure'">
                      <font-awesome-icon icon="fa-solid fa-plane-departure" class="h-3 w-3 text-sky-300" />
                    </span>
                  
                    <span class="ml-2">{{ r?.turs_CityStart?.[locale] }} - {{ r?.turs_CityEnd?.[locale] }}</span>
                 
                    <span class="ml-2">{{ r?.turs_transDetail?.[locale] }}</span>
                  </div>
                </div>
              </div>

              <div class="rounded-xl border border-brand-200 bg-brand-50/40 p-4">
                <div class="text-xs font-semibold text-brand-800 mb-2">{{$t('Konaklama')}}</div>
                <div class="flex flex-col gap-3">
                  <div v-for="(htl, hIndex) in selectedTour.hotels" :key="`hotel_${hIndex}`" class="flex items-center gap-3 rounded-xl border border-brand-100 bg-white p-3">
                    <img :src="showImage(htl.sOtelPhoto, 72, 72, true, '', '')" :alt="htl.sOtelAdi?.[locale]" class="h-16 w-16 rounded-xl object-cover ring-2 ring-brand-100" />
                    <div class="min-w-0">
                      <div class="text-sm font-semibold text-neutral-900 truncate" v-html="htl.sOtelAdi?.[locale]"></div>
                      <div class="text-[11px] text-neutral-600">{{ htl.city?.[locale] }} • {{ htl.turo_Sure }} {{$t('gece')}}</div>
                      <div class="text-[10px] text-neutral-500" v-if="htl.star?.[locale]">{{$t('Yıldız')}}: {{ htl.star?.[locale] }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="rounded-xl border border-neutral-200 bg-white p-4">
                <div class="text-xs font-semibold text-neutral-700 mb-2">{{$t('Dahil Olan Hizmetler')}}</div>
                <div class="grid grid-cols-1 gap-2 text-[11px] text-neutral-600">
                  <div class="flex items-start gap-2">
                    <span class="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full bg-support-50 text-support-700">
                      <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3" />
                    </span>
                    {{$t('Gidiş dönüş uçak bileti')}}
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full bg-support-50 text-support-700">
                      <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3" />
                    </span>
                    {{$t('Hızlı tren ile ara geçiş')}}
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full bg-support-50 text-support-700">
                      <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3" />
                    </span>
                    {{$t('Belirtilen 5 yıldızlı, yürüme mesafeli otellerde konaklama')}}
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full bg-support-50 text-support-700">
                      <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3" />
                    </span>
                    {{$t('Sabah ve akşam açık büfe yemek')}}
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full bg-support-50 text-support-700">
                      <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3" />
                    </span>
                    {{$t('Vize ve seyahat sigortası')}}
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full bg-support-50 text-support-700">
                      <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3" />
                    </span>
                    {{$t('Tüm transferler')}}
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full bg-support-50 text-support-700">
                      <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3" />
                    </span>
                    {{$t('İnanç Tur irşad ve rehberlik hizmetleri')}}
                  </div>
                </div>
              </div>
            </div>
          </div>
 </div>
          <div class="border-t border-neutral-200 bg-neutral-50 px-5 py-3 pb-4 md:py-4 sticky bottom-0">
            <div class="hidden md:block rounded-2xl border border-accent-200 bg-accent-50/70 p-2 mb-3">
              <div class="flex justify-between">
                <div class="text-xs text-accent-700 font-semibold mt-4 pl-4">{{$t('Toplam Ücret')}}
                  <button
                      type="button"
                      @click.stop.prevent="toggleQuickPreviewPeopleEditor"
                      class="mt-1 inline-flex items-center gap-1 rounded-full border border-brand-200 bg-brand-50 px-2 py-1 text-[10px] font-semibold text-brand-800 hover:bg-brand-100"
                    >
                      <font-awesome-icon icon="fa-solid fa-users" class="h-2.5 w-2.5" />
                      {{ $t('Kişi Düzenle') }}
                    </button>
                </div>
                  <div class="flex flex-col items-end">
                    <div class="flex items-baseline gap-1">
                      <span class="text-xl py-0 font-extrabold text-neutral-900">{{ formatMoney(getTourTotal(selectedTour, reservation)) }}</span>
                      <span class="text-xs font-semibold text-neutral-500">{{ selectedTour.tour_Currency }}</span>
                    </div>
                    <div class="text-[11px] text-neutral-600">
                      {{ previewPeopleLabel }}
                    </div>
                    
                </div>
              </div>
              <div v-if="quickPreviewPeopleEditorOpen" class="mt-2 rounded-xl border border-neutral-200 bg-white p-2.5">
                <div class="flex items-center gap-1.5 mb-1.5 px-2 text-[9px] font-semibold text-neutral-400 uppercase tracking-wide">
                  <span class="w-14"></span>
                  <span class="min-w-[46px] text-center">{{ $t('Yetişkin') }}</span>
                  <span class="min-w-[46px] text-center">{{ $t('Çocuk') }}</span>
                  <span class="min-w-[46px] text-center">{{ $t('Bebek') }}</span>
                </div>
                <div class="space-y-1.5 max-h-[150px] overflow-auto pr-1">
                  <div
                    v-for="(room, roomIdx) in reservation.rooms"
                    :key="`quick_room_edit_${roomIdx}`"
                    class="flex items-center gap-1.5 rounded-lg border border-neutral-200 bg-neutral-50 px-2 py-1"
                  >
                    <span class="w-14 text-[10px] font-semibold text-neutral-600">{{ roomIdx + 1 }}. {{ $t('Oda') }}</span>
                    <select v-model.number="room.adult" class="h-7 min-w-[46px] rounded-md border border-neutral-300 bg-white px-1 text-[11px]">
                      <option v-for="n in 3" :key="`qr_adult_${roomIdx}_${n}`" :value="n">{{ n }}</option>
                    </select>
                    <select v-model.number="room.child" class="h-7 min-w-[46px] rounded-md border border-neutral-300 bg-white px-1 text-[11px]">
                      <option v-for="n in 4" :key="`qr_child_${roomIdx}_${n}`" :value="n - 1">{{ n - 1 }}</option>
                    </select>
                    <select v-model.number="room.baby" class="h-7 min-w-[46px] rounded-md border border-neutral-300 bg-white px-1 text-[11px]">
                      <option v-for="n in 4" :key="`qr_baby_${roomIdx}_${n}`" :value="n - 1">{{ n - 1 }}</option>
                    </select>
                    <button
                      v-if="roomIdx !== 0"
                      type="button"
                      @click.stop.prevent="removeRoom(roomIdx)"
                      class="ml-auto text-rose-500 hover:text-rose-600"
                    >
                      <font-awesome-icon icon="fa-solid fa-trash" class="h-3 w-3" />
                    </button>
                  </div>
                </div>

                <div v-if="totalKidsCount > 0" class="mt-2 border-t border-neutral-200 pt-2">
                  <p class="text-[9px] font-semibold text-neutral-400 uppercase tracking-wide mb-1.5">{{ $t('Çocuk Yaşları ve Yatak') }}</p>
                  <div class="space-y-1.5 max-h-[170px] overflow-auto pr-1">
                    <div
                      v-for="(age, ageIdx) in reservation.childrenAges"
                      :key="`quick_age_edit_${ageIdx}`"
                      class="rounded-md border border-neutral-200 bg-neutral-50 px-1.5 py-1"
                    >
                      <div class="flex items-center gap-1">
                        <span class="text-[10px] text-neutral-500">{{ ageIdx + 1 }}.</span>
                        <select v-model="reservation.childrenAges[ageIdx]" @change="onSidebarChildAgeChange(ageIdx)" class="h-6 min-w-[60px] rounded border border-neutral-300 bg-white px-1 text-[10px]">
                          <option value="">{{ $t('Yaş seç') }}</option>
                          <option v-for="n in 18" :key="`quick_age_${ageIdx}_${n}`" :value="n - 1">{{ n - 1 === 0 ? '0 (' + $t('bebek') + ')' : (n - 1) + ' ' + $t('yaş') }}</option>
                        </select>
                        <button
                          type="button"
                          class="inline-flex items-center gap-1 rounded border border-neutral-300 bg-white px-1.5 py-1 text-[9px] font-semibold text-neutral-600"
                          @click="toggleSidebarChildBedPanel(ageIdx)"
                        >
                          <font-awesome-icon icon="fa-solid fa-bed" class="h-2.5 w-2.5" />
                          {{ getSidebarChildBedLabel(ageIdx) }}
                        </button>
                        <button type="button" @click.stop.prevent="removeChildAge(ageIdx)" class="ml-auto text-rose-500 hover:text-rose-600">
                          <font-awesome-icon icon="fa-solid fa-xmark" class="h-3 w-3" />
                        </button>
                      </div>
                      <div v-if="sidebarChildBedPanelOpen[ageIdx]" class="mt-1 grid grid-cols-2 gap-1">
                        <button
                          v-for="opt in getSidebarChildBedOptionsByIndex(ageIdx)"
                          :key="`quick_bed_${ageIdx}_${opt.key}`"
                          type="button"
                          @click="selectSidebarChildBedOption(ageIdx, opt.key)"
                          class="rounded border px-1.5 py-1 text-left"
                          :class="sidebarChildBedChoices[ageIdx] === opt.key ? 'border-sky-300 bg-sky-50' : 'border-neutral-200 bg-white'"
                        >
                          <div class="flex items-center gap-1.5">
                            <div class="flex h-6 w-8 items-center justify-center rounded bg-slate-100">
                              <svg v-if="opt.kind === 'turBaby'" viewBox="0 0 40 20" class="h-4 w-7">
                                <rect x="2" y="2" width="36" height="16" rx="4" fill="#dbeafe" stroke="#60a5fa" stroke-width="1.2"/>
                                <line x1="8" y1="2" x2="8" y2="18" stroke="#93c5fd" stroke-width="1"/>
                                <line x1="16" y1="2" x2="16" y2="18" stroke="#93c5fd" stroke-width="1"/>
                                <line x1="24" y1="2" x2="24" y2="18" stroke="#93c5fd" stroke-width="1"/>
                                <line x1="32" y1="2" x2="32" y2="18" stroke="#93c5fd" stroke-width="1"/>
                              </svg>
                              <svg v-else-if="opt.kind === 'turChild'" viewBox="0 0 40 20" class="h-4 w-7">
                                <rect x="3" y="3" width="34" height="14" rx="4" fill="#d1fae5" stroke="#34d399" stroke-width="1.2"/>
                                <rect x="6" y="5" width="10" height="5" rx="2" fill="#ecfdf5"/>
                                <path d="M6 13 Q20 9 34 13" fill="none" stroke="#6ee7b7" stroke-width="1.6"/>
                              </svg>
                              <svg v-else viewBox="0 0 40 20" class="h-4 w-7">
                                <rect x="2" y="3" width="36" height="14" rx="4" fill="#fde68a" stroke="#f59e0b" stroke-width="1.2"/>
                                <rect x="5" y="5" width="10" height="5" rx="2" fill="#fffbeb"/>
                                <rect x="25" y="5" width="10" height="5" rx="2" fill="#fffbeb"/>
                              </svg>
                            </div>
                            <div>
                              <p class="mb-0 text-[9px] font-semibold text-neutral-700">{{ locale === 'tr' ? opt.labelTr : opt.labelEn }}</p>
                              <p class="mb-0 text-[8px] text-neutral-500">{{ locale === 'tr' ? opt.descTr : opt.descEn }}</p>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-2 flex items-center justify-between gap-2">
                  <button type="button" @click.stop.prevent="addRoom" class="h-7 px-2 rounded-md border border-dashed border-neutral-300 text-[11px] font-semibold text-neutral-700 hover:bg-neutral-100">+ {{ $t('Oda') }}</button>
                  <div class="flex items-center gap-2">
                      <button type="button" @click.stop.prevent="resetPeopleSelection" class="h-7 px-2 rounded-md border border-neutral-300 text-[11px] font-semibold text-neutral-700 hover:bg-neutral-100">{{ $t('Sıfırla') }}</button>
                      <button type="button" @click.stop.prevent="toggleQuickPreviewPeopleEditor" class="h-7 px-2 rounded-md border border-red-300 text-[11px] font-semibold text-red-700 hover:bg-red-100">{{ $t('Kapat') }}</button>
                   </div> 
                </div>
              </div>
              
            </div>
            <div class="flex items-center gap-2 mb-3">
              <button
                type="button"
                class="h-9 px-3 inline-flex items-center rounded-full border border-neutral-200 bg-white text-neutral-700 text-xs font-semibold hover:bg-neutral-50 disabled:opacity-50"
                @click="selectPrevTour"
                :disabled="!hasPrevTour"
              >
                <font-awesome-icon icon="fa-solid fa-chevron-left" class="h-3 w-3 mr-1" />
                {{ !isMobile ? $t('Önceki') : '' }}
              </button>
              <button
                type="button"
                class="h-9 px-3 inline-flex items-center rounded-full border border-neutral-200 bg-white text-neutral-700 text-xs font-semibold hover:bg-neutral-50 disabled:opacity-50"
                @click="selectNextTour"
                :disabled="!hasNextTour"
              >
                {{ !isMobile ? $t('Sonraki') : '' }}
                <font-awesome-icon icon="fa-solid fa-chevron-right" class="h-3 w-3 ml-1" />
              </button>
              <button
                type="button"
                class="h-9 px-3 inline-flex items-center rounded-full border text-xs font-semibold hover:bg-neutral-50"
                :class="isCompared(selectedTour) ? 'border-accent-400 bg-accent-50 text-accent-700' : 'border-neutral-200 bg-white text-neutral-700'"
                @click.stop.prevent="onCompare(selectedTour)"
              >
                <font-awesome-icon icon="fa-solid fa-code-compare" class="h-3 w-3 mr-1" />
                {{$t('Karşılaştır')}}
              </button>
              <GlobalShare
                v-if="previewShareUrl"
                :title="previewShareTitle"
                :url="previewShareUrl"
                size="xs"
              ></GlobalShare>
            </div>
            <div class="flex items-center gap-2">
              <a
                :href="buildWhatsAppUrl(`Merhaba ${selectedTour.start} tarihli ${selectedTour.tur_Sure} günlük turunuz hakkında bilgi almak istiyorum.`)"
                target="_blank" rel="nofollow noopener noreferrer"
                class="h-8 px-4 inline-flex items-center rounded-full bg-support-600 text-white text-xs font-semibold hover:bg-support-500"
              >
                <font-awesome-icon icon="fa-brands fa-whatsapp" class="h-3 w-3 mr-1" />
                WhatsApp
              </a>
              <button
                type="button"
                class="h-8 px-4 inline-flex items-center rounded-full bg-accent-600 text-white text-xs font-semibold hover:bg-accent-500"
                @click.stop.prevent="goPath('/tourDetail/' + selectedTour.pdb_Id)"
              >
                <font-awesome-icon icon="fa-solid fa-circle-info" class="h-3 w-3 mr-1" />
                {{$t('Detaylar')}}
              </button>
            </div> 
        </div>
      </aside>
    </div>

    <div v-if="isCompareOpen" class="fixed inset-0 z-50">
      <div class="absolute inset-0 bg-neutral-900/40" @click="closeCompare"></div>
      <section class="absolute inset-0 bg-white flex flex-col">
        <div class="flex items-center justify-between px-6 py-4 border-b border-neutral-200 bg-neutral-50">
          <div class="flex items-center gap-3">
            <span class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-accent-50 text-accent-700">
              <font-awesome-icon icon="fa-solid fa-code-compare" class="h-4 w-4" />
            </span>
            <div>
              <div class="text-sm font-semibold text-neutral-900">{{$t('Tur Karşılaştırma')}}</div>
              <div class="text-xs text-neutral-500">{{ compareTours.length }} {{$t('tur seçildi')}}</div>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <button
              type="button"
              class="h-9 px-3 inline-flex items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-600 hover:bg-neutral-50 text-xs font-semibold"
              @click="clearCompareTours"
            >
              {{$t('Temizle')}}
            </button>
            <button
              type="button"
              class="h-9 w-9 inline-flex items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-600 hover:bg-neutral-50"
              @click="closeCompare"
              :title="$t('Kapat')"
            >
              <font-awesome-icon icon="fa-solid fa-xmark" class="h-4 w-4" />
            </button>
          </div>
        </div>

        <div class="flex-1 overflow-auto">
          <div class="min-w-full px-6 py-4">
            <div v-if="compareTours.length === 0" class="w-full flex flex-col items-center justify-center py-12 text-center">
              <div class="h-16 w-16 rounded-2xl bg-accent-50 text-accent-700 inline-flex items-center justify-center">
                <font-awesome-icon icon="fa-solid fa-code-compare" class="h-6 w-6" />
              </div>
              <div class="mt-4 text-base font-semibold text-neutral-900">{{$t('Henüz tur seçilmedi')}}</div>
              <div class="text-sm text-neutral-500 mt-1">{{$t('Karşılaştırmak için tur listesine gidin.')}}</div>
              <button
                type="button"
                class="mt-4 h-10 px-4 inline-flex items-center rounded-full bg-accent-600 text-white text-xs font-semibold hover:bg-accent-500"
                @click.stop.prevent="goPath('/tour/umre-turlari')"
              >
                {{$t('Tur Seç')}}
              </button>
            </div>

            <div v-else class="flex gap-4 overflow-x-auto pb-6">
              <div
                v-for="tour in compareTours"
                :key="`compare_${tour.pdb_Id}`"
                class="w-[320px] shrink-0 rounded-2xl border border-neutral-200 bg-white shadow-sm"
              >
                <div class="flex items-start justify-between gap-2 px-4 py-4 border-b border-neutral-100">
                  <div>
                    <div class="text-sm font-semibold text-neutral-900">{{ tour.start }}</div>
                    <div class="text-xs text-neutral-500">{{ tour.tur_Sure }} {{$t('gün')}}</div>
                  </div>
                  <button
                    type="button"
                    class="h-8 w-8 inline-flex items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-600 hover:bg-neutral-50"
                    @click.stop.prevent="removeCompareTour(tour)"
                    :title="$t('Kaldır')"
                  >
                    <font-awesome-icon icon="fa-solid fa-xmark" class="h-3 w-3" />
                  </button>
                </div>

                <div class="px-4 py-3">
                  <div class="flex flex-wrap gap-2 text-[11px] text-neutral-600">
                    <span class="rounded-full bg-neutral-100 px-2 py-0.5">{{$t('Gidiş')}}: {{ tour.start }}</span>
                    <span class="rounded-full bg-neutral-100 px-2 py-0.5">{{$t('Dönüş')}}: {{ tour.end }}</span>
                    <img :src="showImage(tour.airwayLogo, '', 30, '', '', '')" title="Airway" alt="Airway" class="h-4" style="width:60px;height:16px;" />
                  </div>

                  <div class="mt-3 rounded-2xl border border-neutral-200 bg-neutral-50/70 p-3">
                    <div class="text-[11px] font-semibold text-neutral-700 mb-2">{{$t('Ücretler')}}</div>
                    <div class="grid grid-cols-3 gap-2 text-[11px]">
                      <div class="rounded-xl border border-neutral-200 bg-white px-2 py-2">
                        <div class="text-[10px] text-neutral-500">{{$t('İkili Oda')}}</div>
                        <div v-if="tour.turs_double_high && tour.turs_double != tour.turs_double_high" class="text-[9px] text-neutral-400 line-through">
                          {{ formatMoney(tour.turs_double_high) }} {{ tour.tour_Currency }}
                        </div>
                        <div class="mt-1 flex items-baseline gap-1">
                          <span class="text-sm font-bold text-neutral-900">{{ formatMoney(tour.turs_double) }}</span>
                          <span class="text-[10px] text-neutral-500">{{ tour.tour_Currency }}</span>
                        </div>
                      </div>
                      <div class="rounded-xl border border-neutral-200 bg-white px-2 py-2">
                        <div class="text-[10px] text-neutral-500">{{$t('Üçlü Oda')}}</div>
                        <div v-if="tour.turs_triple_high && tour.turs_triple != tour.turs_triple_high" class="text-[9px] text-neutral-400 line-through">
                          {{ formatMoney(tour.turs_triple_high) }} {{ tour.tour_Currency }}
                        </div>
                        <div class="mt-1 flex items-baseline gap-1">
                          <span class="text-sm font-bold text-neutral-900">{{ formatMoney(tour.turs_triple) }}</span>
                          <span class="text-[10px] text-neutral-500">{{ tour.tour_Currency }}</span>
                        </div>
                      </div>
                      <div class="rounded-xl border border-neutral-200 bg-white px-2 py-2">
                        <div class="text-[10px] text-neutral-500">{{$t('Single Oda')}}</div>
                        <div v-if="tour.turs_single_high && tour.turs_single != tour.turs_single_high" class="text-[9px] text-neutral-400 line-through">
                          {{ formatMoney(tour.turs_single_high) }} {{ tour.tour_Currency }}
                        </div>
                        <div class="mt-1 flex items-baseline gap-1">
                          <span class="text-sm font-bold text-neutral-900">{{ formatMoney(tour.turs_single) }}</span>
                          <span class="text-[10px] text-neutral-500">{{ tour.tour_Currency }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mt-2 grid grid-cols-2 gap-2 text-[11px]">
                      <div class="rounded-xl border border-neutral-200 bg-white px-2 py-2">
                        <div class="text-[10px] text-neutral-500">{{$t('Çocuk')}}</div>
                        <div v-if="tour.turs_child_high && tour.turs_child_high != '0' && tour.turs_child != tour.turs_child_high" class="text-[9px] text-neutral-400 line-through">
                          {{ formatMoney(tour.turs_child_high) }} {{ tour.tour_Currency }}
                        </div>
                        <div class="mt-1 flex items-baseline gap-1">
                          <span class="text-sm font-bold text-neutral-900">{{ formatMoney(tour.turs_child) }}</span>
                          <span class="text-[10px] text-neutral-500">{{ tour.tour_Currency }}</span>
                        </div>
                      </div>
                      <div class="rounded-xl border border-neutral-200 bg-white px-2 py-2">
                        <div class="text-[10px] text-neutral-500">{{$t('Bebek')}}</div>
                        <div v-if="tour.turs_baby_high && tour.turs_baby_high != '0' && tour.turs_baby != tour.turs_baby_high" class="text-[9px] text-neutral-400 line-through">
                          {{ formatMoney(tour.turs_baby_high) }} {{ tour.tour_Currency }}
                        </div>
                        <div class="mt-1 flex items-baseline gap-1">
                          <span class="text-sm font-bold text-neutral-900">{{ formatMoney(tour.turs_baby) }}</span>
                          <span class="text-[10px] text-neutral-500">{{ tour.tour_Currency }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4 rounded-xl border border-neutral-200 bg-white p-3">
                    <div class="text-[11px] font-semibold text-neutral-700 mb-2">{{$t('Rotalar')}}</div>
                    <div class="flex flex-col gap-2">
                      <div v-for="(r, index) in tour.routes" :key="`compare_route_${tour.pdb_Id}_${index}`" class="text-[11px] text-neutral-600">
                        <span class="font-semibold text-neutral-700">{{ r.rDay }} {{ r.rMonth }} {{ r.rYear }}</span>
                        <span class="ml-2">{{ r?.turs_CityStart?.[locale] }} - {{ r?.turs_CityEnd?.[locale] }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4 rounded-xl border border-brand-200 bg-brand-50/40 p-3">
                    <div class="text-[11px] font-semibold text-brand-800 mb-2">{{$t('Konaklama')}}</div>
                    <div class="flex flex-col gap-3">
                      <div v-for="(htl, hIndex) in tour.hotels" :key="`compare_hotel_${tour.pdb_Id}_${hIndex}`" class="flex items-center gap-3 rounded-xl border border-brand-100 bg-white p-2">
                        <img :src="showImage(htl.sOtelPhoto, 60, 60, true, '', '')" :alt="htl.sOtelAdi?.[locale]" class="h-12 w-12 rounded-xl object-cover ring-2 ring-brand-100" />
                        <div class="min-w-0">
                          <div class="text-[11px] font-semibold text-neutral-900 truncate" v-html="htl.sOtelAdi?.[locale]"></div>
                          <div class="text-[10px] text-neutral-600">{{ htl.city?.[locale] }} • {{ htl.turo_Sure }} {{$t('gece')}}</div>
                          <div class="text-[10px] text-neutral-500" v-if="htl.star?.[locale]">{{$t('Yıldız')}}: {{ htl.star?.[locale] }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4 rounded-xl border border-neutral-200 bg-white p-3">
                    <div class="text-[11px] font-semibold text-neutral-700 mb-2">{{$t('Dahil Olan Hizmetler')}}</div>
                    <div class="grid grid-cols-1 gap-2 text-[11px] text-neutral-600">
                      <div class="flex items-start gap-2">
                        <span class="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full bg-support-50 text-support-700">
                          <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3" />
                        </span>
                        {{$t('Gidiş dönüş uçak bileti')}}
                      </div>
                      <div class="flex items-start gap-2">
                        <span class="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full bg-support-50 text-support-700">
                          <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3" />
                        </span>
                        {{$t('Hızlı tren ile ara geçiş')}}
                      </div>
                      <div class="flex items-start gap-2">
                        <span class="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full bg-support-50 text-support-700">
                          <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3" />
                        </span>
                        {{$t('Belirtilen 5 yıldızlı, yürüme mesafeli otellerde konaklama')}}
                      </div>
                      <div class="flex items-start gap-2">
                        <span class="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full bg-support-50 text-support-700">
                          <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3" />
                        </span>
                        {{$t('Sabah ve akşam açık büfe yemek')}}
                      </div>
                      <div class="flex items-start gap-2">
                        <span class="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full bg-support-50 text-support-700">
                          <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3" />
                        </span>
                        {{$t('Vize ve seyahat sigortası')}}
                      </div>
                      <div class="flex items-start gap-2">
                        <span class="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full bg-support-50 text-support-700">
                          <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3" />
                        </span>
                        {{$t('Tüm transferler')}}
                      </div>
                      <div class="flex items-start gap-2">
                        <span class="mt-0.5 h-5 w-5 inline-flex items-center justify-center rounded-full bg-support-50 text-support-700">
                          <font-awesome-icon icon="fa-solid fa-check" class="h-3 w-3" />
                        </span>
                        {{$t('İnanç Tur irşad ve rehberlik hizmetleri')}}
                      </div>
                    </div>
                  </div>

                  <div class="mt-4 rounded-2xl border border-accent-200 bg-accent-50/70 p-3">
                    <div class="flex justify-between">
                      <div class="text-xs text-accent-700 font-semibold mt-4 pl-2">{{$t('Toplam Ücret')}}</div>
                      <div class="flex flex-col items-end">
                        <div class="flex items-baseline gap-1">
                          <span class="text-lg py-0 font-extrabold text-neutral-900">{{ formatMoney(getTourTotal(tour, reservation)) }}</span>
                          <span class="text-[10px] font-semibold text-neutral-500">{{ tour.tour_Currency }}</span>
                        </div>
                        <div class="text-[10px] text-neutral-600">{{ previewPeopleLabel }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4 flex items-center gap-2">
                    <button
                      type="button"
                      class="h-9 px-3 inline-flex items-center rounded-full border border-neutral-200 bg-white text-neutral-700 text-xs font-semibold hover:bg-neutral-50"
                      @click.stop.prevent="goPath('/tourDetail/' + tour.pdb_Id)"
                    >
                      <font-awesome-icon icon="fa-solid fa-circle-info" class="h-3 w-3 mr-1" />
                      {{$t('Detaya Git')}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="border-t border-neutral-200 bg-neutral-50 px-6 py-3">
          <div class="flex flex-wrap items-center justify-between gap-3">
            <div class="text-xs text-neutral-600">
              {{$t('Toplam')}}: <span class="font-semibold text-neutral-800">{{ compareTours.length }}</span>
            </div>
            <div class="flex items-center gap-2">
              <button
                type="button"
                class="h-9 px-3 inline-flex items-center rounded-full border border-neutral-200 bg-white text-neutral-700 text-xs font-semibold hover:bg-neutral-50"
                @click.stop.prevent="goPath('/tour/umre-turlari')"
              >
                {{$t('Tur Listesine Dön')}}
              </button>
              <button
                type="button"
                class="h-9 px-3 inline-flex items-center rounded-full bg-accent-600 text-white text-xs font-semibold hover:bg-accent-500"
                @click="closeCompare"
              >
                {{$t('Kapat')}}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>



   <section v-if="seoLandingContent" class="mx-auto max-w-screen-xl px-4 py-5 sm:px-6 lg:px-10" aria-labelledby="umrah-landing-heading">
      <div class="overflow-hidden rounded-3xl border border-slate-200 bg-gradient-to-br from-white via-slate-50 to-amber-50/60 p-5 shadow-sm md:p-7">
        <p class="mb-2 text-xs font-bold uppercase tracking-[0.16em] text-amber-700">{{ seoLandingContent.eyebrow }}</p>
        <h2 ref="seoLandingHeadingRef" id="umrah-landing-heading" class="mb-3 text-2xl font-bold leading-tight text-slate-900 md:text-3xl">
          {{ seoLandingContent.heading }}
        </h2>
        <p class="mb-5 max-w-5xl text-sm leading-7 text-slate-700 md:text-base">{{ seoLandingContent.intro }}</p>

        <section
          v-if="seoLandingContent.cta"
          class="mb-5 flex flex-col gap-4 rounded-2xl border border-teal-200 bg-teal-50 p-4 md:flex-row md:items-center md:justify-between md:p-5"
          aria-labelledby="umrah-private-cta-heading"
        >
          <div>
            <h3 id="umrah-private-cta-heading" class="mb-1 text-lg font-bold text-slate-900">{{ seoLandingContent.cta.title }}</h3>
            <p class="mb-0 max-w-3xl text-sm leading-6 text-slate-700">{{ seoLandingContent.cta.text }}</p>
          </div>
          <a
            :href="getPath(seoLandingContent.cta.path)"
            @click.stop.prevent="goPath(seoLandingContent.cta.path)"
            class="inline-flex shrink-0 items-center justify-center rounded-xl bg-teal-700 px-5 py-3 text-sm font-bold text-white transition hover:bg-teal-800"
          >{{ seoLandingContent.cta.label }} →</a>
        </section>

        <section
          v-if="seoLandingContent.quickAnswers?.length"
          class="mb-5 rounded-2xl border border-teal-200 bg-teal-50/70 p-4 md:p-5"
          aria-labelledby="umrah-quick-answers-heading"
        >
          <h3 id="umrah-quick-answers-heading" class="mb-3 text-lg font-bold text-slate-900">
            {{ seoLandingContent.quickAnswersHeading }}
          </h3>
          <dl class="grid gap-3 md:grid-cols-3">
            <div v-for="item in seoLandingContent.quickAnswers" :key="item.question" class="rounded-xl bg-white p-4 shadow-sm">
              <dt class="mb-2 text-sm font-bold leading-5 text-slate-900">{{ item.question }}</dt>
              <dd class="mb-0 text-sm leading-6 text-slate-600">{{ item.answer }}</dd>
            </div>
          </dl>
        </section>

        <div v-if="showSeoStartingPrice" class="mb-5 flex flex-col gap-3 rounded-2xl border border-amber-200 bg-amber-50/70 p-4 md:flex-row md:items-center md:justify-between">
          <div>
            <p class="mb-0 text-xs font-bold uppercase tracking-[0.12em] text-amber-800">{{ locale === 'en' ? 'Starting package price' : 'Başlangıç paket fiyatı' }}</p>
            <strong class="mt-1 block text-2xl text-slate-900">{{ umrahSeoStrategy.startingPriceLabel }}</strong>
          </div>
          <p class="mb-0 max-w-3xl text-xs leading-5 text-slate-600 md:text-sm">
            {{ locale === 'en'
              ? 'Prices are per person and may vary by departure date, hotel and room occupancy. Check each live tour page for the current price and availability.'
              : 'Fiyatlar kişi başıdır; kalkış tarihi, otel ve oda yerleşimine göre değişebilir. Güncel fiyat ve kontenjan için her programın canlı tur detayını esas alın.' }}
          </p>
        </div>

        <div class="grid gap-3 md:grid-cols-3">
          <article v-for="item in seoLandingContent.highlights" :key="item.title" class="rounded-2xl border border-slate-200 bg-white p-4">
            <h3 class="mb-2 text-base font-bold text-slate-900">{{ item.title }}</h3>
            <p class="mb-0 text-sm leading-6 text-slate-600">{{ item.text }}</p>
          </article>
        </div>

        <div v-if="seoLandingContent.sections?.length" class="mt-5 grid gap-4 lg:grid-cols-3">
          <article
            v-for="section in seoLandingContent.sections"
            :key="section.title"
            class="rounded-2xl border border-slate-200 bg-white p-5"
          >
            <h3 class="mb-3 text-lg font-bold leading-6 text-slate-900">{{ section.title }}</h3>
            <p
              v-for="paragraph in section.paragraphs"
              :key="paragraph"
              class="mb-3 text-sm leading-7 text-slate-600 last:mb-0"
            >{{ paragraph }}</p>
          </article>
        </div>

        <nav class="mt-5 flex flex-wrap gap-2" :aria-label="locale === 'tr' ? 'Umre programı bağlantıları' : 'Umrah package links'">
          <a
            v-for="item in seoLandingContent.links"
            :key="item.path"
            :href="getPath(item.path)"
            @click.stop.prevent="goPath(item.path)"
            class="rounded-full border border-brand-200 bg-white px-3 py-1.5 text-xs font-semibold text-brand-800 transition hover:border-brand-400 hover:bg-brand-50"
          >{{ item.label }}</a>
        </nav>
      </div>
    </section>


    <section v-if="premiumTourContent" class="mx-auto max-w-screen-xl px-4 pb-6 sm:px-6 lg:px-10 PY-6" aria-labelledby="premium-umrah-types-heading">
      <div class="rounded-3xl border border-amber-200/70 bg-gradient-to-br from-amber-50 via-white to-slate-50 p-5 md:p-7">
        <h2 id="premium-umrah-types-heading" class="mb-3 text-xl font-bold leading-tight text-slate-900 md:text-2xl">
          {{ premiumTourContent.heading }}
        </h2>
        <p class="mb-5 max-w-5xl text-sm leading-7 text-slate-700 md:text-base">{{ premiumTourContent.intro }}</p>

        <div class="grid gap-3 md:grid-cols-3">
          <a
            v-for="item in premiumTourContent.cards"
            :key="item.path"
            :href="getPath(item.path)"
            :title="item.title"
            @click.stop.prevent="goPath(item.path)"
            class="group rounded-2xl border border-slate-200 bg-white p-4 transition hover:-translate-y-0.5 hover:border-amber-400 hover:shadow-md"
          >
            <h3 class="mb-2 text-base font-bold text-slate-900 group-hover:text-brand-800">{{ item.title }}</h3>
            <p class="mb-0 text-sm leading-6 text-slate-600">{{ item.text }}</p>
          </a>
        </div>

        <p class="mb-0 mt-5 rounded-2xl bg-slate-900 px-4 py-3 text-sm leading-6 text-slate-100">
          {{ premiumTourContent.selectionGuide }}
        </p>
        <a
          v-if="locale === 'tr'"
          :href="getPath('/page/en-iyi-umre-turu-nasil-secilir')"
          class="mt-4 inline-flex text-sm font-extrabold text-teal-800 hover:underline"
          @click.stop.prevent="goPath('/page/en-iyi-umre-turu-nasil-secilir')"
        >Umre turu tavsiye ve seçim rehberini okuyun →</a>
      </div>
    </section>

    <button
      v-if="!isMobile && compareTours.length > 0"
      type="button"
      class="fixed right-4 bottom-24 z-40 h-11 px-4 inline-flex items-center rounded-full bg-accent-600 text-white text-xs font-semibold shadow-lg hover:bg-accent-500"
      @click="openCompare"
    >
      <font-awesome-icon icon="fa-solid fa-code-compare" class="h-4 w-4 mr-2" />
      {{$t('Karşılaştır')}} ({{ compareTours.length }})
    </button>
    <TransitionRoot appear :show="isOpen" as="template">
      <Dialog as="div" @close="closeModal" :show="isOpen" class="relative z-40">
          <TransitionChild v-if="isOpen && selectedTour" as="template" enter="duration-300 ease-out" enter-from="opacity-0"
          enter-to="opacity-100" leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
          <div class="fixed inset-0 bg-black/25" />
        </TransitionChild> 

        <div class="fixed inset-0 overflow-y-auto">
          <div class="flex min-h-full items-center justify-center p-4 text-center">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100" leave="duration-200 ease-in" leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95">
              <DialogPanel
                class="w-full max-w-4xl transform overflow-hidden rounded-2xl bg-white p-2 text-left align-middle shadow-xl transition-all">
                <DialogTitle as="h3" class="text-sm md:text-lg py-2 px-1 font-medium leading-6 mb-0 text-gray-900 flex items-center justify-between">
                  <div class="text-md font-semibold">{{ selectedTour.start }} - {{ selectedTour.tur_Sure }} {{ $t('gün') }}  {{ $t('umre') }}</div>
                   <img :src="showImage(selectedTour.airwayLogo, '', 30, '', '', '')" title="Airway" alt="Airway" class="h-5 ml-4 "  style="width:67px;height: 20px;" />
                </DialogTitle>
                <div class="mt-0">
                  <div class="bg-white">
                    <div class="w-full mx-auto pt-2 px-1 ">
                      <div class="block md:flex md:space-x-2">
                        <div class="w-full px-1 md:p-2 w-full border-b-1 md:border border-slate-100 text-sm rounded-md  block"
                          v-for="(r, index) in  selectedTour.routes">
                          <span class="flex text-md items-center">
                            <span class="p-2 flex items-center justify-center bg-pruple-100  text-orange-800 flex items-center rounded-full">
                              <font-awesome-icon :icon="'fa-solid ' + r.turs_Transporter" class="h-3 w-3" />
                            </span>
                            <span class="flex items-center font-semibold text-sm p-1 ">{{ r.rDay }} {{ r.rMonth }} {{ r.rYear }}</span>
                            <span class="flex items-center mr-2 text-sm rounded-r-md">{{ r.rDayName }}</span> 

                          </span>
                          <span class="text-slate-600" v-if="r">
                            {{ r?.turs_CityStart?.[locale] }} - {{ r?.turs_CityEnd?.[locale] }} <span
                              v-html="r.turs_transDetail?.[locale]"></span>
                          </span>
                        </div>
                      </div>

                       
                      <div class="flex  flex-col w-full border-b border-b-slate-50 justify-center my-1 pt-1 md:my-1 items-start md:px-1 md:py-2 border-t ">
                        <span class="  font-bold text-sm md:mb-2">{{$t('Konaklama')}}</span>
                        <div class="py-4 flex w-full flex-col space-y-4  md:flex-row md:space-x-2 md:space-y-1">
 
                          <template v-for="htl in selectedTour.hotels">
                              <div 
                                class="px-2 w-full flex space-x-3"
                                v-if="htl.sOtelAdi?.tr"
                                >
                                <img :class="`rounded-l-lg hover:opacity-80 ring-offset-2 ring-2  rounded-lg`"
                                       :src="showImage(htl.sOtelPhoto, 100, 100, true, '', '')" :alt="htl.sOtelAdi?.[locale]"
                                       style="width:64px;height: 64px;"
                                       />
                                       <div class="flex flex-col">
                                <div class="mt-1 text-sm flex">
                                  <strong  v-html="htl.sOtelAdi?.[locale]"></strong> 
                                  <a :href="`#${htl.sOtelAdi?.[locale]}`" @click="openSidebar(htl)" class=" ml-2">
                                    <font-awesome-icon icon="fa-solid fa-external-link" class="h-4 w-4"></font-awesome-icon>
                                  </a>
                                </div>
                                <div class="mt-0 md:mt-2 text-sm">{{$t('Şehir')}}: {{htl.city?.[locale] }} ({{ htl.turo_Sure }} {{$t('gece')}})</div>
                                <div class="mt-0 md:mt-1 text-sm">{{$t('Yıldız')}}: {{htl.star?.[locale] }}</div>
                                <div class="mt-0 md:mt-1 text-sm" v-if="htl.sOtelShort?.[locale]">{{$t('Konum')}}: {{htl.sOtelShort?.[locale] }}</div>
                              </div> 
                            </div>
                          </template>
                          </div>
                        </div> 
                      <div class="border-b border-b-slate-100">
                      <span class="  font-bold text-sm">{{$t('Ücretler')}} </span>
                    <div class="py-0">
                      <div class="flex flex-wrap md:grid  sm:grid-cols-5 lg:grid-cols-5"> 
                        <div
                          class="bg-slate-50 w-1/2 md:w-full  hover:bg-slate-100 text-slate-800 py-1 md:p-2 border border-slate-100 text-center">
                          <h3 class="font-semibold text-xs leading-4 mb-0">{{$t('İkili Oda')}} </h3>
                          <div class="text-[10px] font-bold text-slate-500 leading-4 line-through" v-if="selectedTour.turs_double_high && selectedTour.turs_double!=selectedTour.turs_double_high">{{ formatMoney(selectedTour.turs_double_high) }} {{ selectedTour.tour_Currency }}</div>
                          <p class="text-center font-bold my-0 md:my-1 leading-4" :class="selectedTour.turs_double_high && selectedTour.turs_double!=selectedTour.turs_double_high ? 'text-green-600 mt-1 leading-4' : 'mt-1 leading-5'">{{ formatMoney(selectedTour.turs_double) }} {{ selectedTour.tour_Currency }}  </p>
                          <span class="text-[9px] text-slate-400 block leading-4">*{{$t('kişi başı')}}</span>
                        </div>
                        <div
                          class="bg-slate-50 w-1/2 md:w-full  hover:bg-slate-100 text-slate-800 py-1 md:p-2 border border-slate-100 text-center ">
                          <h3 class="font-semibold text-xs leading-4 mb-0">{{$t('Üçlü Oda')}} </h3>
                          <div class="text-[10px] font-bold text-slate-500 leading-4 line-through" v-if="selectedTour.turs_triple_high && selectedTour.turs_triple!=selectedTour.turs_triple_high">{{ formatMoney(selectedTour.turs_triple_high) }} {{ selectedTour.tour_Currency }}</div>
                          <p class="text-center font-bold my-0 md:my-1 leading-4" :class="selectedTour.turs_triple_high && selectedTour.turs_triple!=selectedTour.turs_triple_high ? 'text-green-600 mt-1 leading-4' : 'mt-1 leading-5'">{{ formatMoney(selectedTour.turs_triple) }} {{ selectedTour.tour_Currency }}</p>
                          <span class="text-[9px] text-slate-400 block leading-4">*{{$t('kişi başı')}}</span>
                        </div>
                        <div
                          class="bg-slate-50 w-1/3 md:w-full hover:bg-slate-100 text-slate-800 py-1 md:p-2 border border-slate-100 text-center">
                          <h3 class="font-semibold text-xs leading-5 mb-0">{{$t('Single Oda')}}</h3>
                          <div class="text-[10px] font-bold text-slate-500  leading-4 line-through" v-if="selectedTour.turs_single_high && selectedTour.turs_single!=selectedTour.turs_single_high">{{ formatMoney(selectedTour.turs_single_high) }} {{ selectedTour.tour_Currency }}</div>
                          <p class="text-center font-bold  my-0 md:my-1 leading-4" :class="selectedTour.turs_single_high && selectedTour.turs_single!=selectedTour.turs_single_high ? 'text-green-600 mt-1 leading-4' : 'mt-1 leading-5'">{{ formatMoney(selectedTour.turs_single) }} {{ selectedTour.tour_Currency }}
                          </p>
                        </div>
                        <div
                          class="bg-slate-50 w-1/3 md:w-full hover:bg-slate-100 text-slate-800 py-1 md:p-2 border border-slate-100 text-center">
                          <h3 class="font-semibold text-xs leading-5 mb-0">{{$t('Çocuk')}}(2-11)</h3>
                          <div class="text-[10px]  font-bold text-slate-500  leading-4 line-through" v-if="selectedTour.turs_child_high && selectedTour.turs_child_high!='0' && selectedTour.turs_child!=selectedTour.turs_child_high">{{ formatMoney(selectedTour.turs_child_high) }} {{ selectedTour.tour_Currency }}</div>
                          <p class="text-center font-bold  my-0 md:my-1 leading-4" :class="selectedTour.turs_child_high && selectedTour.turs_child!=selectedTour.turs_child_high ? 'text-green-600 mt-1 leading-4' : 'mt-1 leading-5'">{{ formatMoney(selectedTour.turs_child) }} {{ selectedTour.tour_Currency }}</p>
                          <span class="text-[9px] text-slate-400 block  leading-4">*{{$t('Yataksız')}}</span>
                        </div>
                        <div
                          class="bg-slate-50 w-1/3 md:w-full hover:bg-slate-100 text-slate-800 py-1 md:p-2 border border-slate-100 text-center">
                          <h3 class="font-semibold text-xs leading-5 mb-0">{{$t('Bebek')}}(0-2)</h3>
                          <div class="text-[10px]  font-bold text-slate-500 leading-4 line-through" v-if="selectedTour.turs_baby_high && selectedTour.turs_baby_high!='0' && selectedTour.turs_baby!=selectedTour.turs_baby_high">{{ formatMoney(selectedTour.turs_baby_high) }} {{ selectedTour.tour_Currency }}</div>
                          <p class="text-center font-bold my-0 md:my-1 leading-4" :class="selectedTour.turs_baby_high && selectedTour.turs_baby!=selectedTour.turs_baby_high ? 'text-green-600 mt-1 leading-4' : 'mt-1 leading-5'">{{ formatMoney(selectedTour.turs_baby) }} {{ selectedTour.tour_Currency }} </p>
                          <span class="text-[9px] text-slate-400 block leading-4">*{{$t('Yataksız')}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
                </div>

                <!-- <div @click="closeModal()" class="-top-2 absolute -right-2 p-1 text-center justify-center rounded-full shadow-lg">
                    <font-awesome-icon icon="fa-solid fa-times" class="h-5 w-5"></font-awesome-icon>
                </div> -->
                <div class="mt-2 md:mt-4 mb-2 px-2 flex justify-between space-x-2">
                  <span class="flex  space-x-2">
                      
                          <a :href="buildWhatsAppUrl(`Merhaba ${selectedTour.start} tarihli ${selectedTour.tur_Sure} günlük, ${selectedTour.otel1_adi?.tr || ''}, ${selectedTour.otel2_adi?.tr || ''} turunuz hakkında bilgi almak istiyorum.`)"
                        target="_blank" rel="nofollow noopener noreferrer"
                        :title="$t('Detaylar')"
                        class="whatsappTrigger cursor-pointer border bg-teal-500 text-white border border-slate-200 shadow-md hover:bg-yellow-500 hover:text-white font-medium rounded-lg px-2 md:px-2 h-8 text-xs flex items-center">
                        <font-awesome-icon icon="fa-brands fa-whatsapp" class="h-4 w-4 text-white"></font-awesome-icon>
                      </a>
                         <a  href="tel:+908502414141"
                          class=" cursor-pointer   border   bg-yellow-500 text-white border border-slate-200 shadow-md hover:bg-yellow-500 hover:text-white font-medium rounded-lg px-2 md:px-2 h-8 text-xs flex items-center"
                         > <font-awesome-icon icon="fa-solid fa-phone" class="h-4 w-4 text-white"></font-awesome-icon>
                        </a>
                      <!-- <GlobalButton :label="$t('Rezervation')" color="amber" size="sm" variant="primary"> </GlobalButton> -->
                      <GlobalButton  @click="goPath('/tourDetail/' + selectedTour.pdb_Id)"  :label="$t('Detaylar')" color="sky" size="sm" variant="primary"> </GlobalButton>
                  </span>
                  <GlobalButton  @click="closeModal()"  :label="$t('Kapat')" color="slate" size="sm" variant="light"> </GlobalButton>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
 


     <!-- Tarihler Modal -->
    <TransitionRoot appear :show="detailMenuView" as="template">
      <Dialog as="div" @close="detailMenuView=false" class="relative z-40">
        <TransitionChild as="template" enter="duration-200 ease-out" enter-from="opacity-0" enter-to="opacity-100"
                         leave="duration-150 ease-in" leave-from="opacity-100" leave-to="opacity-0">
          <div class="fixed inset-0 bg-black/40" />
        </TransitionChild>

        <div class="fixed inset-0 overflow-y-auto">
          <div class="flex min-h-full items-center justify-center p-3 text-center">
            <TransitionChild as="template" enter="duration-200 ease-out" enter-from="opacity-0 scale-95"
                             enter-to="opacity-100 scale-100" leave="duration-150 ease-in"
                             leave-from="opacity-100 scale-100" leave-to="opacity-0 scale-95">
              <DialogPanel class="w-full max-w-md sm:max-w-lg md:max-w-2xl transform overflow-hidden rounded-2xl bg-white p-3 text-left align-middle shadow-xl transition-all">
                <div class="flex items-center justify-between mb-2">
                  <h3 class="text-sm md:text-base font-semibold text-slate-700">{{$t('Müsait Tarihler')}}</h3>
                  <button
                    type="button"
                    class="inline-flex items-center justify-center rounded-md border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 w-8 h-8"
                    aria-label="close"
                    @click="detailMenuView=false"
                  >
                    <font-awesome-icon icon="fa-solid fa-times" class="h-4 w-4"></font-awesome-icon>
                  </button>
                </div>
                <p class="text-xs text-slate-500 mb-2">{{$t('Kesin kalkışlı tur tarihleri.')}}</p>

                <div class="max-h-[70vh] overflow-y-auto">
                  <div v-for="(item, key) in toursDateListMonth" :key="'k_' + key" class="rounded-md border border-slate-200 mb-2">
                    <button
                      type="button"
                      class="w-full flex items-center justify-between text-xs font-semibold px-3 py-2"
                      @click="toggleMonth(item)"
                    >
                      <span class="text-slate-700">{{ item }}</span>
                      <font-awesome-icon icon="fa-solid fa-chevron-down" class="h-3 w-3 text-slate-400"></font-awesome-icon>
                    </button>

                    <div class="px-2 pb-2" v-show="toursDateList[item].show">
                      <template v-for="(item2, key2) in toursDateList[item]">
                        <button
                          v-if="item2 && item2.date"
                          type="button"
                          @click="scrollTo(item2.id); detailMenuView=false"
                          class="inline-flex items-center border mr-1 mb-1 border-slate-200 hover:bg-slate-50 bg-white text-xs px-2 py-1 rounded"
                        >
                          {{ item2.date }} ({{ item2?.total }}tur)
                        </button>
                      </template>
                    </div>
                  </div>
                </div>

              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>



     <!-- Otel Seçimi Modal -->
    <TransitionRoot appear :show="showHotelModal" as="template">
      <Dialog as="div" @close="closeHotelModal" class="relative z-50">
        <TransitionChild as="template" enter="duration-200 ease-out" enter-from="opacity-0" enter-to="opacity-100"
                         leave="duration-150 ease-in" leave-from="opacity-100" leave-to="opacity-0">
          <div class="fixed inset-0 bg-black/40" />
        </TransitionChild>

        <div class="fixed inset-0 overflow-y-auto">
          <div class="flex min-h-full items-center justify-center p-3 text-center">
            <TransitionChild as="template" enter="duration-200 ease-out" enter-from="opacity-0 scale-95"
                             enter-to="opacity-100 scale-100" leave="duration-150 ease-in"
                             leave-from="opacity-100 scale-100" leave-to="opacity-0 scale-95">
              <DialogPanel class="w-full max-w-md sm:max-w-lg md:max-w-2xl transform overflow-hidden rounded-2xl bg-white p-3 text-left align-middle shadow-xl transition-all">
                <div class="flex items-center justify-between mb-2">
                  <h3 class="text-sm md:text-base font-semibold text-slate-700">{{ $t('Umre Otellerini Filtrele') }}</h3>
                  <button
                    type="button"
                    class="inline-flex items-center justify-center rounded-md border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 w-8 h-8"
                    aria-label="close"
                    @click="closeHotelModal"
                  >
                    <font-awesome-icon icon="fa-solid fa-times" class="h-4 w-4"></font-awesome-icon>
                  </button>
                </div>

                <div class="mb-3">
                  <button
                    type="button"
                    class="w-full text-left text-xs px-3 py-2 rounded border border-slate-200 hover:bg-slate-50"
                    @click="selectAllHotels"
                  >
                    <font-awesome-icon
                      :icon="(!search.activeHotelId || search.activeHotelId==='all') ? 'fa-solid fa-circle-check' : 'fa-solid fa-circle'"
                      :class="(!search.activeHotelId || search.activeHotelId==='all') ? 'text-green-600' : 'text-slate-400'"
                      class="h-4 w-4 mr-2"
                    />
                    {{ $t('Tüm Oteller') }}
                  </button>
                </div>

                <!-- Medine -->
                <p class="leading-5 mb-1 text-sm text-slate-700 font-semibold">
                  {{$t('Medine Otellerimiz')}}
                </p>
                <ul class="divide-y divide-slate-100">
                  <li
                    v-for="h in hotels.filter(x => x.city === 'Medine')"
                    :key="`medine_modal_${h.id}`"
                    class="py-2 flex items-center justify-between"
                  >
                    <button
                      type="button"
                      class="flex items-center text-left flex-1 hover:bg-slate-50 rounded px-2 py-1"
                      @click.prevent="chooseHotel(h)"
                    >
                      <font-awesome-icon
                        :icon="search.activeHotelId === h.id ? 'fa-solid fa-circle-check' : 'fa-solid fa-circle'"
                        :class="search.activeHotelId === h.id ? 'text-green-600' : 'text-slate-400'"
                        class="w-4 h-4 mr-2"
                      />
                      <span class="text-sm text-slate-700">{{ h.name }}</span>
                    </button>
                    <a
                      :href="getPath(h.link)"
                      @click.prevent.stop="goPathBlank(h.link)"
                      class="ml-2 text-xs px-2 py-1 rounded border border-slate-300 text-slate-600 hover:bg-slate-50"
                    >
                      {{$t('İncele')}}
                    </a>
                  </li>
                </ul>

                <!-- Mekke -->
                <p class="leading-5 mt-4 mb-1 text-sm text-slate-700 font-semibold">
                  {{$t('Mekke Otellerimiz')}}
                </p>
                <ul class="divide-y divide-slate-100">
                  <li
                    v-for="h in hotels.filter(x => x.city === 'Mekke')"
                    :key="`mekke_modal_${h.id}`"
                    class="py-2 flex items-center justify-between"
                  >
                    <button
                      type="button"
                      class="flex items-center text-left flex-1 hover:bg-slate-50 rounded px-2 py-1"
                      @click.prevent="chooseHotel(h)"
                    >
                      <font-awesome-icon
                        :icon="search.activeHotelId === h.id ? 'fa-solid fa-circle-check' : 'fa-solid fa-circle'"
                        :class="search.activeHotelId === h.id ? 'text-green-600' : 'text-slate-400'"
                        class="w-4 h-4 mr-2"
                      />
                      <span class="text-sm text-slate-700">{{ h.name }}</span>
                    </button>
                    <a
                      :href="getPath(h.link)"
                      @click.prevent.stop="goPathBlank(h.link)"
                      class="ml-2 text-xs px-2 py-1 rounded border border-slate-300 text-slate-600 hover:bg-slate-50"
                    >
                      {{$t('İncele')}}
                    </a>
                  </li>
                </ul>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>

      <TransitionRoot appear :show="showVideoModal" as="template">
      <Dialog as="div" @close="closeVideoModal" class="relative z-50">
        <TransitionChild as="template" enter="duration-200 ease-out" enter-from="opacity-0" enter-to="opacity-100"
                         leave="duration-150 ease-in" leave-from="opacity-100" leave-to="opacity-0">
          <div class="fixed inset-0 bg-black/40" />
        </TransitionChild>

        <div class="fixed inset-0 overflow-y-auto">
          <div class="flex min-h-full items-center justify-center p-3 text-center">
            <TransitionChild as="template" enter="duration-200 ease-out" enter-from="opacity-0 scale-95"
                             enter-to="opacity-100 scale-100" leave="duration-150 ease-in"
                             leave-from="opacity-100 scale-100" leave-to="opacity-0 scale-95">
              <DialogPanel class="w-full max-w-md sm:max-w-lg md:max-w-2xl transform overflow-hidden rounded-2xl bg-white p-2 text-left align-middle shadow-xl transition-all">
                <div class="relative">
                    <button
                    type="button"
                    class="right-2 float-right mb-1 inline-flex items-center justify-center rounded-md border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 w-fit h-8 px-2"
                    aria-label="close"
                    @click="closeVideoModal"
                  >
                    <font-awesome-icon icon="fa-solid fa-times" class="h-4 w-4"></font-awesome-icon> Videoyu Kapat
                  </button>
                  <div style="position: relative; width: 100%; height: 0; padding-top: 177.7778%; padding-bottom: 0; overflow: hidden; border-radius: 8px;">
                    <iframe
                      loading="lazy"
                      style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0;"
                      src="https://www.canva.com/design/DAGTNCUdJiY/lwQ9w0k-QS8W4YvbmdlgRA/watch?embed"
                      allowfullscreen="allowfullscreen"
                      allow="fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      title="Neden İnanç Tur?"
                    ></iframe>
                   
                  </div>
                  
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>


    <section v-if="seoFaqs.length" class="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 lg:px-10" aria-labelledby="umrah-faq-heading">
      <div class="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm md:p-8">
        <p class="mb-2 text-xs font-bold uppercase tracking-[0.16em] text-brand-700">{{ locale === 'tr' ? 'Karar vermeden önce' : 'Before you decide' }}</p>
        <h2 id="umrah-faq-heading" class="mb-5 text-2xl font-bold text-slate-900 md:text-3xl">
          {{ seoLandingContent?.faqHeading || (locale === 'tr' ? 'Umre Turları ve Fiyatları Hakkında Sorulanlar' : 'Questions About Umrah Packages and Prices') }}
        </h2>
        <div class="grid gap-3 md:grid-cols-2">
          <details v-for="item in seoFaqs" :key="item.question" class="group rounded-2xl border border-slate-200 bg-slate-50/70 p-4 open:bg-white">
            <summary class="cursor-pointer list-none pr-6 text-sm font-bold leading-6 text-slate-900">{{ item.question }}</summary>
            <p class="mb-0 mt-3 text-sm leading-6 text-slate-600">{{ item.answer }}</p>
          </details>
        </div>
      </div>
    </section>

    <AdvancedFaqClient v-if="pageData?.faq"></AdvancedFaqClient>

    <!-- ===== Global Kişi & Oda Düzenleme Overlay ===== -->
    <Teleport to="body">
      <Transition name="people-overlay">
        <div v-if="globalPeopleEditorOpen" class="fixed inset-0 z-[70] flex items-end md:items-center justify-center">
          <!-- Backdrop -->
          <div class="absolute inset-0 bg-neutral-900/50 backdrop-blur-sm" @click="closeGlobalPeopleEditor"></div>
          <!-- Panel -->
          <div class="people-overlay-panel relative z-10 w-full md:max-w-2xl bg-white md:rounded-2xl rounded-t-2xl shadow-2xl flex flex-col" style="max-height: 92vh;">
            <!-- Header -->
            <div class="flex items-center justify-between px-5 py-4 border-b border-neutral-100 shrink-0">
              <div class="flex items-center gap-3">
                <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-amber-50 text-amber-600 shrink-0">
                  <font-awesome-icon icon="fa-solid fa-users" class="h-4 w-4" />
                </span>
                <div>
                  <h3 class="text-sm font-bold text-neutral-900 mb-0 leading-tight">{{ $t('Oda Seçimi') }}</h3>
                  <p class="text-xs text-neutral-500 mb-0 leading-tight">{{ $t('Kişi ve çocuk bilgilerini girin') }}</p>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <button type="button" @click.stop.prevent="resetPeopleSelection" class="h-8 px-3 rounded-full border border-neutral-200 text-xs font-semibold text-neutral-500 hover:bg-neutral-50 transition-colors">
                  {{ $t('Sıfırla') }}
                </button>
                <button type="button" @click="closeGlobalPeopleEditor" class="h-9 w-9 inline-flex items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-500 hover:bg-neutral-50 transition-colors">
                  <font-awesome-icon icon="fa-solid fa-xmark" class="h-4 w-4" />
                </button>
              </div>
            </div>

            <!-- Body -->
            <div class="flex-1 overflow-y-auto px-5 py-4 space-y-5">
              <!-- Rooms -->
              <div>
                <div v-for="(room, roomIdx) in reservation.rooms" :key="`gpe_room_${roomIdx}`" class="mb-4">
                  <div class="flex items-center justify-between mb-2.5">
                    <span class="text-sm font-bold text-neutral-800">{{ roomIdx + 1 }}. {{ $t('Oda') }}</span>
                    <button v-if="roomIdx !== 0" type="button" @click.stop.prevent="removeRoom(roomIdx)" class="text-xs text-rose-500 hover:text-rose-600 font-medium transition-colors">
                      {{ $t('Odayı Kaldır') }}
                    </button>
                  </div>
                  <div class="grid grid-cols-3 gap-3">
                    <!-- Yetişkin -->
                    <div class="flex flex-col gap-1.5">
                      <label class="text-[11px] font-semibold text-neutral-400 uppercase tracking-wide">{{ $t('Yetişkin') }} (12+)</label>
                      <div class="flex items-center rounded-xl border border-neutral-200 bg-neutral-50 overflow-hidden">
                        <button type="button" @click="room.adult = Math.max(1, room.adult - 1)" class="h-10 w-10 flex items-center justify-center text-neutral-500 hover:bg-neutral-200 transition-colors text-base font-bold shrink-0">−</button>
                        <span class="flex-1 text-center text-base font-bold text-neutral-900">{{ room.adult }}</span>
                        <button type="button" @click="room.adult = Math.min(5, room.adult + 1)" class="h-10 w-10 flex items-center justify-center text-neutral-500 hover:bg-neutral-200 transition-colors text-base font-bold shrink-0">+</button>
                      </div>
                    </div>
                    <!-- Çocuk -->
                    <div class="flex flex-col gap-1.5">
                      <label class="text-[11px] font-semibold text-neutral-400 uppercase tracking-wide">{{ $t('Çocuk') }} (2-11)</label>
                      <div class="flex items-center rounded-xl border border-neutral-200 bg-neutral-50 overflow-hidden">
                        <button type="button" @click="room.child = Math.max(0, room.child - 1)" class="h-10 w-10 flex items-center justify-center text-neutral-500 hover:bg-neutral-200 transition-colors text-base font-bold shrink-0">−</button>
                        <span class="flex-1 text-center text-base font-bold text-neutral-900">{{ room.child }}</span>
                        <button type="button" @click="room.child = Math.min(4, room.child + 1)" class="h-10 w-10 flex items-center justify-center text-neutral-500 hover:bg-neutral-200 transition-colors text-base font-bold shrink-0">+</button>
                      </div>
                    </div>
                    <!-- Bebek -->
                    <div class="flex flex-col gap-1.5">
                      <label class="text-[11px] font-semibold text-neutral-400 uppercase tracking-wide">{{ $t('Bebek') }} (0-2)</label>
                      <div class="flex items-center rounded-xl border border-neutral-200 bg-neutral-50 overflow-hidden">
                        <button type="button" @click="room.baby = Math.max(0, room.baby - 1)" class="h-10 w-10 flex items-center justify-center text-neutral-500 hover:bg-neutral-200 transition-colors text-base font-bold shrink-0">−</button>
                        <span class="flex-1 text-center text-base font-bold text-neutral-900">{{ room.baby }}</span>
                        <button type="button" @click="room.baby = Math.min(4, room.baby + 1)" class="h-10 w-10 flex items-center justify-center text-neutral-500 hover:bg-neutral-200 transition-colors text-base font-bold shrink-0">+</button>
                      </div>
                    </div>
                  </div>
                </div>
                <button type="button" @click.stop.prevent="addRoom" class="w-full h-10 rounded-xl border border-dashed border-neutral-300 text-sm font-semibold text-neutral-500 hover:bg-neutral-50 hover:border-neutral-400 transition-colors">
                  + {{ $t('Oda Ekle') }}
                </button>
              </div>

              <!-- Çocuk yaşları ve yatak seçimi -->
              <div v-if="totalKidsCount > 0" class="border-t border-neutral-100 pt-5">
                <div class="flex items-start justify-between mb-4">
                  <div>
                    <span class="text-sm text-left font-bold text-neutral-800 mb-0 leading-tight">{{ $t('Çocukların yaşlarını belirtin') }}</span>
                   </div>
                </div>
                <div class="space-y-3">
                  <div v-for="(age, ageIdx) in reservation.childrenAges" :key="`gpe_age_${ageIdx}`" class="rounded-2xl border border-neutral-200 bg-neutral-50/60 p-3.5">
                    <!-- Age row -->
                    <div class="flex items-center gap-3 mb-3">
                      <span class="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-100 text-brand-700 text-xs font-bold">{{ ageIdx + 1 }}</span>
                      <select v-model="reservation.childrenAges[ageIdx]" @change="onSidebarChildAgeChange(ageIdx)" class="h-10 flex-1 rounded-xl border border-neutral-200 bg-white px-3 text-sm font-medium text-neutral-800 appearance-none">
                        <option value="">{{ $t('Yaş seçin') }}</option>
                        <option v-for="n in 18" :key="`gpe_age_opt_${ageIdx}_${n}`" :value="n - 1">{{ n - 1 === 0 ? '0 (' + $t('bebek') + ')' : (n - 1) + ' ' + $t('yaş') }}</option>
                      </select>
                      <button type="button" @click.stop.prevent="removeChildAge(ageIdx)" class="h-8 w-8 shrink-0 inline-flex items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-400 hover:text-rose-500 hover:border-rose-200 transition-colors">
                        <font-awesome-icon icon="fa-solid fa-xmark" class="h-3.5 w-3.5" />
                      </button>
                    </div>
                    <!-- Bed options -->
                    <div v-if="getSidebarChildBedOptionsByIndex(ageIdx).length > 0" class="grid grid-cols-1 sm:grid-cols-3 gap-2">
                      <button
                        v-for="opt in getSidebarChildBedOptionsByIndex(ageIdx)"
                        :key="`gpe_bed_${ageIdx}_${opt.key}`"
                        type="button"
                        @click="selectSidebarChildBedOption(ageIdx, opt.key)"
                        class="relative flex items-center gap-3 rounded-xl border p-3 text-left transition-all"
                        :class="sidebarChildBedChoices[ageIdx] === opt.key
                          ? 'border-sky-400 bg-sky-50 ring-1 ring-sky-300 ring-offset-1'
                          : 'border-neutral-200 bg-white hover:border-neutral-300 hover:bg-neutral-50'"
                      >
                        <!-- SVG illustration -->
                        <div class="flex h-10 w-14 shrink-0 items-center justify-center rounded-lg transition-colors" :class="sidebarChildBedChoices[ageIdx] === opt.key ? 'bg-sky-100' : 'bg-neutral-100'">
                          <!-- Baby Crib -->
                          <svg v-if="opt.kind === 'turBaby'" viewBox="0 0 52 30" class="h-6 w-10">
                            <rect x="2" y="5" width="48" height="20" rx="5" :fill="sidebarChildBedChoices[ageIdx] === opt.key ? '#bfdbfe' : '#e2e8f0'" :stroke="sidebarChildBedChoices[ageIdx] === opt.key ? '#60a5fa' : '#94a3b8'" stroke-width="1.5"/>
                            <line x1="10" y1="5" x2="10" y2="25" :stroke="sidebarChildBedChoices[ageIdx] === opt.key ? '#93c5fd' : '#cbd5e1'" stroke-width="1.2"/>
                            <line x1="19" y1="5" x2="19" y2="25" :stroke="sidebarChildBedChoices[ageIdx] === opt.key ? '#93c5fd' : '#cbd5e1'" stroke-width="1.2"/>
                            <line x1="28" y1="5" x2="28" y2="25" :stroke="sidebarChildBedChoices[ageIdx] === opt.key ? '#93c5fd' : '#cbd5e1'" stroke-width="1.2"/>
                            <line x1="37" y1="5" x2="37" y2="25" :stroke="sidebarChildBedChoices[ageIdx] === opt.key ? '#93c5fd' : '#cbd5e1'" stroke-width="1.2"/>
                            <line x1="46" y1="5" x2="46" y2="25" :stroke="sidebarChildBedChoices[ageIdx] === opt.key ? '#93c5fd' : '#cbd5e1'" stroke-width="1.2"/>
                          </svg>
                          <!-- Extra Bed -->
                          <svg v-else-if="opt.kind === 'turChild'" viewBox="0 0 52 30" class="h-6 w-10">
                            <rect x="2" y="5" width="48" height="20" rx="5" :fill="sidebarChildBedChoices[ageIdx] === opt.key ? '#d1fae5' : '#e2e8f0'" :stroke="sidebarChildBedChoices[ageIdx] === opt.key ? '#34d399' : '#94a3b8'" stroke-width="1.5"/>
                            <rect x="5" y="8" width="14" height="8" rx="3" :fill="sidebarChildBedChoices[ageIdx] === opt.key ? '#ecfdf5' : '#f1f5f9'"/>
                            <path d="M5 21 Q26 14 50 21" fill="none" :stroke="sidebarChildBedChoices[ageIdx] === opt.key ? '#6ee7b7' : '#cbd5e1'" stroke-width="2"/>
                          </svg>
                          <!-- Shared Bed -->
                          <svg v-else viewBox="0 0 52 30" class="h-6 w-10">
                            <rect x="2" y="5" width="48" height="20" rx="5" :fill="sidebarChildBedChoices[ageIdx] === opt.key ? '#fde68a' : '#e2e8f0'" :stroke="sidebarChildBedChoices[ageIdx] === opt.key ? '#f59e0b' : '#94a3b8'" stroke-width="1.5"/>
                            <rect x="5" y="8" width="14" height="8" rx="3" :fill="sidebarChildBedChoices[ageIdx] === opt.key ? '#fffbeb' : '#f1f5f9'"/>
                            <rect x="33" y="8" width="14" height="8" rx="3" :fill="sidebarChildBedChoices[ageIdx] === opt.key ? '#fffbeb' : '#f1f5f9'"/>
                          </svg>
                        </div>
                        <!-- Text -->
                        <div class="min-w-0 flex-1">
                          <p class="mb-0 text-xs font-semibold text-neutral-800 leading-tight">{{ locale === 'tr' ? opt.labelTr : opt.labelEn }}</p>
                          <p class="mb-0 text-[10px] text-neutral-500 leading-tight mt-0.5">{{ locale === 'tr' ? opt.descTr : opt.descEn }}</p>
                        </div>
                        <!-- Check icon -->
                        <font-awesome-icon v-if="sidebarChildBedChoices[ageIdx] === opt.key" icon="fa-solid fa-circle-check" class="h-4 w-4 text-sky-500 shrink-0" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer -->
            <div class="flex items-center justify-end gap-3 px-5 py-4 border-t border-neutral-100 bg-neutral-50 rounded-b-2xl shrink-0">
              <button type="button" @click.stop.prevent="closeGlobalPeopleEditor" class="h-11 px-8 rounded-xl bg-brand-700 text-sm font-bold text-white hover:bg-brand-600 transition-colors flex items-center gap-2">
                <font-awesome-icon icon="fa-solid fa-check" class="h-3.5 w-3.5" />
                {{ $t('Kaydet') }}
              </button>
            </div>
          </div>
        </div>
      </Transition>
    </Teleport>

    <ClientOnly>
      <Teleport to="body">
        <LazyTourLazyHotelDetail v-if="showSidebar" ref="hotelDetailRef" @close="showSidebar=false" />
      </Teleport>
      <LazyTourLazyNedenInancTur v-if="loadNedenInancTurModal" ref="nedenInancTurModalRef" />
      <LazyTourLazyCommentsModal v-if="loadCommentsModal" ref="commentsModalRef" />
    </ClientOnly>
  </div>
</template>
<script setup>
import { ref, onMounted, onActivated, onDeactivated, onBeforeUnmount, computed, inject, reactive, watch, nextTick } from 'vue';
import { onBeforeRouteLeave } from 'vue-router'
import {
  DialogPanel,
  DialogTitle,
  Dialog,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'
import AdvancedFaqClient from '~/components/advanced/Faq.client.vue'
import { createUmrahLandingSearch, resolveUmrahLandingFilters } from '~/utils/umrahLandingFilters'
import { buildUmrahSeoStrategy } from '~/utils/umrahSeoStrategy'
import { buildWhatsAppUrl } from '~/utils/whatsapp'
import { getMatchingHolidays } from '~/utils/tourCalendar'
import axios from 'axios' 
import { set } from 'date-fns'; 
import { Carousel, Slide, Navigation } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
const config = useRuntimeConfig();
const openNoteForm = inject("openNoteForm")

definePageMeta({
  keepalive: true,
  layout: 'tour'
})

const aliveProbe = ref({
  createdAt: new Date().toLocaleTimeString(),
  mountCount: 0,
})
const narrationOpenTourId = ref('')

const getTourNarrationMedia = (tour) => {
  const preference = String(tour?.turs_show_video_or_sound || 'none').toLowerCase()
  if (preference === 'none') return null
  const video = String(tour?.turs_voice_video || '').trim()
  const voice = String(tour?.turs_voice_file || '').trim()
  if (preference === 'video') {
    if (video) return { type: 'video', src: video }
    if (voice) return { type: 'voice', src: voice }
  }
  if (preference === 'voice' && voice) return { type: 'voice', src: voice }
  return null
}

const toggleTourNarration = (tour) => {
  if (!getTourNarrationMedia(tour)) return
  narrationOpenTourId.value = narrationOpenTourId.value === tour.pdb_Id ? '' : tour.pdb_Id
}


const route = useRoute()
const router = useRouter()
const tourCo = useTours()
const user = useUser()
const headertab = ref(1)
const {locale,t} = useI18n()
const { searchQuestions } = useInfo()
const  labelSearch  = ref({
  when: t('When'),
  duration: t('Duration'),
});
const { goPath, getPath, goPathBlank, linkInLanguage, formatDate, formatMoney, decodeHTMLEntities, showImage, getIsMobile } = useCommon()
const { getRoomKidsCount, normalizeChildrenAges, getReservationTotals, getTourTotal, removeChildFromRooms, loadReservationSelection, saveReservationSelection } = useReservationPricing();
const url = computed(() => {
  return route.params?.link;
});
const keyworUmreTuru = computed(() => {
  let id = urlToId[route.params?.link]?.id ||  null;
  let title = urlToId[route.params?.link]?.title ||  pageData.value.SA_Baslik;
  return title && route.params?.link != 'umre-turlari' ? `${title}` : t('Umre Turu');
});
const keyworUmreTuru2 = computed(() => {
  let id = urlToId[route.params?.link]?.id ||  null;
  let title = urlToId[route.params?.link]?.title2 ||  pageData.value.SA_Baslik;
  return title && route.params?.link != 'umre-turlari' ? `${title}` : t('Umre Turları ve Fiyatları');
});

 
const activeHotelFilterLabel = ref('');
const selectedForPrint = ref([])
const showPdfStudio = ref(false)
const pdfCoverUrl = computed(() => {
  const pageKey = String(route.params?.link || '').toLocaleLowerCase('tr-TR')
  return pageKey.includes('umre')
    ? '/assets/img/pdf/teklif_kapak_9.png'
    : '/assets/img/pdf/teklif_kapak_8.png'
})

// Tour comparison state
const comparisonMode = ref(false)
const comparisonTours = ref([])

// Basit slugify (otel adı ile slugları eşlemek için)
 

const stickyClass = computed(() => {
 let cls = '';
 cls+= detailMenuView.value ||  detailSearchView.value ? 'shadow-xl rounded-md ' : '';

 cls+= 'bg-white md:mt-2';
 return cls
});


const activeTourNumber = ref(8)
const hotelDetailRef = ref(null) 
const hide = ref({})


const showVideo = ref(false);        // masaüstü sidebar içi (mevcut)
const showVideoModal = ref(false);   // mobil popup
const sidebarRoomEditorOpen = ref(false);  // oda seçimi form açık/kapalı

const openVideoModal = () => { showVideoModal.value = true; }
const closeVideoModal = () => { showVideoModal.value = false; }


const showHotelModal = ref(false);
const openHotelModal = () => { showHotelModal.value = true; }
const closeHotelModal = () => { showHotelModal.value = false; }
const chooseHotel = (h) => { setHotelFilter(h.id, h.name); closeHotelModal(); }
const selectAllHotels = () => {
  search.value.activeHotelId = 'all';
  activeHotelFilterLabel.value = '';
  fetchTours(0, true);
  closeHotelModal();
};


const selectedTour = ref(null)
const isOpen = ref(false)
const showPreview = ref(false)
const openQuickTourDetail = (tour) => {
  // router.push({hash: `#`+tour.pdb_Id });
    // URL'yi değiştirmeden modalı aç (scroll sabit kalır)
  selectedTour.value = tour
  // if (isMobile.value) {
  //   isOpen.value = true
  // } else {
  //   showPreview.value = true
  // }

   showPreview.value = true
  // Eğer URL'de hash istiyorsanız, scroll tetiklemeyen yöntem:
  const y = window?.scrollY || 0
  const u = new URL(window.location.href)
  u.hash = `tour-${tour.pdb_Id}` // paylaşım için
  history.replaceState({}, '', u) // scroll tetiklemez
  requestAnimationFrame(() => window.scrollTo({ top: y, behavior: 'auto' }))

}
const closePreview = () => {
  showPreview.value = false
  selectedTour.value = null
}
const closeModal = () => {
  //selectedTour.value = null;
  isOpen.value = false;
  // Hash eklediyseniz kapatırken kaldırmak için:
  const y = window?.scrollY || 0
  const u = new URL(window.location.href)
  u.hash = ''
  history.replaceState({}, '', u)

  const shareItem = (tour) => {
    const url = `${window.location.origin}/tourDetail/${tour.pdb_Id}`
    if (navigator.share) {
      navigator.share({ title: tour.otel1_adi?.tr + ' / ' + tour.otel2_adi?.tr, url })
    } else {
      navigator.clipboard?.writeText(url)
    }
  }

  const printItem = (tour) => {
    if (!tour?.pdb_Id) return
    window.open(`/tourDetail/${tour.pdb_Id}?print=1`, '_blank')
  }
  requestAnimationFrame(() => window.scrollTo({ top: y, behavior: 'auto' }))

}


const viewMode = ref('cards')
const viewModes = ['cards', 'table', 'calendar']

const setViewMode = (mode) => {
  viewMode.value = viewModes.includes(mode) ? mode : 'cards'
  try { localStorage.setItem('tours_view_mode', viewMode.value) } catch (e) {}
}

// sliding indicator style for segmented control
const viewIndicatorStyle = computed(() => {
  const index = Math.max(0, viewModes.indexOf(viewMode.value))
  return { transform: `translateX(${index * 100}%)` }
})

// collapsed state per date (mobile)
const collapsedDates = reactive({})
const toggleCollapse = (key) => {
  if (!key) return
  collapsedDates[key] = !collapsedDates[key]
}
const isCollapsed = (key) => {
  return !!collapsedDates[key]
}

// ===== Tour Comparison Helpers =====
const getComparableTours = (tourGroup) => {
  if (!Array.isArray(tourGroup)) return []
  return tourGroup.filter((t) => t?.turs_status_data?.available || t?.turs_status_data?.value === "FULL")
}

const getComparisonRows = (tourGroup) => {
  const list = getComparableTours(tourGroup)
  if (!list.length) return []

  const defs = [
    {
      key: 'medinaHotel',
      label: t('Medine Oteli'),
      resolve: (tour) => tour?.otel1_adi?.[locale.value] || tour?.otel1_adi?.tr || '-',
    },
    {
      key: 'mekkaHotel',
      label: t('Mekke Oteli'),
      resolve: (tour) => tour?.otel2_adi?.[locale.value] || tour?.otel2_adi?.tr || '-',
    },
    {
      key: 'medinaNights',
      label: t('Medine Geceleme'),
      resolve: (tour) => `${tour?.turs_otel1_sure || '-'} ${t('gece')}`,
    },
    {
      key: 'mekkaNights',
      label: t('Mekke Geceleme'),
      resolve: (tour) => `${tour?.turs_otel2_sure || '-'} ${t('gece')}`,
    },
    {
      key: 'airline',
      label: t('Havayolu'),
      resolve: (tour) => tour?.airwayName?.[locale.value] || tour?.airwayName?.tr || '-',
    },
    {
      key: 'price',
      label: t('Fiyat (Kişi Başı)'),
      resolve: (tour) => `${formatMoney(tour?.turs_double || 0)} ${tour?.tour_Currency || ''}`.trim(),
    },
  ]

  return defs.map((def) => {
    const values = list.map((tour) => def.resolve(tour))
    const uniqueCount = new Set(values.map((v) => String(v))).size
    return {
      key: def.key,
      label: def.label,
      values,
      hasDifference: uniqueCount > 1,
    }
  })
}

const getComparisonPriceStats = (tourGroup) => {
  const list = getComparableTours(tourGroup)
  if (!list.length) {
    return { minLabel: '-', maxLabel: '-', diffLabel: '-' }
  }

  const sorted = [...list].sort((a, b) => (a?.turs_double || 0) - (b?.turs_double || 0))
  const min = sorted[0]
  const max = sorted[sorted.length - 1]
  const diff = Math.max(0, (max?.turs_double || 0) - (min?.turs_double || 0))

  return {
    minLabel: `${formatMoney(min?.turs_double || 0)} ${min?.tour_Currency || ''}`.trim(),
    maxLabel: `${formatMoney(max?.turs_double || 0)} ${max?.tour_Currency || ''}`.trim(),
    diffLabel: `${formatMoney(diff)} ${max?.tour_Currency || min?.tour_Currency || ''}`.trim(),
  }
}

const openComparisonModal = (tourGroup) => {
  const list = getComparableTours(tourGroup)
  if (list.length < 2) return
  comparisonTours.value = list
  comparisonMode.value = true
}

const closeComparison = () => {
  comparisonMode.value = false
  comparisonTours.value = []
}

const openComparisonHotel = (tour, hotelIndex) => {
  const hotel = tour?.hotels?.[hotelIndex]
  if (!hotel) return
  closeComparison()
  setTimeout(() => {
    openSidebar(hotel)
  }, 120)
}

const isPrintSelected = (tourId) => {
  return selectedForPrint.value.some((tour) => String(tour?.pdb_Id) === String(tourId))
}

const togglePrintSelect = (tour) => {
  if (!tour?.pdb_Id) return
  const selected = isPrintSelected(tour.pdb_Id)
  if (selected) {
    selectedForPrint.value = selectedForPrint.value.filter((item) => String(item?.pdb_Id) !== String(tour.pdb_Id))
  } else {
    selectedForPrint.value.push(tour)
  }
}

const clearPrintSelection = () => {
  selectedForPrint.value = []
  showPdfStudio.value = false
}

const removePrintSelection = (tourId) => {
  selectedForPrint.value = selectedForPrint.value.filter((tour) => String(tour?.pdb_Id) !== String(tourId))
}

const compactCards = reactive({})
const toggleCardCompact = (tourId) => {
  if (!tourId) return
  compactCards[tourId] = !compactCards[tourId]
}
const isCardCompact = (tourId) => {
  return !!compactCards[tourId]
}

// keyboard support for segmented control
const onViewListKeydown = (e) => {
  if (!e) return
  const key = e.key
  const currentIndex = Math.max(0, viewModes.indexOf(viewMode.value))
  if (key === 'ArrowRight' || key === 'ArrowDown') {
    e.preventDefault()
    const nextIndex = (currentIndex + 1) % viewModes.length
    setViewMode(viewModes[nextIndex])
  } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
    e.preventDefault()
    const prevIndex = (currentIndex - 1 + viewModes.length) % viewModes.length
    setViewMode(viewModes[prevIndex])
  } else if (key === 'Enter' || key === ' ') {
    e.preventDefault()
    const nextIndex = (currentIndex + 1) % viewModes.length
    setViewMode(viewModes[nextIndex])
  }
}

// flattened tours array for table mode
const flattenedTours = computed(() => {
  if (!tours.value) return []
  // tours.value is grouped object where each key maps array of tours
  const flattened = Object.values(tours.value).flat()
  // ensure unique by pdb_Id and sort by start date
  const map = new Map()
  flattened.forEach(t => {
    if (t && t.pdb_Id) map.set(t.pdb_Id, t)
  })
  return Array.from(map.values()).sort((a, b) => new Date(a.turs_StartDate) - new Date(b.turs_StartDate))
})

const novemberCampaignTour = computed(() => flattenedTours.value.find((tour) => {
  const departureDate = String(tour?.turs_StartDate || '')
  return departureDate.includes('-11-28') && tour?.turs_status_data?.available
}) || null)

const openNovemberCampaign = async () => {
  const tour = novemberCampaignTour.value
  if (!process.client || !tour?.pdb_Id) return

  setViewMode('cards')
  if (tour.start) collapsedDates[tour.start] = false
  await nextTick()

  const target = document.getElementById(`tour${tour.pdb_Id}`)
  if (!target) return

  const yOffset = -110
  const y = target.getBoundingClientRect().top + (window.pageYOffset || 0) + yOffset
  window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' })
}

// Child pricing type ranking for sorting
const childTypeRank = {
  turBaby: 1,
  turChildNoBed: 2,
  turChild: 3
}

// Child prices organized by age range (like tourDetail)
const childPricesOrdered = computed(() => {
 
  if (!selectedTour.value?.prices) return {}
  
  const list = (selectedTour.value.prices || []).filter(item => 
    ['turBaby', 'turChild', 'turChildNoBed'].includes(item?.turf_PaxType)
  )
  
  let yasList = [...list].sort((a, b) => {
    const minA = Number(a?.turf_MinAge ?? 0)
    const minB = Number(b?.turf_MinAge ?? 0)
    if (minA !== minB) return minA - minB

    const maxA = Number(a?.turf_MaxAge ?? 0)
    const maxB = Number(b?.turf_MaxAge ?? 0)
    if (maxA !== maxB) return maxA - maxB

    return (childTypeRank[a?.turf_PaxType] || 99) - (childTypeRank[b?.turf_PaxType] || 99)
  })
  
  let listLast = {}
  yasList.forEach(item => {
    if (!listLast[item.turf_MinAge + "-" + item.turf_MaxAge]) {
      listLast[item.turf_MinAge + "-" + item.turf_MaxAge] = []
    }
    listLast[item.turf_MinAge + "-" + item.turf_MaxAge].push(item)
  })
  return listLast
})

const getChildPriceLabel = (price) => {
  if (price?.turf_PaxType === 'turBaby') {
    return locale.value === 'tr' ? 'Bebek' : 'Baby'
  }
  if (price?.turf_PaxType === 'turChildNoBed') {
    return locale.value === 'tr' ? 'Çocuk (Yataksız)' : 'Child (No Bed)'
  }
  if (price?.turf_PaxType === 'turChild') {
    return locale.value === 'tr' ? 'Çocuk (Ek Yatak ile)' : 'Child (With Bed)'
  }
  return locale.value === 'tr' ? 'Çocuk' : 'Child'
}

const getChildRoomLabel = (price) => {
  if (price?.turf_PaxType === 'turBaby') {
    return locale.value === 'tr' ? 'Otel tarafında beşik verilebilir.' : 'Baby with Crib'
  }
  if (price?.turf_PaxType === 'turChildNoBed') {
    return locale.value === 'tr' ? 'Ebeveyn yatağında konaklayabilir.' : 'with Parents Bed'
  }
  if (price?.turf_PaxType === 'turChild') {
    return locale.value === 'tr' ? 'Ek yatak verilir.' : 'Extra Bed Child'
  }
  return locale.value === 'tr' ? 'Çocuk' : 'Child'
}

const previewPeople = computed(() => {
  const rooms = reservation.value?.rooms?.length || 0
  const adults = reservation.value?.rooms?.reduce((sum, room) => sum + (room.adult || 0), 0) || 0
  const children = reservation.value?.rooms?.reduce((sum, room) => sum + (room.child || 0), 0) || 0
  const babies = reservation.value?.rooms?.reduce((sum, room) => sum + (room.baby || 0), 0) || 0
  return { rooms, adults, children, babies }
})

const previewPeopleLabel = computed(() => {
  const { rooms, adults, children, babies } = previewPeople.value
  const parts = []
  parts.push(`${rooms} ${t('Oda')}`)
  parts.push(`${adults} ${t('Yetişkin')}`)
  if (children > 0) parts.push(`${children} ${t('Çocuk')}`)
  if (babies > 0) parts.push(`${babies} ${t('Bebek')}`)
  return parts.join(' • ')
})

const sidebarChildBedChoices = ref([])
const sidebarChildBedPanelOpen = ref([])

const parseChildAge = (age) => {
  if (age === '' || age === null || age === undefined) return null
  const parsed = parseInt(String(age), 10)
  return Number.isNaN(parsed) ? null : parsed
}

const sidebarPriceKey = (price) => `${price?.turf_PaxType || ''}:${price?.turf_RoomType || price?.turf_PaxType || ''}`

const getSidebarChildBedOptions = (age) => {
  const parsed = parseChildAge(age)
  if (parsed === null || !selectedTour.value?.prices) return []
  return selectedTour.value.prices
    .filter(price => ['turBaby', 'turChild', 'turChildNoBed'].includes(price?.turf_PaxType) &&
      parsed >= Number(price?.turf_MinAge ?? 0) && parsed <= Number(price?.turf_MaxAge ?? 0))
    .map(price => ({
      key: sidebarPriceKey(price),
      kind: price.turf_PaxType,
      price,
      labelTr: getChildPriceLabel(price),
      labelEn: getChildPriceLabel(price),
      descTr: getChildRoomLabel(price),
      descEn: getChildRoomLabel(price),
    }))
}

const getSidebarDefaultBedChoice = (age) => {
  const options = getSidebarChildBedOptions(age)
  return options.length === 1 ? options[0].key : null
}

const saveSidebarChildPriceSelections = () => {
  reservation.value.childPriceSelections = (reservation.value.childrenAges || []).map((age, idx) => {
    const choice = sidebarChildBedChoices.value[idx]
    const option = getSidebarChildBedOptions(age).find(item => item.key === choice)
    return {
      age,
      selectedPriceType: option?.price?.turf_PaxType || null,
      selectedPriceId: option?.price?.turf_RoomType || option?.price?.turf_PaxType || null,
    }
  })
}

const syncSidebarChildBedSelections = () => {
  const ages = Array.isArray(reservation.value?.childrenAges) ? reservation.value.childrenAges : []

  while (sidebarChildBedChoices.value.length < ages.length) {
    sidebarChildBedChoices.value.push(null)
  }
  while (sidebarChildBedPanelOpen.value.length < ages.length) {
    sidebarChildBedPanelOpen.value.push(false)
  }

  if (sidebarChildBedChoices.value.length > ages.length) {
    sidebarChildBedChoices.value = sidebarChildBedChoices.value.slice(0, ages.length)
  }
  if (sidebarChildBedPanelOpen.value.length > ages.length) {
    sidebarChildBedPanelOpen.value = sidebarChildBedPanelOpen.value.slice(0, ages.length)
  }

  // Fiyat seçenekleri tur bazlıdır. Hızlı İncele'de tur seçilmeden önce
  // saklanmış tercihi geçersiz sayıp silme.
  if (!selectedTour.value) return

  ages.forEach((age, idx) => {
    const options = getSidebarChildBedOptions(age)
    const selected = sidebarChildBedChoices.value[idx]
    if (options.find((opt) => opt.key === selected)) return

    const saved = reservation.value.childPriceSelections?.[idx]
    const savedOption = options.find(opt =>
      opt.price?.turf_PaxType === saved?.selectedPriceType &&
      (opt.price?.turf_RoomType || opt.price?.turf_PaxType) === saved?.selectedPriceId
    )
    sidebarChildBedChoices.value[idx] = savedOption?.key || getSidebarDefaultBedChoice(age)
  })
  saveSidebarChildPriceSelections()
}

const onSidebarChildAgeChange = (idx) => {
  normalizeChildrenAges(reservation.value)
  sidebarChildBedChoices.value[idx] = null
  if (Array.isArray(reservation.value.childPriceSelections)) {
    reservation.value.childPriceSelections[idx] = {
      age: reservation.value.childrenAges[idx],
      selectedPriceType: null,
      selectedPriceId: null,
    }
  }
  syncSidebarChildBedSelections()
  const age = reservation.value.childrenAges[idx]
  const validOptionKeys = getSidebarChildBedOptions(age).map((opt) => opt.key)
  if (!validOptionKeys.includes(sidebarChildBedChoices.value[idx])) {
    sidebarChildBedChoices.value[idx] = getSidebarDefaultBedChoice(age)
  }
  saveSidebarChildPriceSelections()
  saveReservationSelection(reservation.value)
}

const toggleSidebarChildBedPanel = (idx) => {
  const options = getSidebarChildBedOptions(reservation.value.childrenAges[idx])
  if (options.length === 0) return
  sidebarChildBedPanelOpen.value[idx] = !sidebarChildBedPanelOpen.value[idx]
}

const selectSidebarChildBedOption = (idx, bedKey) => {
  sidebarChildBedChoices.value[idx] = bedKey
  saveSidebarChildPriceSelections()
  saveReservationSelection(reservation.value)
}

const getSidebarChildBedOptionsByIndex = (idx) => {
  return getSidebarChildBedOptions(reservation.value.childrenAges[idx])
}

const getSidebarChildBedLabel = (idx) => {
  const selectedKey = sidebarChildBedChoices.value[idx]
  const options = getSidebarChildBedOptionsByIndex(idx)
  const found = options.find((opt) => opt.key === selectedKey)
  if (!found) return locale.value === 'tr' ? 'Yatak seçimi' : 'Bed option'
  return locale.value === 'tr' ? found.labelTr : found.labelEn
}

const getStatusBadgeClass = (statusData) => {
  const token = String(statusData?.color || '').toLowerCase()
  if (token.includes('green') || token.includes('success')) return 'bg-support-600 text-white'
  if (token.includes('amber') || token.includes('orange') || token.includes('yellow')) return 'bg-accent-600 text-white'
  if (token.includes('blue') || token.includes('sky') || token.includes('indigo')) return 'bg-brand-800 text-white'
  if (token.includes('red') || token.includes('rose')) return 'bg-brand-900 text-white'
  return 'bg-brand-800 text-white'
}

const getTourCampaignTitle = (tourItem) => {
  const campaignTitle = tourItem?.turs_CampaignTitle
  if (!campaignTitle) return ''
  if (typeof campaignTitle === 'string') return campaignTitle.trim()
  return String(campaignTitle?.[locale.value] || campaignTitle?.tr || campaignTitle?.en || '').trim()
}

const getInfoBadgeClass = (colorToken) => {
  const token = String(colorToken || '').toLowerCase()
  if (token.includes('green') || token.includes('teal')) return 'bg-support-50 text-support-700 border-support-200'
  if (token.includes('amber') || token.includes('orange') || token.includes('yellow')) return 'bg-accent-50 text-accent-700 border-accent-200'
  if (token.includes('blue') || token.includes('sky') || token.includes('indigo')) return 'bg-brand-50 text-brand-700 border-brand-200'
  if (token.includes('red') || token.includes('rose')) return 'bg-neutral-100 text-neutral-800 border-neutral-300'
  return 'bg-brand-50 text-brand-700 border-brand-200'
}

const listPeopleEditorTourId = ref(null)
const quickPreviewPeopleEditorOpen = ref(false)
const globalPeopleEditorOpen = ref(false)

const closeGlobalPeopleEditor = () => { globalPeopleEditorOpen.value = false }

const toggleListPeopleEditor = (_tourId) => {
  globalPeopleEditorOpen.value = true
  quickPreviewPeopleEditorOpen.value = false
  listPeopleEditorTourId.value = null
}

const toggleQuickPreviewPeopleEditor = () => {
  globalPeopleEditorOpen.value = true
  quickPreviewPeopleEditorOpen.value = false
  listPeopleEditorTourId.value = null
}

const resetPeopleSelection = () => {
  reservation.value.rooms = [
    {
      adult: 2,
      child: 0,
      baby: 0,
      room_type: null,
      options: {},
    },
  ]
  reservation.value.childrenAges = []
  normalizeChildrenAges(reservation.value)
  saveReservationSelection(reservation.value)
}

watch(
  () => selectedTour.value?.pdb_Id,
  () => {
    quickPreviewPeopleEditorOpen.value = false
    listPeopleEditorTourId.value = null
    syncSidebarChildBedSelections()
    saveReservationSelection(reservation.value)
  }
)

const currentTourIndex = computed(() => {
  if (!selectedTour.value) return -1
  const selectedId = String(selectedTour.value.pdb_Id || '')
  return flattenedTours.value.findIndex((tour) => String(tour.pdb_Id || '') === selectedId)
})

const hasPrevTour = computed(() => currentTourIndex.value > 0)
const hasNextTour = computed(() => currentTourIndex.value >= 0 && currentTourIndex.value < flattenedTours.value.length - 1)

const selectTourInPreview = (tour) => {
  if (!tour) return
  selectedTour.value = tour
  showPreview.value = true
  // if (isMobile.value) {
  //   isOpen.value = true
  // } else {
  //   showPreview.value = true
  // }
}

const selectPrevTour = () => {
  if (!hasPrevTour.value) return
  selectTourInPreview(flattenedTours.value[currentTourIndex.value - 1])
}

const selectNextTour = () => {
  if (!hasNextTour.value) return
  selectTourInPreview(flattenedTours.value[currentTourIndex.value + 1])
}

const previewShareUrl = computed(() => {
  if (!selectedTour.value) return ''
  if (typeof window === 'undefined') return ''
  return `${window.location.origin}/tourDetail/${selectedTour.value.pdb_Id}`
})

const previewShareTitle = computed(() => {
  if (!selectedTour.value) return ''
  const title = `${selectedTour.value.otel1_adi?.tr || ''} / ${selectedTour.value.otel2_adi?.tr || ''}`.trim()
  return `${t('Bu turu gördün mü ?')}: ${title} ${previewShareUrl.value}`
})

const compareState = useTourCompare()
const compareTours = computed(() => compareState.value?.items || [])
const isCompareOpen = computed({
  get: () => compareState.value?.open,
  set: (val) => {
    compareState.value.open = val
  },
})

const isCompared = (tour) => {
  if (!tour) return false
  const tourId = String(tour.pdb_Id || '')
  return compareTours.value.some((item) => String(item?.pdb_Id || '') === tourId)
}

const addCompareTour = (tour) => {
  if (!tour || isCompared(tour)) return
  compareState.value.items = [...compareTours.value, tour]
  compareState.value.open = true
}

const removeCompareTour = (tourOrId) => {
  const tourId = String(tourOrId?.pdb_Id || tourOrId || '')
  compareState.value.items = compareTours.value.filter((item) => String(item?.pdb_Id || '') !== tourId)
}

const toggleCompareTour = (tour) => {
  if (!tour) return
  if (isCompared(tour)) {
    removeCompareTour(tour)
  } else {
    addCompareTour(tour)
  }
  compareState.value.open = true
}

const clearCompareTours = () => {
  compareState.value.items = []
  compareState.value.open = true
}

const closeCompare = () => {
  compareState.value.open = false
}

const openCompare = () => {
  compareState.value.open = true
}

const onCompare = (tour) => {
  toggleCompareTour(tour)
}

const calendarCursor = ref(new Date())
const calendarSelectedDate = ref(null)

const formatDateKey = (year, month, day) => {
  const mm = String(month + 1).padStart(2, '0')
  const dd = String(day).padStart(2, '0')
  return `${year}-${mm}-${dd}`
}

const extractDateKey = (value) => {
  if (!value) return ''
  const raw = String(value)
  return raw.includes('T') ? raw.split('T')[0] : raw
}

const calendarWeekdays = computed(() => {
  return locale.value === 'tr'
    ? ['Pt', 'Sa', 'Ca', 'Pe', 'Cu', 'Ct', 'Pz']
    : ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']
})

const calendarMonthLabel = computed(() => {
  const loc = locale.value === 'tr' ? 'tr-TR' : 'en-US'
  return calendarCursor.value.toLocaleDateString(loc, { month: 'long', year: 'numeric' })
})

const calendarToursByDate = computed(() => {
  const map = new Map()
  flattenedTours.value.forEach((tour) => {
    const key = extractDateKey(tour.turs_StartDate)
    if (!key) return
    if (!map.has(key)) map.set(key, [])
    map.get(key).push(tour)
  })
  return map
})

const calendarDays = computed(() => {
  const year = calendarCursor.value.getFullYear()
  const month = calendarCursor.value.getMonth()
  const firstDay = new Date(year, month, 1)
  const firstDayIndex = (firstDay.getDay() + 6) % 7
  const daysInMonth = new Date(year, month + 1, 0).getDate()
  const prevMonthDays = new Date(year, month, 0).getDate()
  const days = []

  for (let i = 0; i < 42; i += 1) {
    const dayNumber = i - firstDayIndex + 1
    let dateObj
    let inMonth = true
    if (dayNumber <= 0) {
      dateObj = new Date(year, month - 1, prevMonthDays + dayNumber)
      inMonth = false
    } else if (dayNumber > daysInMonth) {
      dateObj = new Date(year, month + 1, dayNumber - daysInMonth)
      inMonth = false
    } else {
      dateObj = new Date(year, month, dayNumber)
    }

    const dateKey = formatDateKey(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate())
    const toursForDay = calendarToursByDate.value.get(dateKey) || []
    const firstTour = toursForDay[0]
    days.push({
      dateKey,
      day: dateObj.getDate(),
      inMonth,
      isSelected: calendarSelectedDate.value === dateKey,
      toursCount: toursForDay.length,
      hasTours: toursForDay.length > 0,
      previewText: firstTour ? `${firstTour.otel1_adi?.[locale.value] || firstTour.otel1_adi?.tr}` : '',
    })
  }
  return days
})

const calendarSelectedTours = computed(() => {
  if (!calendarSelectedDate.value) return []
  return calendarToursByDate.value.get(calendarSelectedDate.value) || []
})

const calendarSelectedLabel = computed(() => {
  if (!calendarSelectedDate.value) return t('Gün seçin')
  const [y, m, d] = calendarSelectedDate.value.split('-')
  const dateObj = new Date(Number(y), Number(m) - 1, Number(d))
  const loc = locale.value === 'tr' ? 'tr-TR' : 'en-US'
  return dateObj.toLocaleDateString(loc, { day: '2-digit', month: 'long', year: 'numeric' })
})

const selectCalendarDate = (day) => {
  if (!day) return
  calendarSelectedDate.value = day.dateKey
}

const clearCalendarSelection = () => {
  calendarSelectedDate.value = null
}

const goPrevCalendarMonth = () => {
  const year = calendarCursor.value.getFullYear()
  const month = calendarCursor.value.getMonth()
  calendarCursor.value = new Date(year, month - 1, 1)
}

const goNextCalendarMonth = () => {
  const year = calendarCursor.value.getFullYear()
  const month = calendarCursor.value.getMonth()
  calendarCursor.value = new Date(year, month + 1, 1)
}



const showSidebar = ref(false)
const openSidebar = (hotel)=>{
  showSidebar.value = true;
  const revealWhenReady = (attempts = 20) => {
    if (hotelDetailRef.value?.changeVisibility) {
      hotelDetailRef.value.changeVisibility(hotel)
    } else if (attempts > 0) {
      window.setTimeout(() => revealWhenReady(attempts - 1), 50)
    }
  }
  nextTick(() => revealWhenReady())
}
const reservation = useReservation()
const isMobile = useIsMobile();
const mobileMediaQuery = ref(null)
const syncIsMobile = () => {
  if (import.meta.client) {
    isMobile.value = window.matchMedia('(max-width: 768px)').matches
    return
  }

  isMobile.value = getIsMobile()
}

if (import.meta.client) syncIsMobile()
else if (isMobile.value === null) syncIsMobile()
const prevHtmlOverflowX = ref('')
const prevBodyOverflowX = ref('')

onMounted(() => {
  syncIsMobile()
  mobileMediaQuery.value = window.matchMedia('(max-width: 768px)')
  mobileMediaQuery.value.addEventListener?.('change', syncIsMobile)
  loadReservationSelection(reservation.value);
  hydratePeopleFromQuery();
  normalizeChildrenAges(reservation.value);
  syncSidebarChildBedSelections();
  saveReservationSelection(reservation.value);

  // Global html/body overflow-x hidden can break sticky behavior in some browsers.
  const htmlEl = document.documentElement
  const bodyEl = document.body
  prevHtmlOverflowX.value = htmlEl.style.overflowX || ''
  prevBodyOverflowX.value = bodyEl.style.overflowX || ''
  htmlEl.style.overflowX = 'visible'
  bodyEl.style.overflowX = 'visible'
});

onBeforeUnmount(() => {
  mobileMediaQuery.value?.removeEventListener?.('change', syncIsMobile)
  document.documentElement.style.overflowX = prevHtmlOverflowX.value
  document.body.style.overflowX = prevBodyOverflowX.value
})

watch(
  () => reservation.value.rooms,
  () => {
    normalizeChildrenAges(reservation.value);
    syncSidebarChildBedSelections();
    saveReservationSelection(reservation.value);
  },
  { deep: true }
);

watch(
  () => reservation.value.childrenAges,
  () => {
    normalizeChildrenAges(reservation.value);
    syncSidebarChildBedSelections();
    saveReservationSelection(reservation.value);
  },
  { deep: true }
);

const showDates = ()=>{
 
  if(!isScrolled.value){
     searchWhenScrolled();
  }
 
  detailMenuView.value=!detailMenuView.value;
  detailSearchView.value=false
}
let hotels = [
  { name: "A Fairmont Clock Tower", id: "aG90ZWxEZXRhaWwxNzI4NTQ4MjA3", link: '/hotel/fairmont-hotel-makkah-clock-royal-tower',  city: 'Mekke'},
  { name: "Rotana Jabal Omar Makkah", id: "ROTANAJABALOMAR", link: '/hotel/rotana-jabal-omar-makkah', city: 'Mekke'},
  { name: "Anwar Al Movenpick", id: "aG90ZWxEZXRhaWwxNTI2NDU3NTk2"  , link: '/hotel/anwar-al-movenpick-madinah' ,city: 'Medine'},
  // { name: "Al Marwa Rayhaan by Rotana", id: "aG90ZWxEZXRhaWwxNzYwNjAzODkz", link: '/hotel/al-marwa-rayhaan-by-rotana',  city: 'Mekke'},
  // { name: "Bosphorus Waqf al Safi", id: "aG90ZWxEZXRhaWwxNTQ3MTQ3Mzgw"  , link: '/hotel/boshphorus-waqf-al-safi-hotel-madinah'  ,city: 'Medine'},
  // { name: "Makkah Hotel( Eski Hilton)", id: "aG90ZWxEZXRhaWwxNjcxNjI4ODYz"  , link: '/hotel/makkah-hilton', city: 'Mekke'},
  // { name: "Anjum Hotel", id: "aG90ZWxEZXRhaWwxNTQ3MTQ3MjMw" , link: '/hotel/anjum-hotel-makkah', city: 'Mekke'},
  // { name: "Jumeirah Jabal Omar Makkah",   id: "aG90ZWxEZXRhaWwxNzM4NzYxNDgy", link: '/hotel/jumeirah-jabal-omar-makkah',  city: 'Mekke'},
  { name: "Peninsula Worth Hotel",        id: "aG90ZWxEZXRhaWwxNzc2NTkwNzI1", link: '/hotel/peninsula-worth-hotel',  city: 'Medine'},
]
const pageData = usePageData();
const tours = ref(null);
const loading = ref(null);
const hasToursData = computed(() => !!tours.value && Object.keys(tours.value).length > 0)
const showToursLoadingSkeleton = computed(() => !!loading.value && !hasToursData.value)
const loadingGhostCount = computed(() => (isMobile.value ? 4 : 5))
const toursDateList = ref([]);
const toursDateListMonth = ref([]);
const mountedFinished = ref(false);
const todayIso = new Date().toISOString().slice(0, 10)
const currentSeoYear = new Date().getFullYear()
const nextSeoYear = currentSeoYear + 1
const umrahSeasonLabel = `${currentSeoYear}-${nextSeoYear}`
const umrahSeoStrategy = computed(() => buildUmrahSeoStrategy(currentSeoYear, locale.value))
const isPrimaryUmrahLanding = computed(() => ['/tour/umre-turlari', '/en/tour/umrah-tours'].includes(route.path))
const isFiveStarUmrahLanding = computed(() => [
  '/tour/5-yildizli-luks-umre-turlari',
  '/en/tour/5-star-luxury-umrah-packages'
].includes(route.path))
const isVipUmrahLanding = computed(() => [
  '/tour/vip-umre-programlari',
  '/en/tour/vip-luxury-umrah-packages'
].includes(route.path))
const SUPPORTED_UMRAH_DURATIONS = Object.freeze([3, 5, 7, 8, 10, 12, 13, 15])
const umrahDurationDays = computed(() => {
  const match = String(url.value || '').match(/^(\d+)-(?:gunluk-umre-turlari|days-umrah-tours)$/)
  const days = Number(match?.[1])
  return SUPPORTED_UMRAH_DURATIONS.includes(days) ? days : null
})
// The detailed duration copy is only needed on a duration-specific landing
// page. Keep it out of the generic Umrah catalogue's initial client bundle.
const durationContentModule = umrahDurationDays.value
  ? await import('~/utils/umrahDurationContent')
  : null
const umrahClusterLandingKey = computed(() => ({
  '/tour/ramazan-umre-turlari': 'ramadan',
  '/en/tour/ramadan-umrah-tours': 'ramadan',
  '/tour/somestr-umre-turlari': 'semester',
  '/en/tour/somestr-umre-turlari': 'semester'
})[route.path] || (umrahDurationDays.value ? `duration${umrahDurationDays.value}` : null))
const showSeoStartingPrice = computed(() => (umrahDurationDays.value !== null && umrahDurationDays.value !== 3) || isPrimaryUmrahLanding.value || isFiveStarUmrahLanding.value)

const durationNavigationLinks = computed(() => SUPPORTED_UMRAH_DURATIONS.map((days) => ({
  label: locale.value === 'en' ? `${days}-day Umrah` : `${days} günlük umre`,
  path: `/tour/${days}-gunluk-umre-turlari`
})))

const umrahClusterLinks = [
  { label: 'Umre fiyatları', path: '/tour/umre-turlari' },
  { label: '7 günlük umre', path: '/tour/7-gunluk-umre-turlari' },
  { label: '10 günlük umre', path: '/tour/10-gunluk-umre-turlari' },
  { label: 'Ramazan umresi', path: '/tour/ramazan-umre-turlari' },
  { label: 'Sömestr umresi', path: '/tour/somestr-umre-turlari' },
  { label: 'Mekke ve Medine umre otelleri', path: '/page/umre-otelleri-rehberi' },
  { label: 'Kadın irşad görevlisi', path: '/page/kadin-irsad-gorevlisi' }
]

const getUmrahClusterLandingContent = (key) => {
  const strategy = umrahSeoStrategy.value[key]
  if (!strategy) return null

  if (umrahDurationDays.value) {
    return durationContentModule.buildUmrahDurationContent({
      days: umrahDurationDays.value,
      locale: locale.value,
      h1: strategy.h1,
      links: [
        { label: locale.value === 'en' ? 'All Umrah packages' : 'Tüm umre programları', path: '/tour/umre-turlari' },
        ...durationNavigationLinks.value.filter((item) => !item.path.startsWith(`/tour/${umrahDurationDays.value}-`)),
        { label: locale.value === 'en' ? 'Umrah hotels guide' : 'Umre otelleri rehberi', path: '/page/umre-otelleri-rehberi' }
      ]
    })
  }

  if (locale.value === 'en') {
    const pages = {
      duration7: {
        breadcrumb: '7-Day Umrah Packages',
        eyebrow: 'Duration-based Umrah packages',
        heading: 'Compare 7-Day Umrah Packages on Equal Terms',
        intro: 'Compare 7-day departures by Makkah and Madinah nights, named hotels, flights, transfers, room price and current availability.'
      },
      duration10: {
        breadcrumb: '10-Day Umrah Packages',
        eyebrow: 'Duration-based Umrah packages',
        heading: 'Compare Duration, Hotels and Prices for 10-Day Umrah',
        intro: 'Compare 10-day departures by Makkah and Madinah nights, named hotels, flights, transfers, room price and current availability.'
      },
      ramadan: {
        breadcrumb: 'Ramadan Umrah Packages',
        eyebrow: 'Seasonal Umrah packages',
        heading: 'Review Ramadan Umrah by Date, Hotel and Itinerary',
        intro: 'Compare Ramadan departures by travel dates, fasting-day itinerary, suhoor and iftar arrangements, named hotels, flights and current availability.'
      },
      semester: {
        breadcrumb: 'School Holiday Umrah Packages',
        eyebrow: 'Family packages for school holidays',
        heading: 'Plan School Holiday Umrah by Date and Family Needs',
        intro: 'Compare family departures by school holiday dates, duration, room arrangements, child prices, named hotels and flights.'
      }
    }
    const page = pages[key]
    return page ? {
      h1: strategy.h1,
      ...page,
      highlights: [],
      links: [
        { label: 'All Umrah packages', path: '/tour/umre-turlari' },
        { label: '7-day Umrah', path: '/tour/7-gunluk-umre-turlari' },
        { label: '10-day Umrah', path: '/tour/10-gunluk-umre-turlari' },
        { label: 'Ramadan Umrah', path: '/tour/ramazan-umre-turlari' }
      ]
    } : null
  }

  const pages = {
    duration7: {
      breadcrumb: '7 Günlük Umre Turları',
      eyebrow: 'Süre bazlı umre programları',
      heading: '7 Günlük Umre Programlarını Aynı Kapsamla Karşılaştırın',
      intro: 'Bu sayfadaki programlar ana 5 yıldızlı umre kategorisinden yalnızca 7 gün süren kalkışlar seçilerek listelenir. Kısa süre tek başına karar ölçütü değildir; Mekke ve Medine gece dağılımını, otellerin tam adını, uçuş saatlerini, transferi ve oda fiyatını birlikte inceleyin.',
      highlights: [
        { title: 'Kime uygun olabilir?', text: 'İş veya okul takvimi nedeniyle daha sınırlı zamanı bulunan ve yoğun bir günlük programa uyum sağlayabilen yolcular için değerlendirilebilir.' },
        { title: 'Gece ve rota dağılımı', text: 'Toplam 7 gün içinde Mekke ve Medine’de kaç gece kalındığını, ilk varış şehrini ve şehirler arası geçiş planını tur detayından doğrulayın.' },
        { title: 'Fiyatı doğru karşılaştırın', text: 'Aynı oda tipini, otelleri, uçuşu ve dahil hizmetleri karşılaştırın. Güncel kişi başı fiyat ve kontenjan için seçilen kalkışın detayını esas alın.' }
      ]
    },
    duration10: {
      breadcrumb: '10 Günlük Umre Turları',
      eyebrow: 'Süre bazlı umre programları',
      heading: '10 Günlük Umre Programlarında Süre, Otel ve Fiyatı Karşılaştırın',
      intro: 'Bu sayfa ana 5 yıldızlı umre kategorisindeki 10 günlük kalkışları dinamik olarak filtreler. Programları değerlendirirken Mekke ve Medine gece dağılımını, ibadet ve ziyaret temposunu, açıklanan otelleri, uçuşu, transferleri ve oda bazlı fiyatları beraber karşılaştırın.',
      highlights: [
        { title: 'Daha dengeli seyahat temposu', text: '10 günlük plan, 7 günlük seçeneğe göre daha fazla konaklama zamanı sağlayabilir; kesin ziyaret ve serbest zaman planı kalkışa göre değişir.' },
        { title: 'Mekke–Medine dağılımı', text: 'Her iki şehirdeki gece sayısını, otel değişimini ve Haremeyn’e ulaşım biçimini tur programında ayrı ayrı kontrol edin.' },
        { title: 'Oda tipine göre fiyat', text: 'İkili, üçlü, dörtlü ve tek kişilik oda ücretleri farklıdır. Çocuk ve bebek koşullarını da seçtiğiniz turun fiyat hesaplamasından doğrulayın.' }
      ]
    },
    ramadan: {
      breadcrumb: 'Ramazan Umre Turları',
      eyebrow: 'Dönem bazlı umre programları',
      heading: 'Ramazan Umresini Tarih, Konaklama ve Program Kapsamıyla İnceleyin',
      intro: 'Ramazan dönemine denk gelen kalkışlar bu sayfada tarih aralığına göre dinamik olarak listelenir. Gidiş ve dönüş günlerinin Ramazan’ın hangi bölümünü kapsadığını; sahur-iftar düzenini, otel konumunu, ziyaret temposunu ve uçuş saatlerini kesin program üzerinden kontrol edin.',
      highlights: [
        { title: 'Ramazan tarih aralığı', text: 'Programın Ramazan’ın başı, ortası veya son günlerinden hangilerini kapsadığını gidiş ve dönüş tarihleriyle doğrulayın.' },
        { title: 'Sahur, iftar ve yemek planı', text: 'Otel yemek düzeni ile sahur ve iftar hizmetlerinin pakete dahil olup olmadığını her kalkışın yazılı hizmet listesinde inceleyin.' },
        { title: 'Yoğunluk ve ulaşım', text: 'Haremeyn çevresindeki dönemsel yoğunluğu dikkate alarak otel mesafesini, servis veya yürüme planını ve grup buluşma düzenini değerlendirin.' }
      ]
    },
    semester: {
      breadcrumb: 'Sömestr Umre Turları',
      eyebrow: 'Okul tatiline uygun aile programları',
      heading: 'Sömestr Umresini Aile, Oda Düzeni ve Tarihe Göre Planlayın',
      intro: 'Sömestr tatili tarih aralığına denk gelen 5 yıldızlı umre kalkışları bu sayfada dinamik olarak listelenir. Çocuklu aileler için uçuş saatini, toplam süreyi, oda kapasitesini, çocuk yatak seçeneğini, otel mesafesini ve okul takvimine uyumu birlikte değerlendirin.',
      highlights: [
        { title: 'Kesin tatil tarihleri', text: 'Gidiş-dönüş günlerini güncel okul takvimiyle karşılaştırın; programın ders dönemine taşmadığını rezervasyon öncesinde kontrol edin.' },
        { title: 'Aile odası ve çocuk fiyatı', text: 'Oda kapasitesi, çocuk yaşı, yataklı veya yataksız konaklama ve varsa bebek ücretinin kalkışa özel koşullarını inceleyin.' },
        { title: 'Aileler için ulaşım', text: 'Otelin Haremeyn’e gerçek ulaşım biçimi, uçuş saatleri, bagaj hakkı ve transfer süresi özellikle küçük çocuklarla seyahatte önemlidir.' }
      ]
    }
  }

  return pages[key] ? { h1: strategy.h1, ...pages[key], links: umrahClusterLinks } : null
}

const seoLandingContent = computed(() => {
  const clusterContent = getUmrahClusterLandingContent(umrahClusterLandingKey.value)
  if (clusterContent) return clusterContent
  if (!isPrimaryUmrahLanding.value && !isFiveStarUmrahLanding.value && !isVipUmrahLanding.value) return null

  if (locale.value === 'en') {
    if (isVipUmrahLanding.value) {
      return {
        h1: umrahSeoStrategy.value.vip.h1,
        breadcrumb: 'VIP and Boutique Umrah',
        eyebrow: umrahSeoStrategy.value.vip.eyebrow,
        heading: umrahSeoStrategy.value.vip.heading,
        intro: umrahSeoStrategy.value.vip.intro,
        highlights: [
          {
            title: '20–45 guests, one Makkah hotel',
            text: 'Scheduled groups are planned for 20–45 guests, and the whole group stays together at Fairmont in Makkah during the current season.'
          },
          {
            title: 'Turkish Airlines and high-speed rail',
            text: 'Turkish Airlines is standard for flights, high-speed rail for the Madinah–Makkah intercity journey, and newer-model VIP vehicles or coaches for airports and visits.'
          },
          {
            title: 'A dedicated guidance and field team',
            text: 'The tour scholar focuses on guests while two staff in Madinah, two in Makkah and the Türkiye team manage operational processes.'
          }
        ],
        links: [
          { label: 'Umrah service standards', path: '/page/umre-hizmet-standartlari' },
          { label: 'All Umrah packages', path: '/tour/umre-turlari' },
          { label: '5-star luxury Umrah', path: '/tour/5-yildizli-luks-umre-turlari' },
          { label: 'Private Umrah planning', path: '/tour/kisiye-ozel-umre-turlari' },
          { label: 'Guest reviews', path: '/page/yorumlar' },
          { label: 'Umrah guide', path: '/page/umre-rehberi' }
        ]
      }
    }

    const fiveStar = isFiveStarUmrahLanding.value
    return {
      h1: fiveStar ? umrahSeoStrategy.value.premium.h1 : umrahSeoStrategy.value.catalog.h1,
      breadcrumb: fiveStar ? '5-Star Umrah Packages' : 'Umrah Packages',
      eyebrow: fiveStar ? umrahSeoStrategy.value.premium.eyebrow : 'Current departures and transparent package details',
      heading: fiveStar
        ? umrahSeoStrategy.value.premium.heading
        : `Compare ${umrahSeasonLabel} Umrah Dates, Hotels and Room Prices`,
      intro: fiveStar
        ? umrahSeoStrategy.value.premium.intro
        : `Compare packages starting from ${umrahSeoStrategy.value.startingPriceLabel} by travel date, duration, Makkah and Madinah accommodation, airline, transfers and room occupancy. The live detail page of each program is the authoritative source for current price, availability and included services.`,
      highlights: [
        {
          title: 'Price by room type',
          text: 'The per-person price changes according to double, triple, quad or single occupancy and the selected child or infant arrangement.'
        },
        {
          title: 'Hotel location and comfort',
          text: 'Review the hotel name, star category, city, nights of stay and distance to Masjid al-Haram or Al-Masjid an-Nabawi for each program.'
        },
        {
          title: 'A complete travel plan',
          text: 'Check flights, transfers, route, duration, guidance and availability together; package inclusions may differ between departures.'
        }
      ],
      links: [
        { label: 'Umrah service standards', path: '/page/umre-hizmet-standartlari' },
        { label: '7-day Umrah', path: '/tour/7-gunluk-umre-turlari' },
        { label: '10-day Umrah', path: '/tour/10-gunluk-umre-turlari' },
        { label: 'School Holiday Umrah', path: '/tour/somestr-umre-turlari' },
        { label: 'Ramadan Umrah', path: '/tour/ramazan-umre-turlari' },
        { label: 'Private Umrah', path: '/tour/kisiye-ozel-umre-turlari' },
        { label: 'Umrah guide', path: '/page/umre-rehberi' }
      ]
    }
  }

  if (isVipUmrahLanding.value) {
    return {
      h1: umrahSeoStrategy.value.vip.h1,
      breadcrumb: 'VIP ve Butik Umre Turları',
      eyebrow: umrahSeoStrategy.value.vip.eyebrow,
      heading: umrahSeoStrategy.value.vip.heading,
      intro: umrahSeoStrategy.value.vip.intro,
      highlights: [
        {
          title: '20–45 kişi, Mekke’de tek otel',
          text: 'Kesin kalkışlı gruplar 20–45 kişi arasında planlanır; bu sezon Mekke’de grubun tamamı Fairmont’ta birlikte konaklar.'
        },
        {
          title: 'Türk Hava Yolları ve hızlı tren',
          text: 'Uçuşlarda Türk Hava Yolları, Medine–Mekke geçişinde hızlı tren; havalimanı ve ziyaretlerde yeni model VIP araçlar veya otobüsler standarttır.'
        },
        {
          title: 'Ayrı rehberlik ve saha kadrosu',
          text: 'Tur hocası yalnızca misafirlere odaklanır; operasyonu Medine’de iki, Mekke’de iki görevli ve Türkiye ekibi yürütür.'
        }
      ],
      links: [
        { label: 'Umre hizmet standartlarımız', path: '/page/umre-hizmet-standartlari' },
        { label: 'Tüm umre programları', path: '/tour/umre-turlari' },
        { label: '5 yıldızlı lüks umre', path: '/tour/5-yildizli-luks-umre-turlari' },
        { label: 'Kişiye özel umre', path: '/tour/kisiye-ozel-umre-turlari' },
        { label: 'Umre otelleri rehberi', path: '/page/umre-otelleri-rehberi' },
        { label: 'Kadın irşad görevlisi', path: '/page/kadin-irsad-gorevlisi' },
        { label: 'Misafir yorumları', path: '/page/yorumlar' },
        { label: 'Umre rehberi', path: '/page/umre-rehberi' }
      ]
    }
  }

  const fiveStar = isFiveStarUmrahLanding.value
  return {
    h1: fiveStar ? umrahSeoStrategy.value.premium.h1 : umrahSeoStrategy.value.catalog.h1,
    breadcrumb: fiveStar ? '5 Yıldızlı Umre Turları' : 'Umre Turları',
    eyebrow: fiveStar ? umrahSeoStrategy.value.premium.eyebrow : 'Kesinleşen kalkışlar ve şeffaf program ayrıntıları',
    heading: fiveStar
      ? umrahSeoStrategy.value.premium.heading
      : `Umre Tarihlerini, Otelleri ve Oda Fiyatlarını Karşılaştırın ${umrahSeasonLabel} `,
    intro: fiveStar
      ? umrahSeoStrategy.value.premium.intro
      : `${umrahSeoStrategy.value.startingPriceLabel}’den başlayan programları; tarih, süre, Mekke ve Medine otelleri, havayolu, transfer ve oda tipine göre karşılaştırın. Güncel fiyat, kontenjan ve pakete dahil hizmetlerde her turun detay sayfasını esas alın.`,
    highlights: [
      {
        title: 'Oda tipine göre umre fiyatı',
        text: 'Kişi başı ücret; ikili, üçlü, dörtlü veya tek kişilik oda seçimine ve çocuk ya da bebek için tercih edilen yatak düzenine göre değişir.'
      },
      {
        title: 'Otel konumu ve konaklama',
        text: 'Her programda otel adı, yıldız kategorisi, şehir, gece sayısı ve Mescid-i Haram veya Mescid-i Nebevi’ye mesafe bilgilerini birlikte inceleyin.'
      },
      {
        title: 'Uçtan uca program ayrıntısı',
        text: 'Uçuş, transfer, rota, tur süresi, rehberlik ve kontenjan durumunu birlikte kontrol edin; dahil hizmetler kalkışa göre farklılaşabilir.'
      }
    ],
    links: [
      { label: 'Umre hizmet standartlarımız', path: '/page/umre-hizmet-standartlari' },
      { label: '7 günlük umre', path: '/tour/7-gunluk-umre-turlari' },
      { label: '10 günlük umre', path: '/tour/10-gunluk-umre-turlari' },
      { label: 'Sömestr umresi', path: '/tour/somestr-umre-turlari' },
      { label: 'Ramazan umresi', path: '/tour/ramazan-umre-turlari' },
      { label: 'Kişiye özel umre', path: '/tour/kisiye-ozel-umre-turlari' },
      { label: 'Mekke ve Medine umre otelleri', path: '/page/umre-otelleri-rehberi' },
      { label: 'Kadın irşad görevlisi', path: '/page/kadin-irsad-gorevlisi' },
      { label: 'Umre rehberi', path: '/page/umre-rehberi' }
    ]
  }
})

const heroSupportingCopy = computed(() => {
  const intro = String(seoLandingContent.value?.intro || '').trim()
  if (intro) return intro

  return String(pageData.value?.SA_Subtitle || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
})

const premiumTourContent = computed(() => {
  if (!isPrimaryUmrahLanding.value) return null

  if (locale.value === 'en') {
    return {
      heading: 'Umrah Program Types: 5-Star, Luxury, VIP, Boutique and Private',
      intro: 'A five-star hotel category, a luxury service plan and a private or boutique group describe different parts of an Umrah journey. Compare accommodation, walking distance, group size, transfer model, guidance, room choice and date flexibility before selecting a package.',
      cards: [
        {
          title: '5-Star Luxury Umrah Packages',
          text: 'Review named hotels in Makkah and Madinah, distance to the Haramain, room-based prices, flights, transfers and included services.',
          path: '/tour/5-yildizli-luks-umre-turlari'
        },
        {
          title: 'VIP and Boutique Umrah',
          text: 'Review the scheduled service standard: groups of 20–45, one Makkah hotel, Turkish Airlines, rail, VIP road transport and dedicated field teams.',
          path: '/tour/vip-umre-programlari'
        },
        {
          title: 'Private Umrah Planning',
          text: 'Request a tailored program for families, companies and private groups with a clearly defined itinerary and service scope.',
          path: '/tour/kisiye-ozel-umre-turlari'
        }
      ],
      selectionGuide: 'The best Umrah package is not automatically the most expensive one. Choose by comparing exact hotel names and distances, flights, room occupancy, guidance, contract terms and everything included in the price.'
    }
  }

  return {
    heading: 'Umre Programı Türleri: 5 Yıldızlı, Lüks, VIP, Delüks ve Butik',
    intro: '5 yıldızlı umre otel standardını, lüks umre hizmet kapsamını, VIP umre kişiselleştirilmiş desteği; butik umre ise daha küçük grup yapısını ifade edebilir. Delüks umre programlarında konaklama, ulaşım ve özel hizmetlerin kapsamı ayrıca değerlendirilmelidir. Bu nedenle kategori adından önce turun gerçek program ayrıntılarını karşılaştırın.',
    cards: [
      {
        title: '5 Yıldızlı Lüks Umre Turları',
        text: 'Mekke ve Medine’deki otel adlarını, Haremeyn’e mesafeyi, oda fiyatlarını, uçuşları, transferleri ve dahil hizmetleri inceleyin.',
        path: '/tour/5-yildizli-luks-umre-turlari'
      },
      {
        title: 'VIP ve Butik Umre Turları',
        text: '20–45 kişilik grup, Mekke’de tek otel, THY, hızlı tren, VIP araçlar ve ayrı saha kadrosundan oluşan kesin kalkış standardını inceleyin.',
        path: '/tour/vip-umre-programlari'
      },
      {
        title: 'Delüks Umre Konsepti',
        text: 'Delüks, lüks ve standart programların otel, ulaşım, uçuş ve hizmet kapsamı bakımından farklarını öğrenin.',
        path: '/page/delux-umre-konsepti'
      }
    ],
    selectionGuide: 'En iyi umre turu kişisel ihtiyaçlara uygun, kapsamı açıkça belirtilen programdır. En iyi umre turları ve en iyi umre firmaları karşılaştırılırken otel mesafesi, uçuş planı, oda tipi, rehberlik, sözleşme koşulları ve fiyata dahil hizmetler birlikte incelenmelidir.'
  }
})

const seoFaqs = computed(() => {
  if (!seoLandingContent.value) return []
  if (umrahDurationDays.value) {
    return durationContentModule.buildUmrahDurationFaqs(umrahDurationDays.value, locale.value)
  }
  if (locale.value === 'en' && umrahClusterLandingKey.value) {
    const englishClusterFaqs = {
      duration7: [
        { question: 'How many nights are included in a 7-day Umrah package?', answer: 'The total nights and their distribution between Makkah and Madinah can vary by departure. Check the dates and city-by-city accommodation on the selected tour.' },
        { question: 'Who is a 7-day Umrah package suitable for?', answer: 'It may suit travellers with limited leave who can manage a more intensive itinerary. Review the daily pace alongside your health and mobility needs.' },
        { question: 'What is included in a 7-day Umrah price?', answer: 'Inclusions vary by departure. Verify flights, hotels, transfers, visa services, meals, visits, guidance and insurance on the selected tour page.' }
      ],
      duration10: [
        { question: 'How are nights divided on a 10-day Umrah package?', answer: 'The Makkah and Madinah night split can differ by departure. Check the city-specific dates and accommodation listed on the selected tour.' },
        { question: 'Should I choose a 7-day or 10-day Umrah package?', answer: 'Compare your available time, preferred travel pace, budget, hotels, flights and included services before choosing.' },
        { question: 'Does the 10-day Umrah price change by room type?', answer: 'Yes. Per-person prices can vary for double, triple, quad or single occupancy and for child or infant arrangements.' }
      ],
      ramadan: [
        { question: 'Which dates do Ramadan Umrah packages cover?', answer: 'Each departure can cover a different part of Ramadan. Check the exact outbound and return dates on the selected tour.' },
        { question: 'Are suhoor and iftar included in Ramadan Umrah?', answer: 'Meal arrangements vary by package. Confirm suhoor, iftar and other meals in the written list of included services.' },
        { question: 'Why does hotel distance matter during Ramadan Umrah?', answer: 'Seasonal crowds can affect walking and transfer times. Review the exact hotel location and the transport plan to the Haramain.' }
      ],
      semester: [
        { question: 'When do school holiday Umrah packages operate?', answer: 'The listed departures are selected for the school holiday period. Compare exact travel dates with the current school calendar before booking.' },
        { question: 'How is the child price calculated?', answer: 'The price depends on the child’s age, bed choice and room arrangement. Enter traveller details on the selected tour for the applicable options.' },
        { question: 'What should families compare before booking Umrah?', answer: 'Compare flight times, duration, hotel distance, room capacity, meals, transfers and child conditions together.' }
      ]
    }
    return englishClusterFaqs[umrahClusterLandingKey.value] || []
  }
  if (umrahClusterLandingKey.value === 'duration7') {
    return [
      { question: '7 günlük umre turu kaç gece konaklamalıdır?', answer: 'Gece sayısı ve Mekke–Medine dağılımı kalkış planına göre değişebilir. Tur detayındaki giriş-çıkış tarihleri ile her şehirde açıklanan gece sayısını esas alın.' },
      { question: '7 günlük umre kimler için uygundur?', answer: 'Daha kısa izin süresi bulunan yolcular için uygun olabilir; ancak günlük temponun daha yoğun olabileceği dikkate alınmalıdır. Sağlık ve hareket ihtiyacınızı programla birlikte değerlendirin.' },
      { question: '7 günlük umre fiyatına neler dahildir?', answer: 'Kapsam kalkışa göre değişebilir. Uçuş, otel, transfer, vize hizmeti, yemek, ziyaret, rehberlik ve sigorta bilgilerini seçtiğiniz turun detayından doğrulayın.' }
    ]
  }
  if (umrahClusterLandingKey.value === 'duration10') {
    return [
      { question: '10 günlük umre programında Mekke ve Medine’de kaç gece kalınır?', answer: 'Gece dağılımı her kalkışta aynı olmayabilir. Seçilen turun otel bölümünde şehir bazında açıklanan gece sayıları ve tarihleri kontrol edilmelidir.' },
      { question: '7 günlük mü 10 günlük umre mi seçilmeli?', answer: 'Karar izin sürenize, seyahat temponuza, bütçenize ve konaklama planına bağlıdır. Aynı otel, oda, uçuş ve hizmet kapsamındaki seçenekleri karşılaştırın.' },
      { question: '10 günlük umre fiyatı oda tipine göre değişir mi?', answer: 'Evet. Kişi başı ücret ikili, üçlü, dörtlü veya tek kişilik oda yerleşimine; çocuk ve bebek koşullarına göre değişebilir.' }
    ]
  }
  if (umrahClusterLandingKey.value === 'ramadan') {
    return [
      { question: 'Ramazan umre turları hangi tarihleri kapsar?', answer: 'Listede Ramazan ayına denk gelen kalkışlar gösterilir. Her programın kesin gidiş-dönüş tarihini ve Ramazan’ın hangi günlerini kapsadığını tur detayından kontrol edin.' },
      { question: 'Ramazan umresinde sahur ve iftar dahil mi?', answer: 'Yemek kapsamı programdan programa değişebilir. Sahur, iftar ve diğer öğünleri otel ve dahil hizmetler bölümünden yazılı olarak doğrulayın.' },
      { question: 'Ramazan umresi seçerken otel mesafesi neden önemlidir?', answer: 'Ramazan yoğunluğunda yürüme ve ulaşım süreleri değişebilir. Otelin tam konumunu ve Haremeyn’e servis ya da yürüme düzenini inceleyin.' }
    ]
  }
  if (umrahClusterLandingKey.value === 'semester') {
    return [
      { question: 'Sömestr umre turları hangi tarihlerde yapılır?', answer: 'Sayfa ilan edilen yarıyıl tatili aralığına denk gelen kalkışları listeler. Kesin gidiş-dönüş tarihini güncel okul takvimiyle birlikte kontrol edin.' },
      { question: 'Çocuklar için umre fiyatı nasıl hesaplanır?', answer: 'Fiyat çocuğun yaşına, yatak seçimine ve oda yerleşimine göre değişir. İlgili turda yolcu bilgilerini girerek geçerli seçeneği inceleyin.' },
      { question: 'Aileyle umre turu seçerken nelere bakılmalı?', answer: 'Uçuş saatleri, toplam süre, otel mesafesi, oda kapasitesi, yemek planı, transfer süresi ve çocuklara uygulanacak koşullar birlikte değerlendirilmelidir.' }
    ]
  }
  if (isVipUmrahLanding.value && locale.value === 'en') {
    return [
      {
        question: 'What is the difference between VIP and boutique Umrah?',
        answer: 'The labels are not universal across the market. At Inanc Tour they describe a defined scheduled-departure standard: groups of 20–45, one Makkah hotel, Turkish Airlines, high-speed rail, VIP road transport and separate guidance and field teams.'
      },
      {
        question: 'How many people are in a VIP Umrah group?',
        answer: 'Inanc Tour scheduled Umrah groups are planned for 20 to 45 guests.'
      },
      {
        question: 'How are flights and transfers arranged?',
        answer: 'Turkish Airlines is standard for flights. High-speed rail is used for the Madinah–Makkah intercity journey, while airports and visits use newer-model private VIP vehicles or coaches.'
      },
      {
        question: 'Who manages guests and operations?',
        answer: 'The tour scholar focuses on guests and spiritual guidance. Two field staff in Madinah, two in Makkah and the Türkiye operations team manage operational processes.'
      },
      {
        question: 'Are meals and digital travel information included?',
        answer: 'All programs include breakfast and dinner buffets. Reservation, hotel, flight, train, QR, guide and staff information is accessible through the web service and mobile app.'
      }
    ]
  }
  if (isVipUmrahLanding.value) {
    return [
      {
        question: 'VIP umre ile butik umre arasındaki fark nedir?',
        answer: 'Bu ifadeler sektör genelinde tek bir resmî standardı göstermez. İnanç Tur’da 20–45 kişilik grup, Mekke’de tek otel, THY, hızlı tren, VIP araçlar ve ayrı rehberlik-saha kadrosundan oluşan tanımlı kesin kalkış standardını ifade eder.'
      },
      {
        question: 'VIP umre grupları kaç kişiliktir?',
        answer: 'İnanç Tur’un kesin kalkışlı umre grupları 20 ile 45 kişi arasında planlanır.'
      },
      {
        question: 'Uçuş ve transferler nasıl yapılır?',
        answer: 'Uçuşlarda Türk Hava Yolları, Medine–Mekke şehirler arası geçişinde hızlı tren; havalimanı ve ziyaretlerde yeni model özel VIP araçlar veya otobüsler standarttır.'
      },
      {
        question: 'Misafir ve operasyon süreçleriyle kim ilgilenir?',
        answer: 'Tur hocası misafirlere ve manevi rehberliğe odaklanır. Operasyonu Medine’de iki, Mekke’de iki saha görevlisi ile Türkiye ekibi yürütür.'
      },
      {
        question: 'Yemekler ve dijital seyahat bilgileri dahil midir?',
        answer: 'Tüm programlarda sabah ve akşam zengin açık büfe bulunur. Rezervasyon, otel, uçak, tren, QR, rehber ve görevli bilgilerine web servisi ve mobil uygulamadan erişilebilir.'
      }
    ]
  }
  if (locale.value === 'en') {
    return [
      {
        question: 'What determines the price of an Umrah package?',
        answer: 'Travel dates, duration, hotel category and location, airline, room occupancy and child or infant arrangements are the main variables. Compare the current per-person options on each tour page.'
      },
      {
        question: 'What is included in the Umrah package price?',
        answer: 'Inclusions can vary by departure. Use the selected tour page to verify flights, Makkah and Madinah accommodation, visa-related services, transfers, meals, visits, guidance and insurance information.'
      },
      {
        question: 'How do I compare 5-star Umrah hotels?',
        answer: 'Compare more than the star rating: check the exact hotel, walking or transfer distance to the Haramain, number of nights, meal plan, room layout and transport schedule.'
      },
      {
        question: 'Where can I see confirmed Umrah departure dates?',
        answer: 'Confirmed departures and current availability are shown in the tour list. Open a date to review its return date, duration, airline, hotels and remaining availability.'
      },
      {
        question: 'Are there separate Umrah prices for children and infants?',
        answer: 'Yes. The applicable price depends on age, bed choice and room arrangement. Enter the travellers and children’s ages in the package calculator for the relevant options.'
      },
      {
        question: 'How can I reserve an Umrah package?',
        answer: 'Choose a departure, review its program and price, then submit a pre-registration request or contact İnanç Turizm. Final availability and payment details are confirmed by the sales team.'
      }
    ]
  }
  return [
    {
      question: 'Umre turu fiyatlarını hangi unsurlar belirler?',
      answer: 'Seyahat tarihi, tur süresi, otelin kategorisi ve Haremeyn’e mesafesi, havayolu, oda kişi sayısı ile çocuk veya bebek için seçilen yatak düzeni başlıca fiyat unsurlarıdır.'
    },
    {
      question: 'Umre turu fiyatına hangi hizmetler dahildir?',
      answer: 'Paket kapsamı kalkışa göre değişebilir. Uçuş, Mekke ve Medine konaklaması, vize hizmeti, transfer, yemek, ziyaret, rehberlik ve sigorta bilgilerini seçtiğiniz turun detay sayfasından doğrulayın.'
    },
    {
      question: '5 yıldızlı umre otelleri nasıl karşılaştırılmalı?',
      answer: 'Yıldız kategorisinin yanında otelin tam adını, Haremeyn’e yürüme veya transfer mesafesini, konaklama gece sayısını, yemek planını, oda yerleşimini ve ulaşım programını inceleyin.'
    },
    {
      question: 'Kesin umre kalkış tarihlerini nereden görebilirim?',
      answer: 'Kesinleşen tarihler ve güncel kontenjan tur listesinde gösterilir. Bir tarihi açarak dönüş tarihini, tur süresini, havayolunu, otelleri ve müsaitlik durumunu inceleyebilirsiniz.'
    },
    {
      question: 'Çocuk ve bebekler için ayrı umre fiyatı var mı?',
      answer: 'Evet. Uygulanacak fiyat yaşa, yatak seçimine ve oda yerleşimine göre değişir. İlgili turdaki fiyat hesaplama alanına yolcu sayılarını ve çocuk yaşlarını girerek seçenekleri görebilirsiniz.'
    },
    {
      question: 'Umre turu rezervasyonu nasıl yapılır?',
      answer: 'Kalkış tarihini seçip programı ve fiyatı inceleyin; ardından ön kayıt talebi oluşturun veya İnanç Turizm ile iletişime geçin. Son kontenjan ve ödeme bilgileri satış ekibi tarafından teyit edilir.'
    }
  ]
})

const seoLandingMeta = computed(() => {
  if (!seoLandingContent.value) return null
  const strategy = umrahClusterLandingKey.value
    ? umrahSeoStrategy.value[umrahClusterLandingKey.value]
    : isVipUmrahLanding.value
    ? umrahSeoStrategy.value.vip
    : isFiveStarUmrahLanding.value
      ? umrahSeoStrategy.value.premium
      : umrahSeoStrategy.value.catalog

  return {
    title: strategy.title,
    description: strategy.description,
    keywords: strategy.keywords
  }
})

useSeoMeta({
  title: () => seoLandingMeta.value?.title,
  ogTitle: () => seoLandingMeta.value?.title,
  description: () => seoLandingMeta.value?.description,
  ogDescription: () => seoLandingMeta.value?.description,
  keywords: () => seoLandingMeta.value?.keywords,
  ogType: () => seoLandingMeta.value ? 'website' : undefined,
  ogSiteName: () => seoLandingMeta.value ? (locale.value === 'en' ? 'Inanc Tour' : 'İnanç Turizm') : undefined,
  robots: () => seoLandingMeta.value
    ? route.query.compare
      ? 'noindex, follow, noarchive'
      : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
    : undefined
})

const intrinsicLandingFilters = computed(() => resolveUmrahLandingFilters(url.value, new Date()))
const getLandingSearchDefaults = () => createUmrahLandingSearch(url.value, new Date())
const applyIntrinsicLandingFilters = (target) => ({
  ...target,
  ...(intrinsicLandingFilters.value || {}),
})
const search = ref(getLandingSearchDefaults());
const activeTourFilterItems = computed(() => {
  const items = []
  const whenOptions = searchQuestions.value?.when || []
  const durationOptions = searchQuestions.value?.duration || []

  for (const value of search.value.when || []) {
    const option = whenOptions.find((item) => item.id === value)
    const [, year] = String(option?.id || value).split('-')
    items.push(`${t(option?.label || value)}${year ? ` 20${year}` : ''}`)
  }

  for (const value of search.value.duration || []) {
    const option = durationOptions.find((item) => item.id === value)
    const exactDays = String(value).match(/^(\d+)-\1$/)?.[1]
    items.push(option ? t(option.label) : exactDays ? `${exactDays} ${locale.value === 'en' ? 'days' : 'gün'}` : t(value))
  }

  if (search.value.activeHotelId && search.value.activeHotelId !== 'all') {
    items.push(activeHotelFilterLabel.value || t('Seçili otel'))
  }

  return items
})
const activeTourFilterCount = computed(() => activeTourFilterItems.value.length)
const hasActiveTourFilters = computed(() => activeTourFilterCount.value > 0)
const activeTourFilterSummary = computed(() => activeTourFilterItems.value.join(', '))
const tourListCache = useState('tour-list-cache-v2', () => ({}))
const restoredFromCache = ref(false)
const restoredScrollY = ref(0)
const restoredFocusTourId = ref(null)

const getListCacheKey = () => `${locale.value}:${route.path}`

const extractTourIdFromPath = (pathValue) => {
  const path = String(pathValue || '')
  const match = path.match(/\/tourDetail\/([^/?#]+)/i)
  return match?.[1] || null
}

const normalizeTourId = (value) => {
  if (value == null) return null
  const normalized = String(value).trim()
  return normalized.length > 0 ? normalized : null
}

const cloneSafe = (value) => {
  if (value == null) return value
  try {
    if (typeof structuredClone === 'function') return structuredClone(value)
  } catch (e) {
    // Fallback below.
  }
  try {
    return JSON.parse(JSON.stringify(value))
  } catch (e) {
    return null
  }
}

const saveListStateToCache = (options = {}) => {

  if(!process.client  || (window.scrollY || window.pageYOffset || 0) < 100){
    return;
  }
  const key = getListCacheKey()
  const existingFocusTourId = tourListCache.value?.[key]?.focusTourId ?? null
  const focusTourId = options.focusTourId !== undefined
    ? normalizeTourId(options.focusTourId)
    : normalizeTourId(existingFocusTourId)

  const payload = {
    tours: cloneSafe(tours.value),
    activeTours: cloneSafe(activeTours.value),
    toursDateList: cloneSafe(toursDateList.value),
    toursDateListMonth: cloneSafe(toursDateListMonth.value),
    search: cloneSafe(search.value),
    labelSearch: cloneSafe(labelSearch.value),
    activeHotelFilterLabel: activeHotelFilterLabel.value,
    isScrolled: isScrolled.value,
    viewMode: viewMode.value,
    focusTourId,
    scrollY: process.client ? (window.scrollY || window.pageYOffset || 0) : 0,
    savedAt: Date.now(),
  }

  console.log("Saving list state to cache with key:", window.scrollY, window.pageYOffset, payload.scrollY)

  tourListCache.value = {
    ...tourListCache.value,
    [key]: payload,
  }
}

const restoreListStateFromCache = () => {
  const key = getListCacheKey()
  const cached = tourListCache.value?.[key]
  if (!cached || !cached.tours || Object.keys(cached.tours).length === 0) {
    return false
  }
  console.log("Restoring list state from cache with key:", key, cached.scrollY)
  tours.value = cloneSafe(cached.tours)
  activeTours.value = cloneSafe(cached.activeTours) || {}
  toursDateList.value = cloneSafe(cached.toursDateList) || []
  toursDateListMonth.value = cloneSafe(cached.toursDateListMonth) || []
  search.value = applyIntrinsicLandingFilters(cloneSafe(cached.search) || getLandingSearchDefaults())
  labelSearch.value = cloneSafe(cached.labelSearch) || { when: t('When'), duration: t('Duration') }
  activeHotelFilterLabel.value = cached.activeHotelFilterLabel || ''
  isScrolled.value = !!cached.isScrolled
  if (cached.viewMode && viewModes.includes(cached.viewMode)) {
    viewMode.value = cached.viewMode
  }

 
  restoredScrollY.value = typeof cached.scrollY === 'number' ? Math.max(0, cached.scrollY) : 0
    console.log("restoredScrollY.value ", restoredScrollY.value )
  restoredFocusTourId.value = normalizeTourId(cached.focusTourId)
  setTimeout(() => {
    restoreScrollPositionFromCache();
  }, 1000);

  return true
}
const addRoom = () => {
  reservation.value.rooms.push({
    adult: 2,
    child: 0,
    baby: 0,
    room_type: null,
    options: {},
  });
  normalizeChildrenAges(reservation.value);
};

const removeRoom = (index) => {
  reservation.value.rooms = reservation.value.rooms.filter((item, i) => index !== i);
  normalizeChildrenAges(reservation.value);
};

const removeChildAge = (idx) => {
  const age = reservation.value.childrenAges[idx];
  removeChildFromRooms(reservation.value, age);
  reservation.value.childrenAges.splice(idx, 1);
  normalizeChildrenAges(reservation.value);
  syncSidebarChildBedSelections();
  saveReservationSelection(reservation.value);
};

const totalKidsCount = computed(() => getRoomKidsCount(reservation.value));

const hydratePeopleFromQuery = () => {
  const adults = parseInt(route.query?.adults || '', 10);
  const rooms = parseInt(route.query?.rooms || '', 10);
  const children = route.query?.children ? String(route.query.children).split(',').filter(Boolean) : [];

  if (!Number.isNaN(rooms) && rooms > 0) {
    const baseRooms = Array.from({ length: rooms }, () => ({
      adult: 1,
      child: 0,
      baby: 0,
      room_type: null,
      options: {},
    }));
    let remaining = Number.isNaN(adults) ? 0 : Math.max(0, adults - rooms);
    for (let i = 0; i < baseRooms.length && remaining > 0; i += 1) {
      baseRooms[i].adult += 1;
      remaining -= 1;
    }
    for (let i = 0; i < baseRooms.length && remaining > 0; i += 1) {
      baseRooms[i].adult += 1;
      remaining -= 1;
    }
    reservation.value.rooms = baseRooms;
  }

  if (children.length > 0) reservation.value.childrenAges = children;
  normalizeChildrenAges(reservation.value);
};
const urlToId = {
    "rota-fas-turlari": {
      id: "FASTURLARI"
    },
    "7-gunluk-umre-turlari": {id: '7GUNUMRE', title: ('7 Gün Umre Turu'),title2: ('7 Gün Umre Tur ve Fiyatları')},
    "10-gunluk-umre-turlari": {id: '10GUNUMRE', title: ('10 Gün Umre Turu'),title2: ('10 Gün Umre Tur ve Fiyatları')},
    "somestr-umre-turlari": {id: '5YILDIZUMRE', title: ('Sömestr Umre Turu'),title2: ('Sömestr Umre Tur ve Fiyatları')},
    "5-gunluk-umre-turlari": {id: '5GUNUMRE', title: ('5 Gün Umre Turu'),title2: ('5 Gün Umre Tur ve Fiyatları')},
    "12-gunluk-umre": {id: '12GUNUMRE', title: ('12 Gün Umre Turu'),title2: ('12 Gün Umre Tur ve Fiyatları')},
    "15-gun-umre": {id: '15GUNUMRE', title: ('15 Gün Umre Turu'),title2: ('15 Gün Umre Tur ve Fiyatları')},
    "ramazan-umre-turlari": {id: 'RAMAZANUMRE', title: ('Ramazan Umre'),title2: ('Ramazan Umre Tur ve Fiyatları')},
    "agustos-umre-turlari": {id: 'AGUSTOSUMRE', title: ('Ağustos Umre Turu'),title2: ('Ağustos Umre Tur ve Fiyatları')},
    "eylul-umre-turlari": {id: 'EYLULUMRE', title: ('Eylül Umre Turu'),title2: ('Eylül Umre Tur ve Fiyatları')},
    "ekim-umre-turlari": {id: 'EKIMUMRE', title: ('Ekim Umre Turu'),title2: ('Ekim Umre Tur ve Fiyatları')},
    "kasim-umre-turlari": {id: 'KASIMUMRE', title: ('Kasım Umre Turu'),title2: ('Kasım Umre Tur ve Fiyatları')},
    "aralik-umre-turlari": {id: 'ARALIKUMRE', title: ('Aralık Umre Turu'),title2: ('Aralık Umre Tur ve Fiyatları')},
    "ocak-umre-turlari": {id: 'OCAKUMRE', title: ('Ocak Umre Turu'),title2: ('Ocak Umre Tur ve Fiyatları')},
    "subat-umre-turlari": {id: 'SUBATUMRE', title: ('Şubat Umre Turu'),title2: ('Şubat Umre Tur ve Fiyatları')},
    "mart-umre-turlari": {id: 'MARTUMRE', title: ('Mart Umre Turu'),title2: ('Mart Umre Tur ve Fiyatları')},
    "nisan-umre-turlari": {id: 'NISANUMRE', title: ('Nisan Umre Turu'),title2: ('Nisan Umre Tur ve Fiyatları')},
    "mayis-umre-turlari": {id: 'MAYISUMRE', title: ('Mayıs Umre Turu'),title2: ('Mayıs Umre Tur ve Fiyatları')},
    "haziran-umre-turlari": {id: 'HAZIRANUMRE'},
    "temmuz-umre-turlari": {id: 'TEMMUZUMRE'},
    "5-yildizli-luks-umre-turlari": {id: '5YILDIZUMRE',title: ('5 Yıldızlı Otellerde Umre Turu'),title2: ('5 Yıldızlı Umre Tur ve Fiyatları')},
    "unlu-hocalarla-umre-turlari": {id: 'PUPULARGUIDES'},
    "rota-bosna-hersek-turlari": {
      id: "VG91ckNhdGVnb3J5MTY5NjE5MTE4Mgqq"
    },
    "rota-kudus-turlari": {
      id: "VG91ckNhdGVnb3J5MTY5NjE5MTIzNgqq"
    },
    "rota-dubai-turlari": {
      id: "VG91ckNhdGVnb3J5MTY5NjE5MTI3Mgqq"
    },
    "rota-misir-turlari": {
      id: "VG91ckNhdGVnb3J5MTY5NjE5MTMwNAqq"
    }
    , "rota-ispanya-turlari": {
      id: "VG91ckNhdGVnb3J5MTY5NjE5MTQzMwqq"
    }
    , "rota-balkan-turlari": {
      id: "VG91ckNhdGVnb3J5MTY5NjE5NjkzNwqq"
    }, 
    "rota-yurtdisi-turlari": {
      id: "YURT"
    }, "umre-turlari": {
      id: "5YILDIZUMRE"
    }  
}






 
const banners = computed(() => {
  const bannerPaths = ['/tour/umre-turlari', '/en/tour/umrah-tours']
  const path = String(route.path || '/').replace(/\/+$/, '') || '/'

  if (!bannerPaths.includes(path)) return []

  return [
      {
       temp: "1"
      },
      {
        heading: {
          tr: `Umre Fiyatları ${currentSeoYear}`,
          en: `Umrah Prices ${currentSeoYear}`,
        },
        color: "bg-gradient-to-r   from-slate-700 to-slate-400 border-l-4 border-l-orange-500",
        text: {
          tr: `${umrahSeasonLabel} umre fiyatları açıklandı. Güncel program ve fiyatları filtreleme araçlarıyla inceleyebilirsiniz. 5 yıldızlı turları, yıllardır olduğu gibi kaliteden ödün vermeden avantajlı fiyatlarla sunuyoruz.`,
          en: `You can find our ${umrahSeasonLabel} Umrah prices on this page. Use the filters to review current programs and prices. We offer our 5-star accommodation packages at competitive prices without compromising on quality.`,
        }
      }, 
      {
        heading: {
          tr: `Umre Turları ${currentSeoYear}`,
          en: `Umrah Tours ${currentSeoYear}`,
        },
        color: "bg-gradient-to-r   from-slate-700 to-slate-400 border-l-4 border-l-orange-500",
        text: {
          tr: `${umrahSeasonLabel} umre turları ve tarihleri açıklandı. Kesin kalkışlı programlarımızda otelden rehberlik hizmetine kadar her ayrıntıyı inceleyebilirsiniz.`,
          en: `Explore ${umrahSeasonLabel} Umrah packages and departure dates. Review every confirmed program detail, from hotels and flights to guidance services.`,
        }
      },
      {
        heading: {
          tr: '5 Yıldızlı Umre',
          en: '5 Stars Accomodation Umre',
        },  
        color: "bg-gradient-to-r   from-slate-700 to-slate-400 border-l-4 border-l-orange-500",
        text: {
            tr: 'Sadece 5 yıldızlı umre turları düzenliyor ve kaliteyi bir lüks olarak değil standart olarak sunuyoruz. Tüm turlarımızı 5 yıldızlı yakın otellerde konaklayacak şekilde hazırlıyoruz.',
            en: "We only organize 5-star Umrah tours and offer quality as a standard, not as a luxury. We prepare all our tours to stay in nearby 5-star hotels."
        }
      }
    ]
})
 

if(url.value){
      if(locale.value == "tr"){
          let linkPath = linkInLanguage["/tour/"+url.value];
          if(linkPath){
            useHead({
                    link: [ 
                    { rel: "alternate", hreflang: "x-default", href: "https://inanctur.com.tr/tour/"+url.value }, 
                    { rel: "alternate", hreflang: "tr", href: "https://inanctur.com.tr/tour/"+url.value },  
                    { rel: "alternate", hreflang: "en", href: "https://inanctur.com.tr/en"+linkPath }, 
                    ]
            })
          }
      }else if(locale.value == "en"){
  
          let val = Object.entries(linkInLanguage); 
          let res = val.find(item=> item[1] == "/tour/"+url.value )
          if(res){
            useHead({
                    link: [ 
                    { rel: "alternate", hreflang: "x-default", href: "https://inanctur.com.tr"+res[0] }, 
                    { rel: "alternate", hreflang: "tr", href: "https://inanctur.com.tr"+res[0] }, 
                    // { rel: "alternate", hreflang: "tr", href: "https://inanctur.com.tr/tr"+res[0] }, 
                    { rel: "alternate", hreflang: "en", href: "https://inanctur.com.tr/en/tour/"+url.value }, 
                    ]
            })
          }
      }
}

const loadingScrolledData = ref(false)
const category = computed(()=>{
  if (intrinsicLandingFilters.value?.category) return intrinsicLandingFilters.value.category
  if(locale.value != "tr"){
    let val = Object.entries(linkInLanguage);
 
    let res = val.find(item=> item[1] == "/tour/"+url.value )

    if(res){
        let linkAddress = res[0].replace("/tour/",'')
       return urlToId[linkAddress]?.id
    }
    return urlToId[url.value]?.id
  }else{
    return urlToId[url.value]?.id
  }
}) 
  
const setHotelFilter = (hotelId, label) => {  
  if(search.value.activeHotelId == hotelId) {
    // Filtreyi kaldır
    search.value.activeHotelId = null; 
    activeHotelFilterLabel.value = '';
  } else {
    // Filtreyi uygula
    search.value.activeHotelId = hotelId; 
    activeHotelFilterLabel.value = label;
  } 
  // Tüm veriyi alıp (limit yükselterek) client-side filtre uygula
  fetchTours(0, true);
  // Liste başına dön
  if (import.meta.client) window.scrollTo({ top: 0, behavior: 'smooth' });
};

const  generateTouristTripSchema = (tour)=>{
 
  // let cities = JSON.parse(tour.cityDuration)
 
  // return  { 
  //   "@type": "TouristTrip",
  //   "name": `${tour.start} ${tour.tur_Sure}${t('gün')} ${t('umre')}`,
  //   "description": `${tour.start} tarihli ${tour.end} dönüşlü  ${tour.tur_Sure}${t('gün')} ${t('umre')} turu. Uçuşumuz ${tour.airwayName?.tr} ile gerçekleşmektedir. ${tour.tur_Sure}${t('gün')} ${t('umre')} turu için otelimiz ${tour.hotels[0].sOtelAdi?.[locale.value]} otelidir. ${tour.tur_Sure}${t('gün')} ${t('umre')} turu için fiyatlarımız ${tour.turs_double} ${tour.tour_Currency}’dir.`,
  //   "itinerary": cities.map(city => ({
  //     "@type": "City",
  //     "name": city.name
  //   })),
  //   "touristType": {
  //     "@type": "Audience",
  //     "audienceType": "General"
  //   },
  //   "offers": {
  //     "@type": "Offer",
  //     "priceCurrency": tour.tour_Currency,
  //     "price": tour.turs_double.toString(),
  //     "availability": "https://schema.org/InStock",
  //     "validFrom": new Date().toISOString().split('T')[0],
  //     "url": "https://inanctur.com.tr/tourDetail/" + tour.pdb_Id,
  //   },
  //   "provider": {
  //     "@type": "Organization",
  //     "name": locale.value == "tr" ? "İNANÇ TURİZM" : "INANC TOUR",
  //     "logo": {
  //       "@type": "ImageObject",
  //       "url": "https://inanctur.com.tr/assets/img/logo/inanc_tur_yeni_logo.webp"
  //     }
  //   },
  //   "arrivalTime": tour.turs_StartDate,
  //   "departureTime": tour.turs_EndDate,
  //   "image": tour.hotels
  //     .map(hotel => hotel.sOtelPhoto)
  //     .filter(Boolean)
  // }
}

const activeTours = ref({});
const hasAvailableTours = (dayTours) => Array.isArray(dayTours) && dayTours.some((tour) => {
  if (hide.value?.[tour?.start] || tour?.status === 2) return false
  return Boolean(tour?.turs_status_data?.available)
})
const hasVisibleTours = (dayTours) => Array.isArray(dayTours) && dayTours.some((tour) => {
  if (hide.value?.[tour?.start]) return false
  if (tour?.status === 2) return false
  return Boolean(tour?.turs_status_data?.available) || tour?.turs_status_data?.value === 'FULL'
})
const setTours = (data) => {
   
    activeTours.value = {};
    //group tours by turs_StartDate then tur_Sure 
    tours.value = data.reduce((acc, tour) => {
      let city = tour.hotels[0]?.city?.en;
      const key = `${tour.turs_StartDate}-${tour.tur_Sure}-${city}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      if(!acc[key].find(item=> item.pdb_Id == tour.pdb_Id)){
          tour.city = tour.hotels[0]?.city?.en;
          acc[key].push(tour);
          if((tour.turs_status_data?.available || tour.turs_status_data?.value === 'FULL') && tour.status!=2){
            activeTours.value[key] = true;
          }
      } 
      return acc;
    }, {})
    
};
const fetchTours = (offset=0,searchAll=false) => {

  let lmt = isMobile.value ? 10 : 30;
  search.value = applyIntrinsicLandingFilters({ ...search.value, category: category.value });
  if(offset==0 && searchAll){
    search.value.limit = 200;
    search.value.page = 0;
    search.value.offset = 0;

  }else if(offset==0){
    search.value.limit = lmt;
    search.value.page = 0;
  }else{
    search.value.limit = 200;
    search.value.page = 1;
    search.value.offset = lmt;
    loadingScrolledData.value = true; 
  }
 
  loading.value = true;
  return tourCo.getTours(search.value,locale).then((result) => {
    let toursData = result?.tours || [];
    if(offset==0){
      tours.value = [];
      toursData = result.sort((a, b) => {
        const dateDiff = new Date(a.turs_StartDate) - new Date(b.turs_StartDate);
        if (dateDiff !== 0) return dateDiff;

        // return Number(a.turs_double) - Number(b.turs_double);
        return Number(a.tur_Sure) - Number(b.tur_Sure);
      }) 
      const schemaData = [];
   
      setTours(toursData);
      loadingScrolledData.value = false; 
    }else if(result){ 

       let t = [];
      Object.values(tours.value).forEach(item => {
         item.forEach(tour => {
             t.push(tour);
          })
      }); 
      let toursData = [...t,...result].sort((a, b) => {
        const dateDiff = new Date(a.turs_StartDate) - new Date(b.turs_StartDate);
        if (dateDiff !== 0) return dateDiff;

        return Number(a.turs_double) - Number(b.turs_double);
        // return Number(a.tur_Sure) - Number(b.tur_Sure);
      }) ;
 
       setTours(toursData);

      loadingScrolledData.value = false; 
    }else{
      loadingScrolledData.value = false; 
    }


    
    gettoursDateList();
    loading.value = false;
  }).catch(err=>{
    loadingScrolledData.value = false; 
    loading.value = false;
    return [];
  });

}

const isScrolled = ref(false)
const hideSidebarInfoCards = ref(false)
const lastScrollTop = ref(0)
const desktopSidebarRef = ref(null)
const sidebarStickyActive = ref(false)
const sidebarStickyMinimized = ref(false)
const sidebarStickyThreshold = ref(Number.POSITIVE_INFINITY)
const sidebarStickyLeft = ref(0)
const sidebarStickyWidth = ref(300)
const sidebarStickyTop = ref(10)
const seoLandingHeadingRef = ref(null)
let sidebarResizeObserver = null

const roomCardContentVisible = computed(() => !sidebarStickyActive.value || !sidebarStickyMinimized.value)
const sidebarStickyStyle = computed(() => sidebarStickyActive.value ? {
  top: `${sidebarStickyTop.value}px`,
  left: `${sidebarStickyLeft.value}px`,
  width: `${sidebarStickyWidth.value}px`
} : {})
const shouldHideSidebarInfoCards = computed(() => !isMobile.value && sidebarStickyActive.value)

const measureSidebarStickyBoundary = () => {
  if (!import.meta.client || !desktopSidebarRef.value || window.innerWidth < 768) return
  const sidebarRect = desktopSidebarRef.value.getBoundingClientRect()

  sidebarStickyLeft.value = sidebarRect.left
  sidebarStickyWidth.value = sidebarRect.width

  if (!sidebarStickyActive.value) {
    sidebarStickyThreshold.value = window.scrollY + sidebarRect.bottom + 100
  }
}

const updateSidebarSticky = (scrollTop = window.scrollY) => {
  if (!import.meta.client || isMobile.value || window.innerWidth < 768) {
    sidebarStickyActive.value = false
    sidebarStickyMinimized.value = false
    sidebarStickyTop.value = 10
    return
  }

  if (!Number.isFinite(sidebarStickyThreshold.value)) measureSidebarStickyBoundary()
  const shouldStick = scrollTop >= sidebarStickyThreshold.value

  if (shouldStick && !sidebarStickyActive.value) {
    sidebarRoomEditorOpen.value = false
    sidebarStickyMinimized.value = true
    sidebarStickyActive.value = true
  } else if (!shouldStick && sidebarStickyActive.value) {
    sidebarStickyActive.value = false
    sidebarStickyMinimized.value = false
    sidebarStickyTop.value = 10
    requestAnimationFrame(measureSidebarStickyBoundary)
  }

  if (sidebarStickyActive.value && desktopSidebarRef.value) {
    const boundaryTop = seoLandingHeadingRef.value?.getBoundingClientRect().top
    const sidebarRect = desktopSidebarRef.value.getBoundingClientRect()
    const sidebarHeight = Math.min(sidebarRect.height, Math.max(0, window.innerHeight - 120))

    sidebarStickyTop.value = Number.isFinite(boundaryTop)
      ? Math.min(10, boundaryTop - sidebarHeight - 16)
      : 10
  }
}

const toggleStickyRoomCard = () => {
  sidebarStickyMinimized.value = !sidebarStickyMinimized.value
  if (sidebarStickyMinimized.value) sidebarRoomEditorOpen.value = false
}

const handleSidebarResize = () => {
  if (sidebarStickyActive.value && desktopSidebarRef.value) {
    const rect = desktopSidebarRef.value.getBoundingClientRect()
    sidebarStickyLeft.value = rect.left
    sidebarStickyWidth.value = rect.width
  } else {
    measureSidebarStickyBoundary()
  }
  updateSidebarSticky(window.scrollY)
}

onMounted(() => {
  requestAnimationFrame(() => {
    measureSidebarStickyBoundary()
    updateSidebarSticky(window.scrollY)
  })
  window.addEventListener('resize', handleSidebarResize)
  if (typeof ResizeObserver !== 'undefined' && desktopSidebarRef.value) {
    sidebarResizeObserver = new ResizeObserver(() => {
      if (!sidebarStickyActive.value) measureSidebarStickyBoundary()
    })
    sidebarResizeObserver.observe(desktopSidebarRef.value)
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleSidebarResize)
  sidebarResizeObserver?.disconnect()
})
const activeDateId = ref(null)

// Flattened date entries for prev/next navigation
const flatDateEntries = computed(() => {
  if (!toursDateList.value || !toursDateListMonth.value?.length) return []
  const entries = []
  for (const month of toursDateListMonth.value) {
    const group = toursDateList.value[month]
    if (!group) continue
    for (const key of Object.keys(group)) {
      const entry = group[key]
      if (entry?.id && entry?.date) {
        entries.push({ ...entry, month, key })
      }
    }
  }
  return entries
})

const activeDateIndex = computed(() => {
  if (!activeDateId.value) return -1
  return flatDateEntries.value.findIndex(e => e.id === activeDateId.value)
})

const activeDateEntry = computed(() => {
  const idx = activeDateIndex.value
  return idx >= 0 ? flatDateEntries.value[idx] : null
})

const prevDateEntry = computed(() => {
  const idx = activeDateIndex.value
  return idx > 0 ? flatDateEntries.value[idx - 1] : null
})

const nextDateEntry = computed(() => {
  const idx = activeDateIndex.value
  return idx >= 0 && idx < flatDateEntries.value.length - 1 ? flatDateEntries.value[idx + 1] : null
})

const activeDateLabel = computed(() => {
  if (!activeDateEntry.value) return ''
  return activeDateEntry.value.date
})

 const contactForm = useContactForm();

 

const backgroundImage = computed(() => {

  return pageData.value.SA_PageTopImage || '/assets/img/headerbg.png'

})



const data = [
  {
    url: "/tours/rota-yurtdisi-turlari",
    title: "Yurtdışı Turlar"
  },
  {
    url: "/tours/rota-kudus-turlari",
    title: "Kudüs Turları"
  }
  ,
  {
    url: "/tours/rota-misir-turlari",
    title: "Mısır Turları"
  },
  {
    url: "/tours/rota-fas-turlari",
    title: "Fas Turları"
  },
  {
    url: "/tours/rota-tunus-turlari",
    title: "Tunus Turları"
  },
  {
    url: "/tours/rota-dubai-turlari",
    title: "Dubai Turları"
  },
  {
    url: "/tours/rota-bosna-hersek-turlari",
    title: "Bosna Hersek Turları"
  },
  {
    url: "/tours/rota-balkan-turlari",
    title: "Balkan Turları"
  }
];
 


// let informations = [

// {
//     title: {tr: 'Umre Otelleri', en: "Umrah Hotels"},
//     text: {tr: `2025-2026 Kış dönemi umre turları ve fiyatları açıklanmıştır. İlk rezervasyon avantajlarından yararlanmak ister misiniz?`, 
//             en: `Dear Guests;
//             Our winter season packages announced. You can take advantage of the first booking benefits.
//             `},
//   },
//   {
//     title: {tr: 'Sömestr Umre', en: "School Holiday Umrah"},
//     text: {
//       tr: `2026 yılı okul tatili umre turları fiyatlarımız açıklandı. 5 yıldızlı otellerde konaklamalı umre turlarımızda siz de yerinizi ayırın. `, 
//             en: `2026 school holiday Umrah packages prices have been announced. Reserve your place in our Umrah packages with accommodation in 5-star hotels.`,},
//   }

//]

const gettoursDateList = () => {
  let dates = {};
   let kotadolu= {}
  let toursData = Object.values(tours.value);
  if(!toursData || toursData.length==0) return;
  toursData.forEach((itemx,key) => {

    let item = itemx[0]; 
    if(!item) return;
    let start = item.start.split(" ").slice(0, 2).join(" ");
    let month = item.startMonth;
    if(locale.value=="en"){
       start = formatDate(item.turs_StartDate, 'dd MMM')
       item.start = start;
    }else if(locale.value=="tr"){
        
    }
    
    item.startDM = start;
    let sure = parseInt(item.tur_Sure);
    item.sureColor = sure > 11 ? 'purple' : sure > 9 ? 'amber' : sure > 7 ? 'sky' : sure > 5 ? 'teal' : 'amber';
 
    if(item && item.categories){
        item.PUPULARGUIDES = item.categories.includes("PUPULARGUIDES") ? true : false;
     }

       if(item.turs_status_data?.available  || item.turs_status_data.value=="FULL"){
        if (!dates[month] && (item.turs_status_data?.available || item.turs_status_data.value=="FULL")) {
          dates[month] = {}
        }
        if (!dates[month][start]) {
          dates[month][start] = {
            total: itemx.length,
            date: formatDate(item.turs_StartDate, 'dd MMM'),
            id: item.pdb_Id,
            show: false
          }
        } else {
          dates[month][start].total++;
        } 
      }
  })
  /*this.moretours.forEach(item=>{
    let start = item.start.split(" ").slice(0,2).join(" ")
    if(!dates[start]){
      dates[start] = {
        total:1,
        id:item.pdb_Id
      }
    }else{
      dates[start].total++;
    }
  })*/

  toursDateListMonth.value = Object.keys(dates);
  toursDateList.value = (dates);
};

const addSearch = (type, value) => { 
  
  if(import.meta.client && category.value != "5YILDIZUMRE" ){
      if (type=="when") {
        router.push("/tour/umre-turlari?duration=&when="+value)
      }
  }
  labelSearch.value[type] = '';
  if(value==null){
    search.value[type] = []; 
    searchQuestions.value[type] = searchQuestions.value[type].map(item => { 
      item.selected =  false; 
      return item;
    }) 

    if (type=="when") {
        searchQuestions.value['duration'].value = searchQuestions.value['duration'].map(item => { 
          item.selected =  false; 
          return item;
        }) 
        searchQuestions.value.startLeast = todayIso;
    }
  }else{
      if(search.value[type] && search.value[type][0] && search.value[type][0]==value){
        search.value[type] = []; 
        searchQuestions.value[type] = searchQuestions.value[type].map(item => {
            item.selected = false;
            return item;
        })
      }else
      if (type=="when") {
        search.value[type] = []; 
        search.value[type].push(value);
        labelSearch.value.when = '';
        searchQuestions.value[type] = searchQuestions.value[type].map(item => {
          if (item.id == value) {
            item.selected = true;
            labelSearch.value.when = item.label;
          }else{ 
            item.selected =  false;
          }
          return item;
        })

      } else if (search.value[type].find(item => item == value)) {
        search.value[type] = search.value[type].filter(item => item != value);
        searchQuestions.value[type] = searchQuestions.value[type].map(item => {
          if (item.id == value) {
            item.selected = false;
          }
          return item;
        })
      } else {
        search.value[type].push(value)
        // console.log("search.value", search.value, type)
        searchQuestions.value[type] = searchQuestions.value[type].map(item => {
          if (item.id == value) {
            item.selected = true;
          }
          if(item.selected){
            labelSearch.value[type] = ','+item.label;
          }
          return item;
        })
      }
  }
  fetchTours(0,true);
  if (import.meta.client) {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}


// Fetch the first result set through Nuxt data so tour names, dates, prices and
// crawlable detail links are present in the initial server HTML and payload.
const initialTourSearch = {
  ...getLandingSearchDefaults(),
  category: category.value,
  // Ten complete cards provide crawlable discovery without serializing the
  // much larger full catalogue into every SSR response. Remaining programs
  // are loaded by the existing incremental fetch and are all in the sitemap.
  limit: isMobile.value ? 10 : 30,
  page: 0,
  offset: 0
}
const { data: initialTourData } = await useAsyncData(
  `public-tour-list:${locale.value}:${route.path}`,
  () => $fetch('/api/public/tours', {
    query: {
      locale: locale.value,
      category: initialTourSearch.category,
      startLeast: initialTourSearch.startLeast,
      endLeast: initialTourSearch.endLeast,
      when: initialTourSearch.when?.join(','),
      duration: initialTourSearch.duration?.join(','),
      activeHotelId: initialTourSearch.activeHotelId,
      limit: initialTourSearch.limit,
    },
  }),
  { server: true, default: () => [] }
)
if (Array.isArray(initialTourData.value) && initialTourData.value.length > 0) {
  setTours([...initialTourData.value].sort((a, b) => {
    const dateDiff = new Date(a.turs_StartDate) - new Date(b.turs_StartDate)
    return dateDiff !== 0 ? dateDiff : Number(a.tur_Sure) - Number(b.tur_Sure)
  }))
  gettoursDateList()
}

useHead(() => {
  if (!seoLandingContent.value) return {}

  const canonicalUrl = `https://inanctur.com.tr${route.path}`
  const graph = [
    {
      '@type': ['Organization', 'TravelAgency'],
      '@id': 'https://inanctur.com.tr/#organization',
      name: 'İnanç Turizm',
      url: 'https://inanctur.com.tr/',
      description: locale.value === 'en'
        ? 'A travel agency with 21 years of Umrah organization experience, serving approximately 3,500 Umrah pilgrims annually and more than 40,000 pilgrims to date.'
        : '21 yıllık umre organizasyonu deneyimiyle yılda yaklaşık 3.500 ve bugüne kadar 40.000’den fazla umre yolcusuna hizmet veren TÜRSAB 7677 belgeli seyahat acentası.',
      identifier: {
        '@type': 'PropertyValue',
        name: locale.value === 'en' ? 'Travel agency certificate' : 'TÜRSAB Belge No',
        value: '7677'
      }
    },
    {
      '@type': 'CollectionPage',
      '@id': `${canonicalUrl}#webpage`,
      url: canonicalUrl,
      name: seoLandingMeta.value?.title || seoLandingContent.value.h1,
      description: seoLandingMeta.value?.description,
      provider: { '@id': 'https://inanctur.com.tr/#organization' },
      mainEntity: { '@id': `${canonicalUrl}#tour-list` },
      breadcrumb: { '@id': `${canonicalUrl}#breadcrumb` }
    },
    {
      '@type': 'BreadcrumbList',
      '@id': `${canonicalUrl}#breadcrumb`,
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: locale.value === 'en' ? 'Home' : 'Ana Sayfa',
          item: `https://inanctur.com.tr${locale.value === 'en' ? '/en' : ''}`
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: seoLandingContent.value.breadcrumb,
          item: canonicalUrl
        }
      ]
    },
    {
      '@type': 'ItemList',
      '@id': `${canonicalUrl}#tour-list`,
      name: seoLandingContent.value.h1,
      numberOfItems: initialTourData.value?.length || 0,
      itemListElement: (initialTourData.value || []).map((tour, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: tour?.detail?.turd_Name?.[locale.value]
          || tour?.turd_Short?.[locale.value]
          || tour?.turs_title
          || `${tour?.start || tour?.turs_StartDate} ${tour?.tur_Sure || ''} ${locale.value === 'en' ? 'day Umrah package' : 'günlük umre turu'}`,
        url: `https://inanctur.com.tr${locale.value === 'en' ? '/en' : ''}/tourDetail/${tour.pdb_Id}`
      }))
    }
  ]

  if (seoFaqs.value.length) {
    graph.push({
      '@type': 'FAQPage',
      '@id': `${canonicalUrl}#faq`,
      mainEntity: seoFaqs.value.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer
        }
      }))
    })
  }

  return {
    link: [{ key: 'canonical', rel: 'canonical', href: canonicalUrl }],
    script: [{
      key: 'umrah-landing-schema',
      type: 'application/ld+json',
      children: JSON.stringify({
        '@context': 'https://schema.org',
        '@graph': graph
      })
    }]
  }
})

const initialized = ref(false)
restoredFromCache.value = restoreListStateFromCache()

if (!restoredFromCache.value) {
  if(route.query?.when){
    //searchQuestions.value["when"] 
    let when = route.query?.when.split(",");
    when.forEach(element => {
      addSearch("when",element)
    });
  }
  if(route.query?.hotel){ 
    
      let hoteldata = hotels.find(item=> item.id == route.query?.hotel) || {id: route.query?.hotel};
      setHotelFilter(route.query?.hotel,  hoteldata?.name || '');

  } else if (category.value && !initialized.value) {
    if (!hasToursData.value) await fetchTours()
    initialized.value = true
  }
} else {
  initialized.value = true
}


const selectedDate = ref(null)
const scrollTo = (id) => {
const element = document.getElementById('tour' + id);
const yOffset = -110; // 200px yukarıya kaydırma

  if(window){
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({
        top: y,
        behavior: 'smooth'
    });
  }
}; 

const windowTop = ref(true);
const detailSearchView = ref(false);
const detailReservationView = ref(false);
const detailMenuView = ref(false);
const scrollToInside =  (id) => {

  if(id){
    document.getElementById(id).scrollIntoView({ 
      behavior: 'smooth' 
    });
  }else if(window){
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

};

 
const nedenInancTurModalRef = ref(false);
const commentsModalRef = ref(false);
const loadNedenInancTurModal = ref(false);
const loadCommentsModal = ref(false);

const showLazyModal = (modalRef, shouldLoad, visible) => {
  shouldLoad.value = true
  const setVisibilityWhenReady = (attempts = 20) => {
    if (modalRef.value?.show) {
      modalRef.value.show(visible)
    } else if (attempts > 0) {
      window.setTimeout(() => setVisibilityWhenReady(attempts - 1), 50)
    }
  }
  nextTick(() => setVisibilityWhenReady())
}

const openNedenInancTur = () => {
  showLazyModal(nedenInancTurModalRef, loadNedenInancTurModal, true)
  closeMenu()
}
const openComments= () =>{
  showLazyModal(commentsModalRef, loadCommentsModal, true)
}
const closeComments = () =>{
  commentsModalRef.value?.show(false);
}

 
const closeMenu = ()=>{
  detailSearchView.value = false;
  detailReservationView.value = false;
  detailMenuView.value = false;
  windowTop.value = false;
}

const resetSearchFilters = () => {
  search.value = getLandingSearchDefaults();
  labelSearch.value = {
    when: t('When'),
    duration: t('Duration'),
  };
  searchQuestions.value.when = searchQuestions.value.when.map(item => {
    item.selected = false;
    return item;
  });
  searchQuestions.value.duration = searchQuestions.value.duration.map(item => {
    item.selected = false;
    return item;
  });
  search.value.activeHotelId = 'all';
  activeHotelFilterLabel.value = '';
  reservation.value.rooms = [
    {
      adult: 2,
      child: 0,
      baby: 0,
      room_type: null,
      options: {},
    },
  ];
  reservation.value.childrenAges = [];
  sidebarChildBedChoices.value = [];
  sidebarChildBedPanelOpen.value = [];
  normalizeChildrenAges(reservation.value);
  // Tüm veriyi alıp (limit yükselterek) client-side filtre uyg
  fetchTours(0, true);
  window?.scrollTo({
      top: 0,
      behavior: 'smooth'
  })
} 

const runTopSearch = () => {
  fetchTours(0, true);
  const totals = getReservationTotals(reservation.value);
  const query = {
    ...route.query,
    adults: String(totals.adults),
    rooms: String(totals.rooms),
  };
  if (reservation.value.childrenAges && reservation.value.childrenAges.length > 0) {
    query.children = reservation.value.childrenAges.join(',');
  } else {
    delete query.children;
  }
  router.replace({ path: route.path, query });
  scrollToInside('tour-list-top');
}

const searchWhenScrolled = ()=>{
  isScrolled.value = true;
  return fetchTours(1)
}

const waitForPrimaryLoad = () => {
  if (!loading.value) return Promise.resolve()
  return new Promise((resolve) => {
    const stop = watch(loading, (value) => {
      if (!value) {
        stop()
        resolve()
      }
    })
  })
}

const scrollToTourCard = (tourId) => {
  if (!process.client) return false
  const normalizedId = normalizeTourId(tourId)
  if (!normalizedId) return false

  const element = document.getElementById(`tour${normalizedId}`)
  if (!element) return false

  const yOffset = -110
  const y = element.getBoundingClientRect().top + (window.pageYOffset || 0) + yOffset
  window.scrollTo({ top: Math.max(0, y), behavior: 'auto' })
  return true
}

const restoreScrollPositionFromCache = async () => {
  if (!process.client || !restoredFromCache.value) return

  await waitForPrimaryLoad()
  await nextTick()

  let focused = false
  const focusTourId = normalizeTourId(restoredFocusTourId.value)

  if (focusTourId) {
    for (let attempt = 0; attempt < 12; attempt += 1) {
      if (scrollToTourCard(focusTourId)) {
        focused = true
        break
      }

      if (attempt === 2 && !isScrolled.value) {
        await searchWhenScrolled()
      }

      await new Promise((resolve) => setTimeout(resolve, 110))
      await nextTick()
    }
  }

  if (!focused && restoredScrollY.value > 0) {
    window.scrollTo({ top: restoredScrollY.value, behavior: 'auto' })
  }
}

const forceScrollTopWhenNoRestore = () => {
  if (!process.client || restoredFromCache.value) return
  requestAnimationFrame(() => {
    window.scrollTo({ top: 0, behavior: 'auto' })
    lastScrollTop.value = 0
  })
}

const ensureRestoredScrollData = async () => {
  if (!process.client) return
  if (restoredFromCache.value) return

  const restoredY = window.scrollY || window.pageYOffset || 0
  if (restoredY < 140 || isScrolled.value) return

  await waitForPrimaryLoad()

  if (!isScrolled.value) {
    await searchWhenScrolled()
  }
}
const updateActiveDate = () => {
  if (!toursDateList.value || !toursDateListMonth.value?.length) return
  const offset = 200
  let closestId = null
  let closestDist = Infinity
  let closestMonth = null

  for (const month of toursDateListMonth.value) {
    const group = toursDateList.value[month]
    if (!group) continue
    for (const key of Object.keys(group)) {
      const entry = group[key]
      if (!entry?.id) continue
      const el = document.getElementById('tour' + entry.id)
      if (!el) continue
      const top = el.getBoundingClientRect().top
      if (top <= offset + 300) {
        const dist = Math.abs(top - offset)
        if (dist < closestDist) {
          closestDist = dist
          closestId = entry.id
          closestMonth = month
        }
      }
    }
  }

  if (closestId !== null && closestId !== activeDateId.value) {
    activeDateId.value = closestId
    if (closestMonth && toursDateList.value[closestMonth]) {
      openMonth(closestMonth)
    }
  }
}

const openMonth = (monthToOpen) => {
  for (const month of toursDateListMonth.value) {
    if (toursDateList.value[month]) {
      toursDateList.value[month].show = month === monthToOpen
    }
  }
}

const toggleMonth = (month) => {
  const isOpen = toursDateList.value[month]?.show
  for (const m of toursDateListMonth.value) {
    if (toursDateList.value[m]) {
      toursDateList.value[m].show = false
    }
  }
  if (!isOpen) {
    toursDateList.value[month].show = true
  }
}

const onScroll =  (e) => {
  const se = Math.max(
    0,
    e?.target?.scrollingElement?.scrollTop ??
      window?.pageYOffset ??
      document?.documentElement?.scrollTop ??
      0
  )

  const delta = se - lastScrollTop.value
  if (se < 80) {
    hideSidebarInfoCards.value = false
  } else if (delta > 8) {
    hideSidebarInfoCards.value = true
  } else if (delta < -8) {
    hideSidebarInfoCards.value = false
  }
  lastScrollTop.value = se
  updateSidebarSticky(se)

  updateActiveDate()

  if(se > 150){
    windowTop.value = false;     
  }else{
    windowTop.value = true;     
  }


  if(se > 30 &&  !isScrolled.value){
      searchWhenScrolled()
  } 
}
 
const formMessages = [
  {
    tr: `${currentSeoYear} umre programları hakkında bilgi almak istiyorum.`,
    en: `I would like to get information about the ${currentSeoYear} Umrah package programs.`
  }
]
const openNewForm = (text,subject)=>{
  // contactForm.value.data = ;
  // contactForm.value.show=true;  
 
  let message = typeof text == "object" ?  text[locale.value] ?   text[locale.value] : text["tr"] : typeof text == "string" ? text : '';
  openNoteForm(null,{message, not_konu:subject})
}

onMounted(() => { 
  mountedFinished.value = true; 
  lastScrollTop.value = Math.max(0, window?.pageYOffset || document?.documentElement?.scrollTop || 0)
  window.addEventListener("scroll", onScroll, true);

  if (route.query?.compare === '1') {
    openCompare()
  }

  aliveProbe.value.mountCount++
  console.log('[tour/[link]] mounted', aliveProbe.value)

  if (restoredFromCache.value) {
    requestAnimationFrame(() => {
      saveListStateToCache()
    })
    restoreScrollPositionFromCache()
  } else {
    forceScrollTopWhenNoRestore()
  }

  ensureRestoredScrollData()

}) 
onActivated(() => {
  lastScrollTop.value = Math.max(0, window?.pageYOffset || document?.documentElement?.scrollTop || 0)
  window.addEventListener('scroll', onScroll, true);
  console.log('[tour/[link]] deactivated');

  if (!hasToursData.value) {
    restoredFromCache.value = restoreListStateFromCache()
  }

  if (restoredFromCache.value) {
    restoreScrollPositionFromCache()
  } else {
    forceScrollTopWhenNoRestore()
  }
  ensureRestoredScrollData()
}) 
onDeactivated(() => {
  saveListStateToCache()
  window.removeEventListener('scroll', onScroll, true);
  console.log('[tour/[link]] unmounted')
}); 

onBeforeRouteLeave((to, from, next) => {
  if (to?.path?.startsWith('/tourDetail/')) {
    const focusTourId = extractTourIdFromPath(to.path)
    saveListStateToCache({ focusTourId })
  }
  next()
})
</script> 
<style scoped>
@keyframes umrah-hero-drift {
  0%, 100% { transform: translate3d(0, 0, 0); }
  50% { transform: translate3d(-5px, -3px, 0); }
}

@media (prefers-reduced-motion: no-preference) {
  .umrah-hero-art {
    animation: umrah-hero-drift 9s ease-in-out infinite;
  }
}

.tour-campaign-card-copy :deep(p) {
  display: inline;
  margin: 0;
}

.tour-campaign-card-copy :deep(strong),
.tour-campaign-card-copy :deep(b) {
  color: #c2410c;
  font-weight: 800;
}

.people-overlay-enter-active,
.people-overlay-leave-active {
  transition: opacity 0.25s ease;
}
.people-overlay-enter-active .people-overlay-panel,
.people-overlay-leave-active .people-overlay-panel {
  transition: transform 0.25s ease;
}
.people-overlay-enter-from,
.people-overlay-leave-to {
  opacity: 0;
}
.people-overlay-enter-from .people-overlay-panel,
.people-overlay-leave-to .people-overlay-panel {
  transform: translateY(40px);
}
@media (min-width: 768px) {
  .people-overlay-enter-from .people-overlay-panel,
  .people-overlay-leave-to .people-overlay-panel {
    transform: scale(0.96) translateY(10px);
  }
}
</style>
